/* eslint-disable max-lines -- Generated GraphQL types */

export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  GraphqlOrganizationSize: { input: any; output: any };
  GraphqlOrganizationType: { input: any; output: any };
  /** A scalar that can represent any JSON value. */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown> };
}

export interface GqlQueryRoot {
  /** Get current authenticated account */
  account: GqlAccount;
  /** All active (Running) tasks for current org, cursor-paginated. */
  activeBackgroundTasks: GqlActiveBackgroundTasksResult;
  adminAiChatMessages: GqlAiChatMessageList;
  adminAiChatSessions: GqlAdminAiChatSessionList;
  adminAiSearchCandidates: GqlAdminAiSearchCandidateList;
  adminAiSearchHistories: GqlAdminAiSearchHistoryList;
  adminAiSearchStages: Array<GqlAdminAiSearchStageOutput>;
  adminCampaignGet?: Maybe<GqlCampaignOutput>;
  adminCampaignList: GqlCampaignListOutput;
  adminCreatorNetworkIndustries: GqlAdminCreatorNetworkIndustryList;
  adminCreatorNetworkIndustry?: Maybe<GqlAdminIndustryObject>;
  adminCreatorNetworkInfluencerList?: Maybe<GqlAdminInfluencerListDetail>;
  adminCreatorNetworkInfluencerLists: GqlAdminCreatorNetworkInfluencerListList;
  adminCreatorNetworkLocation?: Maybe<GqlAdminLocationObject>;
  adminCreatorNetworkLocations: GqlAdminCreatorNetworkLocationList;
  adminEventTimeline: GqlAdminEventTimelineList;
  /**
   * External-API usage + estimated cost aggregated per `(org, vendor)` over
   * `[from, to)` (#582-D). Reads the `auth_api_usage` telemetry counter —
   * READ-ONLY: no charge, no enforcement. Includes the explicit unattributed
   * bucket (`organizationId = null`). `from`/`to` are RFC3339 timestamps;
   * the range is matched against each row's UTC-midnight day bucket.
   */
  adminExternalApiUsage: Array<GqlAdminExternalApiUsageRow>;
  adminGaPageAnalytics: GqlAdminGaPageAnalyticsObject;
  adminGetAccount: GqlAdminAccountObject;
  adminGetOrganization: GqlOrganizationWithProfileObject;
  adminGetOrganizationMember: GqlOrganizationMemberObject;
  adminGetStats: GqlAdminStatsObject;
  adminListAccountMemberships: Array<GqlAdminAccountMembershipObject>;
  adminListAccounts: GqlAdminAccountList;
  /**
   * List dead-lettered auth_outbox envelopes for ops triage. See issue #305.
   * Returns up to `limit` (capped at 200) newest-first by `dead_lettered_at`.
   * Use the returned `id` with `adminRedriveAuthDlqEnvelope` to retry.
   */
  adminListDeadLetteredAuthEnvelopes: Array<GqlDeadLetteredAuthEnvelopeOutput>;
  adminListDemoRequests: GqlAdminDemoRequestList;
  /**
   * Phase 1c (#286). List active email suppressions, newest first. Used
   * by the operator weekly review (see email-delivery.md §Suppression
   * operator cadence).
   *
   * `organizationId`: empty/missing = all scopes; "global" sentinel =
   * only global rows; ObjectId hex = only that org's rows.
   * `limit`: capped by infra at 200.
   */
  adminListEmailSuppressions: Array<GqlEmailSuppressionObject>;
  adminListOrganizationMembers: GqlOrganizationMemberList;
  adminListOrganizations: GqlOrganizationList;
  adminListOutboxEvents: GqlAdminOutboxEntryList;
  /**
   * MCP OAuth session audit timeline for one `(account, organization)`
   * aggregate (#372). Superadmin-only incident-response read over the
   * `mcp_oauth_session` event log (#347): "why did my MCP session stop
   * working", "who issued tokens for org X", "which cascade-revokes fired".
   *
   * Read-only. Ascending by `sequence`; pass the last `sequence` as
   * `afterSequence` for the next page. `limit` defaults to 50, clamped to
   * `[1, 100]`. `payload` is the opaque serialized event body as a JSON
   * scalar. The org is embedded in the aggregate id, so a crafted
   * `accountId`/`organizationId` never crosses into another aggregate.
   */
  adminMcpOAuthSessionTimeline: Array<GqlAdminMcpOAuthTimelineEvent>;
  adminViewer: GqlAdminAccountObject;
  /**
   * One program's enrolment roster. A program outside the caller's org
   * returns `NOT_FOUND` (existence never disclosed). Requires
   * `SettingsView`.
   */
  affiliateProgramEnrollments: Array<GqlProgramEnrollmentOutput>;
  /**
   * The caller org's affiliate programs, each with enrolled-creator
   * count and lifetime commission. Org-scoped by the session
   * organization; requires `SettingsView`.
   */
  affiliatePrograms: Array<GqlAffiliateProgramOutput>;
  /** Get messages for a chat session */
  aiChatMessages: GqlAiChatMessageList;
  /** Get org-scoped metadata for one chat session. */
  aiChatSessionMetadata: GqlChatSessionMetadataOutput;
  /** List chat sessions for the current organization */
  aiChatSessions: GqlAiChatSessionList;
  /**
   * Retrieve the thinking log for the active turn of a session (page-reload recovery).
   * Returns all persisted thinking events (tokens, tool_start, tool_end, entity_preview).
   * Returns empty list if Redis is unavailable or the log has expired/been cleaned up.
   */
  aiChatThinkingLog: Array<GqlThinkingStreamOutput>;
  /** List accepted candidates for a search history */
  aiSearchCandidates: GqlAiSearchCandidateListOutput;
  /** Get a search history by ID */
  aiSearchHistory: GqlAiSearchHistoryOutput;
  /** List search histories for the current organization */
  aiSearchHistoryList: GqlAiSearchHistoryListOutput;
  /** Get stages for a search history */
  aiSearchStages: Array<GqlAiSearchStageOutput>;
  authById: GqlAuth;
  /** Get all brand collaborations for a creator (previous sponsors). */
  authCollaborations: Array<GqlAuthCollaborationOutput>;
  authCrossLinks: Array<GqlAuthCrossLinkOutput>;
  authDeepLookup?: Maybe<GqlDeepLookupOutput>;
  authFeed: GqlPostListOutput;
  authGroup: GqlAuthGroupOutput;
  authGroupList: GqlAuthGroupList;
  authListByGroupId: GqlAuthListOutput;
  authNote: GqlAuthNoteOutput;
  authNoteItems: GqlAuthNoteItemsConnection;
  authSearch: GqlAuthListOutput;
  /** Current status of a specific async operation. Null if never started. */
  backgroundTask?: Maybe<GqlBackgroundTaskOutput>;
  /** Batch status for multiple entities (for list views). */
  backgroundTasks: Array<GqlBackgroundTaskOutput>;
  /**
   * Tray feed (#263): running + recently terminal tasks for the
   * current org, sorted `(updatedAt desc, _id desc)`. `total` is
   * intentionally absent — the tray shows item counts client-side.
   */
  backgroundTasksTray: GqlBackgroundTasksTrayResult;
  /**
   * Event history of a specific run. `runId` comes from `backgroundTask.runId`.
   * Always ascending order. `afterSequence` for forward pagination.
   * Org embedded in aggregate_id — no cross-tenant leak even with crafted runId.
   */
  backgroundTaskTimeline: Array<GqlBackgroundTaskTimelineEvent>;
  /**
   * Get brand match score for an influencer. Returns null if brand context not enriched.
   * Triggers computation if not cached.
   */
  brandMatchScore?: Maybe<GqlBrandMatchResultOutput>;
  campaign: GqlCampaignOutput;
  /**
   * Per-campaign chronological activity timeline (#259).
   * Brand viewers see all campaign events; creator viewers are scoped
   * by their own auth IDs in the campaign plus campaign-level events.
   */
  campaignActivityTimeline: GqlCampaignActivityTimelineOutput;
  /**
   * #712: "all influencers who posted" for a campaign — the distinct set of
   * authors with any `CampaignPostRecord` (member ∪ discovered), each flagged
   * `inCampaign`. This is the "all influencers" vs "campaign influencers"
   * (`campaign.influencerAuthIds`) split. Brand-only.
   */
  campaignAllInfluencers: GqlCampaignAllInfluencersOutput;
  /**
   * Query analytics for a campaign over a date range.
   * If auth_id is provided, returns analytics for that specific influencer.
   * Otherwise, returns aggregated analytics across all influencers.
   */
  campaignAnalytics: GqlCampaignAnalyticsOutput;
  /**
   * Return daily snapshots (cumulative values) for chart rendering.
   * When aggregated=true (default), returns one aggregate snapshot per date.
   * When aggregated=false, returns all per-auth snapshots.
   */
  campaignAnalyticsHistory: GqlCampaignAnalyticsHistoryList;
  campaignAuth: GqlAuthListOutput;
  /**
   * graphql:public-resolver (#564) — capability-gated by the per-task
   * `secret` (magic-link credential; use-case resolves via `find_by_secret`),
   * not an org session. The invited creator has no organization context to
   * `require_*`. Intentionally public — audited in #564, NOT an omitted-guard bug.
   */
  campaignAuthTaskBySecret: GqlCampaignAuthTaskOutput;
  /**
   * Generate an invite message for a campaign auth task.
   * Returns a formatted text message that can be sent to an influencer.
   */
  campaignAuthTaskInviteMessageGenerate: Scalars['String']['output'];
  /**
   * Public short-link resolver backing the FE redirect page (`/l/{code}`).
   *
   * Mirrors `redirect_short_url` (apps/server routes) but returns the link
   * payload to the FE instead of issuing a 302, so the React redirect page
   * can read `longUrl`/`campaignId`/`authId` and navigate itself (#499).
   *
   * graphql:public-resolver (#564) — intentionally UNAUTHENTICATED: the FE
   * may call this before the visitor has a session (short links are shared
   * publicly). Like the HTTP redirect,
   * it deliberately calls no `require_*` auth guard. Missing, soft-deleted,
   * and disabled links resolve to `null` (never an error) so the FE can show
   * a graceful "link not found" state.
   *
   * Side effect: increments the click counter (probe-then-increment, same as
   * the HTTP redirect) so analytics stay consistent across both entry paths.
   */
  campaignAuthTaskLinkGetByShortUrl?: Maybe<GqlCampaignAuthTaskLinkOutput>;
  campaignAuthTaskLinkList: GqlCampaignAuthTaskLinkListOutput;
  campaignAuthTaskList: GqlCampaignAuthTaskListOutput;
  campaignExportDownloadUrl: Scalars['String']['output'];
  campaignExports: Array<GqlCampaignExportOutput>;
  campaignExportSlices: Array<GqlCampaignExportSliceInfo>;
  campaignList: GqlCampaignListOutput;
  campaignPost: GqlPostListOutput;
  campaignRecommendationList: GqlCampaignRecommendationListOutput;
  /**
   * #712: poll the on-demand sweep job status for a campaign (the FE polls
   * this after firing `runCampaignSweep`).
   *
   * #744: this is also the readiness probe the FE renders the button from,
   * so it reports the feature gates up front — `DISABLED` when the global
   * `SWEEP_ENABLED` flag is off, `UNAVAILABLE` when no HikerAPI key is
   * configured. Either means every `runCampaignSweep` would be refused, so
   * the control should be disabled with the returned `message` as the reason.
   */
  campaignSweepStatus: GqlSweepJobStatus;
  campaignTaskTemplate?: Maybe<GqlCampaignTaskTemplateOutput>;
  /**
   * #9105 — check whether a user-supplied custom short code is valid and
   * free, so the AddLink modal can hard-block before optimistically adding
   * a link. Authoritative reject-on-collision still lives in the create
   * path; this is advisory + drives inline feedback. Authenticated to keep
   * the global `/l/{code}` namespace from being anonymously enumerated.
   */
  campaignTrackingLinkCodeStatus: GqlTrackingLinkCodeStatusOutput;
  /**
   * The traffic-lift report for a campaign (live or historical). Returns
   * `null` if no report has been generated yet.
   */
  campaignTrafficLiftReport?: Maybe<GqlCampaignTrafficLiftReportOutput>;
  /** Check if email is already registered */
  checkContactInfo: Scalars['Boolean']['output'];
  /**
   * #736/#743 — read a creator's profile and its indexing state.
   *
   * A **pure read** since #743: no CAS claim, no background indexing, no
   * 60-second block. It is therefore safe to retry, cache and batch, which is
   * what callers assume of a query. Starting an index is the explicit
   * `indexCreatorProfile` mutation.
   *
   * Returns `NOT_FOUND` when the creator has never been seen — call the
   * mutation to bring them in.
   *
   * Gated on `auth:view` (every role including Viewer has it): reading costs
   * nothing, so it is deliberately a weaker gate than the mutation's.
   */
  creatorProfile: GqlCreatorProfileOutput;
  /**
   * Phase A4 (wiki#14 §4.2): the org's connected Google account, if any.
   * `None` = org has not completed OAuth or backfill hasn't created the
   * row. Spec defers the OAuth-flow rewrite to Phase B; this is a
   * read-only surface for the new property-list UI to know whether to
   * show "Connect Google account" vs "Add property".
   */
  gaAccount?: Maybe<GqlGaAccountOutput>;
  /** List GA accounts for a connection */
  gaAccountList: Array<GqlGaConnectAvailableOption>;
  gaConnectionList: GqlGaConnectionList;
  /** List GA properties for an account */
  gaPropertiesList: Array<GqlGaConnectAvailableOption>;
  /** List GA web streams for a property (used by the measurement ID picker) */
  gaWebStreamsList: Array<GqlGaWebStreamOption>;
  getLinkPreview?: Maybe<GqlLinkPreviewOutput>;
  getOrganization: GqlOrganizationWithProfileObject;
  linkbioPageById?: Maybe<GqlLinkbioPage>;
  linkbioPageByUsername?: Maybe<GqlLinkbioPage>;
  linkbioPageList: GqlLinkbioPageList;
  listOrganizations: GqlOrganizationList;
  /**
   * List comments for a post. No per-post ownership check: comments are public data
   * scraped from social platforms. Only requires authenticated organization context.
   */
  listPostComments: GqlPostCommentListOutput;
  /**
   * Daily LLM-usage breakdown for the current organization over an inclusive
   * `startDate..=endDate` (`YYYY-MM-DD`, UTC), grouped by feature or model.
   * Backs the stacked-area usage chart. Range capped at 92 days.
   */
  llmUsageDaily: GqlLlmUsageDailyOutput;
  /**
   * Get LLM token usage summary for the current organization.
   * Period format: "YYYY-MM" (e.g. "2026-02").
   */
  llmUsageSummary: GqlLlmUsageSummaryOutput;
  notifications: GqlNotificationListOutput;
  /**
   * List campaign auth tasks for a creator organization.
   * Returns tasks from campaigns the organization has accepted invitations to.
   * Only available for creator organizations (not brands).
   */
  organizationCampaignAuthTaskList: GqlCampaignAuthTaskListOutput;
  /**
   * List organization campaigns for the current organization.
   * Returns campaigns the organization has accepted invitations to.
   */
  organizationCampaigns: Array<GqlOrganizationCampaignOutput>;
  /**
   * Find organization campaigns by auth task secret.
   * Public endpoint - no authentication required.
   * graphql:public-resolver (#564) — capability-gated by `auth_task_secret`,
   * not an org session. The unguessable per-invite secret IS the credential
   * (use-case looks the task up via `find_by_secret`); an invited creator
   * viewing their campaigns has no organization context to `require_*`.
   * Intentionally public — audited in #564, NOT an omitted-guard bug.
   */
  organizationCampaignsGetBySecret: Array<GqlOrganizationCampaignOutput>;
  /**
   * wiki#17 — org-scoped commerce rollup across ALL of the caller's
   * campaigns. Powers both the home "Revenue & impact" widget and the
   * cross-campaign Revenue page from ONE query (no N+1 per-campaign
   * calls — the use case reads the org's attributed orders for the
   * period in a single scan).
   *
   * Gating MIRRORS the per-campaign `Campaign.commerceSummary`:
   * - Creator orgs → `null` (no brand-internal revenue surface).
   * - Brand callers lacking `CampaignPaymentsView` → `null` (graceful
   * degradation, not error — the FE hides the widget).
   * - The query is inherently scoped to the caller's SESSION org, so
   * there is no cross-org leak vector (we only ever read the
   * caller's own org's campaigns).
   */
  organizationCommerceSummary?: Maybe<GqlOrganizationCommerceSummaryOutput>;
  /**
   * Read the credit balance for an organization. Returns a zero-valued
   * balance when the org has never been charged or topped up — matches
   * the lazy-create semantics of `try_charge` so the admin UI shows a
   * consistent shape.
   */
  organizationCreditBalance: GqlOrganizationCreditBalanceObject;
  /**
   * Paginated admin top-up history, newest first. Cursor format is opaque
   * (encoded `(created_at, _id)` tuple).
   */
  organizationCreditHistory: GqlOrganizationCreditHistoryPageObject;
  /**
   * Custom sender domain (#529): read the org's email config (domain, status,
   * DNS records). `null` when the org has no custom domain configured.
   * Gated on `SettingsView` — the same scope as `integrations`.
   */
  organizationEmailConfig?: Maybe<GqlOrganizationEmailConfigOutput>;
  organizationMemberList: GqlOrganizationMemberList;
  organizationMemberPermission: Array<GqlOrganizationPermissionItemObject>;
  organizationPaymentDetailsList: GqlOrganizationPaymentDetailsListOutput;
  organizationPaymentDetailsViewSingleByProvider: GqlOrganizationPaymentDetailsOutput;
  organizationPayoutsFromList: GqlCampaignPayoutListOutput;
  organizationPayoutsToList: GqlCampaignPayoutListOutput;
  organizationRoleList: GqlOrganizationRoleList;
  organizationShippingDetailsList: GqlOrganizationShippingDetailsListOutput;
  organizationShippingDetailsViewSingle: GqlOrganizationShippingDetailsOutput;
  /** Direct persona lookup by ID. */
  persona?: Maybe<GqlPersonaOutput>;
  /** Get persona for a specific auth (most common frontend pattern). */
  personaByAuthId?: Maybe<GqlPersonaOutput>;
  /**
   * The persona-membership conflict queue — edges in a given status, newest
   * first. Defaults to `Review` (the queue a human/AI works through). Global,
   * cross-org surface: superadmin only.
   */
  personaConflicts: Array<GqlPersonaConflictOutput>;
  postById: GqlPostOutput;
  /**
   * Track C.5 — per-promo-code revenue / ROI breakdown. Org-scoped:
   * a code outside the caller's org returns `NOT_FOUND` (no
   * existence disclosure). Brand-internal data — requires both
   * `CampaignView` and `CampaignPaymentsView`.
   */
  promoCodePerformance: GqlPromoCodePerformanceOutput;
  /**
   * Public, unauthenticated snapshot of the Active creator-network directory
   * (taxonomy + curated influencers). Served from a short-TTL server-side
   * cache so ISR revalidations + crawler bursts collapse to one DB gather.
   */
  publicDirectory: GqlPublicDirectory;
  /** Validate password reset token and return token info */
  resetPasswordTokenRequest: GqlAccountTokenOutput;
  /**
   * Live picker for the Mirror (link) flow — paginates the shop's
   * code-discount nodes. Up to 100 are returned in one page; Phase 1
   * callers do not paginate (the typical pilot brand has a handful of
   * active codes). Requires `SettingsView` on the caller's org; the
   * `storeId` is org-scoped (a cross-org store is reported as
   * "store not found", no existence disclosure).
   */
  shopifyDiscounts: Array<GqlShopifyDiscountSummaryOutput>;
  /**
   * Read the Marble-side mirror of the store's Shopify product catalog.
   * `ShopifyPollWorker` (Track A.9 / B.5a) keeps this fresh; this query
   * is a pure mirror read — never hits live Shopify (the live-fetch
   * model is the discount picker, which has to be fresh-at-link-time;
   * the product catalog tolerates poll-cycle lag).
   *
   * **Phase 1: unpaginated**, capped at [`SHOPIFY_PRODUCTS_PAGE_CAP`]
   * rows ordered by `updated_at_shopify` desc. A brand with a larger
   * catalog will only see its most-recently-changed products; a real
   * cursor surface lands when a brand asks (the typical pilot brand
   * has < 100 SKUs).
   *
   * Org-scoped: a cross-org store id is reported as "store not found"
   * without disclosing existence. Disconnected stores return
   * `SHOPIFY_STORE_NOT_CONNECTED` rather than rows from a stale mirror.
   * Requires `SettingsView` — symmetric with `shopifyDiscounts`.
   */
  shopifyProducts: Array<GqlShopifyProductOutput>;
  /**
   * Live variant picker for the gifting create flow (Track E). The
   * Track B `ShopifyProduct` mirror deliberately omits variants, so
   * the gift create form resolves a product's `variantId` (+ label +
   * price) here at pick time — a live fetch against Shopify, like
   * `shopifyDiscounts`. Up to 100 variants in one page (Shopify caps
   * a product at 100). Requires `SettingsView`; `storeId` is
   * org-scoped (a cross-org store → "store not found", no existence
   * disclosure). A `productId` Shopify no longer knows (stale mirror)
   * surfaces as `SHOPIFY_PRODUCT_NOT_FOUND` — the FE refetches
   * `shopifyProducts`.
   */
  shopifyProductVariants: Array<GqlShopifyProductVariantOutput>;
  unreadNotificationsCount: Scalars['Int']['output'];
  /** Fetch one UtmTemplate by id; returns null if not in the caller's org. */
  utmTemplate?: Maybe<GqlUtmTemplateOutput>;
  /** List every UtmTemplate in the caller's organization. */
  utmTemplates: Array<GqlUtmTemplateOutput>;
}

export interface GqlQueryRootActiveBackgroundTasksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}

export interface GqlQueryRootAdminAiChatMessagesArgs {
  params: GqlListViewParamsInput;
  sessionId: Scalars['String']['input'];
}

export interface GqlQueryRootAdminAiChatSessionsArgs {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminAiSearchCandidatesArgs {
  decisionFilter?: InputMaybe<Scalars['String']['input']>;
  historyId: Scalars['String']['input'];
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminAiSearchHistoriesArgs {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminAiSearchStagesArgs {
  historyId: Scalars['String']['input'];
}

export interface GqlQueryRootAdminCampaignGetArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlQueryRootAdminCampaignListArgs {
  filter?: InputMaybe<GqlAdminCampaignFilterInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminCreatorNetworkIndustriesArgs {
  filter?: InputMaybe<GqlAdminIndustryFilterInput>;
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminCreatorNetworkIndustryArgs {
  id: Scalars['String']['input'];
}

export interface GqlQueryRootAdminCreatorNetworkInfluencerListArgs {
  id: Scalars['String']['input'];
}

export interface GqlQueryRootAdminCreatorNetworkInfluencerListsArgs {
  filter?: InputMaybe<GqlAdminInfluencerListFilterInput>;
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminCreatorNetworkLocationArgs {
  id: Scalars['String']['input'];
}

export interface GqlQueryRootAdminCreatorNetworkLocationsArgs {
  filter?: InputMaybe<GqlAdminLocationFilterInput>;
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminEventTimelineArgs {
  filter?: InputMaybe<GqlAdminEventTimelineFilterInput>;
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminExternalApiUsageArgs {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}

export interface GqlQueryRootAdminGaPageAnalyticsArgs {
  filter: GqlAdminGaPageAnalyticsFilter;
}

export interface GqlQueryRootAdminGetAccountArgs {
  accountId: Scalars['String']['input'];
}

export interface GqlQueryRootAdminGetOrganizationArgs {
  organizationId: Scalars['String']['input'];
}

export interface GqlQueryRootAdminGetOrganizationMemberArgs {
  memberId: Scalars['String']['input'];
}

export interface GqlQueryRootAdminGetStatsArgs {
  daysBack?: Scalars['Int']['input'];
}

export interface GqlQueryRootAdminListAccountMembershipsArgs {
  accountId: Scalars['String']['input'];
}

export interface GqlQueryRootAdminListAccountsArgs {
  filter?: InputMaybe<GqlAdminAccountFilterInput>;
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminListDeadLetteredAuthEnvelopesArgs {
  limit?: Scalars['Int']['input'];
}

export interface GqlQueryRootAdminListDemoRequestsArgs {
  filter?: InputMaybe<GqlAdminDemoRequestFilterInput>;
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminListEmailSuppressionsArgs {
  limit?: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GqlQueryRootAdminListOrganizationMembersArgs {
  organizationId: Scalars['String']['input'];
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminListOrganizationsArgs {
  filter?: InputMaybe<GqlAdminOrganizationFilterInput>;
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminListOutboxEventsArgs {
  filter?: InputMaybe<GqlAdminOutboxFilterInput>;
  params: GqlListViewParamsInput;
}

export interface GqlQueryRootAdminMcpOAuthSessionTimelineArgs {
  accountId: Scalars['ID']['input'];
  afterSequence?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
}

export interface GqlQueryRootAffiliateProgramEnrollmentsArgs {
  programId: Scalars['ID']['input'];
}

export interface GqlQueryRootAiChatMessagesArgs {
  input: GqlListMessagesInput;
}

export interface GqlQueryRootAiChatSessionMetadataArgs {
  sessionId: Scalars['String']['input'];
}

export interface GqlQueryRootAiChatSessionsArgs {
  input?: InputMaybe<GqlListSessionsInput>;
}

export interface GqlQueryRootAiChatThinkingLogArgs {
  sessionId: Scalars['String']['input'];
}

export interface GqlQueryRootAiSearchCandidatesArgs {
  input: GqlListAiSearchCandidatesInput;
}

export interface GqlQueryRootAiSearchHistoryArgs {
  input: GqlViewAiSearchInput;
}

export interface GqlQueryRootAiSearchHistoryListArgs {
  params?: InputMaybe<GqlListViewParamsInput>;
}

export interface GqlQueryRootAiSearchStagesArgs {
  input: GqlViewAiSearchInput;
}

export interface GqlQueryRootAuthByIdArgs {
  input: GqlAuthByIdInput;
}

export interface GqlQueryRootAuthCollaborationsArgs {
  authId: Scalars['String']['input'];
}

export interface GqlQueryRootAuthCrossLinksArgs {
  authId: Scalars['String']['input'];
}

export interface GqlQueryRootAuthDeepLookupArgs {
  input: GqlDeepLookupQueryInput;
}

export interface GqlQueryRootAuthFeedArgs {
  input: GqlAuthFeedInput;
}

export interface GqlQueryRootAuthGroupArgs {
  input: GqlAuthGroupInput;
}

export interface GqlQueryRootAuthGroupListArgs {
  input: GqlAuthGroupListInput;
}

export interface GqlQueryRootAuthListByGroupIdArgs {
  input: GqlAuthListByGroupIdInput;
}

export interface GqlQueryRootAuthNoteArgs {
  input: GqlAuthNoteViewInput;
}

export interface GqlQueryRootAuthNoteItemsArgs {
  input: GqlAuthNoteItemsInput;
}

export interface GqlQueryRootAuthSearchArgs {
  input: GqlAuthSearchInput;
}

export interface GqlQueryRootBackgroundTaskArgs {
  targetEntityId: Scalars['String']['input'];
  taskType: GqlBackgroundTaskTypeEnum;
}

export interface GqlQueryRootBackgroundTasksArgs {
  targetEntityIds: Array<Scalars['String']['input']>;
  taskType: GqlBackgroundTaskTypeEnum;
}

export interface GqlQueryRootBackgroundTasksTrayArgs {
  input: GqlBackgroundTasksTrayInput;
}

export interface GqlQueryRootBackgroundTaskTimelineArgs {
  afterSequence?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  runId: Scalars['String']['input'];
  targetEntityId: Scalars['String']['input'];
  taskType: GqlBackgroundTaskTypeEnum;
}

export interface GqlQueryRootBrandMatchScoreArgs {
  authId: Scalars['String']['input'];
}

export interface GqlQueryRootCampaignArgs {
  input: GqlCampaignSingleInput;
}

export interface GqlQueryRootCampaignActivityTimelineArgs {
  input: GqlCampaignActivityTimelineInput;
}

export interface GqlQueryRootCampaignAllInfluencersArgs {
  input: GqlCampaignAllInfluencersInput;
}

export interface GqlQueryRootCampaignAnalyticsArgs {
  input: GqlCampaignAnalyticsInput;
}

export interface GqlQueryRootCampaignAnalyticsHistoryArgs {
  input: GqlCampaignAnalyticsHistoryInput;
}

export interface GqlQueryRootCampaignAuthArgs {
  input: GqlCampaignAuthInput;
}

export interface GqlQueryRootCampaignAuthTaskBySecretArgs {
  secret: Scalars['String']['input'];
}

export interface GqlQueryRootCampaignAuthTaskInviteMessageGenerateArgs {
  input: GqlCampaignAuthTaskInviteMessageGenerateInput;
}

export interface GqlQueryRootCampaignAuthTaskLinkGetByShortUrlArgs {
  shortUrl: Scalars['String']['input'];
}

export interface GqlQueryRootCampaignAuthTaskLinkListArgs {
  input: GqlCampaignAuthTaskLinkListInput;
}

export interface GqlQueryRootCampaignAuthTaskListArgs {
  input: GqlCampaignAuthTaskListInput;
}

export interface GqlQueryRootCampaignExportDownloadUrlArgs {
  id: Scalars['ID']['input'];
}

export interface GqlQueryRootCampaignExportsArgs {
  campaignId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface GqlQueryRootCampaignListArgs {
  input: GqlCampaignListInput;
}

export interface GqlQueryRootCampaignPostArgs {
  input: GqlCampaignPostInput;
}

export interface GqlQueryRootCampaignRecommendationListArgs {
  input: GqlCampaignRecommendationListInput;
}

export interface GqlQueryRootCampaignSweepStatusArgs {
  input: GqlCampaignSweepStatusInput;
}

export interface GqlQueryRootCampaignTaskTemplateArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlQueryRootCampaignTrackingLinkCodeStatusArgs {
  code: Scalars['String']['input'];
}

export interface GqlQueryRootCampaignTrafficLiftReportArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlQueryRootCheckContactInfoArgs {
  input: GqlAccountContactInput;
}

export interface GqlQueryRootCreatorProfileArgs {
  input: GqlCreatorProfileInput;
}

export interface GqlQueryRootGaAccountListArgs {
  input: GqlGaAccountListInput;
}

export interface GqlQueryRootGaConnectionListArgs {
  input: GqlListViewParamsInput;
}

export interface GqlQueryRootGaPropertiesListArgs {
  input: GqlGaPropertiesListInput;
}

export interface GqlQueryRootGaWebStreamsListArgs {
  input: GqlGaWebStreamsListInput;
}

export interface GqlQueryRootGetLinkPreviewArgs {
  url: Scalars['String']['input'];
}

export interface GqlQueryRootGetOrganizationArgs {
  organizationId: Scalars['String']['input'];
}

export interface GqlQueryRootLinkbioPageByIdArgs {
  linkbioId: Scalars['ID']['input'];
}

export interface GqlQueryRootLinkbioPageByUsernameArgs {
  username: Scalars['String']['input'];
}

export interface GqlQueryRootLinkbioPageListArgs {
  input: GqlListViewParamsInput;
}

export interface GqlQueryRootListOrganizationsArgs {
  input: GqlOrganizationListInput;
}

export interface GqlQueryRootListPostCommentsArgs {
  input: GqlPostCommentListInput;
}

export interface GqlQueryRootLlmUsageDailyArgs {
  endDate: Scalars['String']['input'];
  groupBy: GqlLlmUsageDimensionInput;
  startDate: Scalars['String']['input'];
}

export interface GqlQueryRootLlmUsageSummaryArgs {
  period: Scalars['String']['input'];
}

export interface GqlQueryRootNotificationsArgs {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<GqlGqlNotificationType>>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlQueryRootOrganizationCampaignAuthTaskListArgs {
  input: GqlOrganizationCampaignAuthTaskListInput;
}

export interface GqlQueryRootOrganizationCampaignsGetBySecretArgs {
  input: GqlOrganizationCampaignBySecretInput;
}

export interface GqlQueryRootOrganizationCommerceSummaryArgs {
  period: GqlCommercePeriodInput;
}

export interface GqlQueryRootOrganizationCreditBalanceArgs {
  organizationId: Scalars['String']['input'];
}

export interface GqlQueryRootOrganizationCreditHistoryArgs {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
}

export interface GqlQueryRootOrganizationMemberListArgs {
  input: GqlOrganizationMemberListInput;
}

export interface GqlQueryRootOrganizationMemberPermissionArgs {
  memberId: Scalars['String']['input'];
}

export interface GqlQueryRootOrganizationPaymentDetailsListArgs {
  input: GqlOrganizationPaymentDetailsListInput;
}

export interface GqlQueryRootOrganizationPaymentDetailsViewSingleByProviderArgs {
  provider: GqlCampaignPaymentProviderEnum;
}

export interface GqlQueryRootOrganizationPayoutsFromListArgs {
  input: GqlOrganizationPayoutsListInput;
}

export interface GqlQueryRootOrganizationPayoutsToListArgs {
  input: GqlOrganizationPayoutsListInput;
}

export interface GqlQueryRootOrganizationRoleListArgs {
  input: GqlOrganizationRoleListInput;
}

export interface GqlQueryRootOrganizationShippingDetailsListArgs {
  input: GqlOrganizationShippingDetailsListInput;
}

export interface GqlQueryRootPersonaArgs {
  id: Scalars['String']['input'];
}

export interface GqlQueryRootPersonaByAuthIdArgs {
  authId: Scalars['String']['input'];
}

export interface GqlQueryRootPersonaConflictsArgs {
  limit?: Scalars['Int']['input'];
  status?: GqlMembershipEdgeStatusOutput;
}

export interface GqlQueryRootPostByIdArgs {
  input: GqlPostByIdInput;
}

export interface GqlQueryRootPromoCodePerformanceArgs {
  promoCodeId: Scalars['ID']['input'];
}

export interface GqlQueryRootResetPasswordTokenRequestArgs {
  input: GqlAccountPasswordResetTokenRequestInput;
}

export interface GqlQueryRootShopifyDiscountsArgs {
  storeId: Scalars['ID']['input'];
}

export interface GqlQueryRootShopifyProductsArgs {
  storeId: Scalars['ID']['input'];
}

export interface GqlQueryRootShopifyProductVariantsArgs {
  productId: Scalars['ID']['input'];
  storeId: Scalars['ID']['input'];
}

export interface GqlQueryRootUtmTemplateArgs {
  id: Scalars['String']['input'];
}

export interface GqlAccount {
  _id: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  isVerified: Scalars['Boolean']['output'];
  loginType: Scalars['String']['output'];
  organizations: Array<GqlOrganizationObject>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<GqlProfileObject>;
  updatedAt: Scalars['String']['output'];
}

export interface GqlOrganizationObject {
  _id: Scalars['ID']['output'];
  accountId: Scalars['ID']['output'];
  /**
   * Current credit balance. Returns 0 when the organization has never been
   * charged or topped up (no balance document exists yet). Derived from
   * `balanceUsdMicros / 10_000` (#582 Stage C) — exact whole credits.
   * @deprecated use balanceUsdMicros (integer micro-USD); credits are derived micros/10_000
   */
  balanceCredits: Scalars['Int']['output'];
  /**
   * Current balance in integer micro-USD (`1 credit = 10_000 micros`).
   * Authoritative money value (#582 Stage C). Returns 0 when the organization
   * has never been charged or topped up (no balance document exists yet).
   */
  balanceUsdMicros: Scalars['Int']['output'];
  brandContext?: Maybe<GqlBrandContextObject>;
  createdAt: Scalars['String']['output'];
  creatorPreferences?: Maybe<GqlCreatorPreferencesOutput>;
  /**
   * Connected-integration flags for the admin panel badges (issue #513):
   * `{ ga, stripe, shopify, email }`. Each boolean is resolved from the live
   * subsystem repos via a batched [`OrgIntegrationsLoader`] (one `$in` query
   * per subsystem per tick — no N+1 on the admin org list view).
   *
   * Admin-sensitive (exposes which paid/commerce subsystems an org has wired),
   * so it self-gates the same way as `shopifyStores`/`stripeCustomerId`:
   * visible to a superadmin, or an active member of THIS org holding
   * `SettingsView`. `OrganizationObject` is reachable via `get_organization`
   * without a membership check, hence the self-gate here.
   */
  integrations: GqlOrgIntegrationsOutput;
  isActive: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  /**
   * Nullable on purpose: a caller who is not an active member of THIS org
   * (e.g. a suspended membership) gets `Ok(None)` rather than
   * `Err(Forbidden)`. `OrganizationObject` is reachable through the
   * non-null `account.organizations` list, so an error here would
   * propagate up and null the entire list for any user with mixed
   * memberships — see #9506. Returning `None` keeps the rest of the list
   * intact while still disclosing nothing about this org's members.
   */
  members?: Maybe<Array<GqlOrganizationMemberObject>>;
  membersCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Snapshot of the `organization_membership_events` broadcaster
   * sequence at query time. FE persists this and applies a
   * `seq > serverSeq` filter to incoming `organizationMembershipEvents`
   * to drop already-included events on refetch races.
   *
   * Resolved concurrently with `members` — the race window is
   * sub-millisecond (atomic load); a duplicate refetch on rare race
   * is harmless (idempotent member list query).
   */
  membersServerSeq: Scalars['Int']['output'];
  permissions: Array<GqlOrganizationPermissionItemObject>;
  profile?: Maybe<GqlOrganizationProfileObject>;
  /**
   * Shopify stores connected to this organization, each flagged
   * `isPrimary`. Visible only to an active member of THIS organization
   * holding `SettingsView` (or a superadmin). A cross-org caller — or a
   * revoked/suspended member with a still-valid JWT — gets `Ok(None)`
   * with no disclosure of whether any store exists. Nullable on purpose:
   * `OrganizationObject` is reachable through the non-null
   * `account.organizations` list, so an `Err` here would propagate up and
   * null the entire list for any user with mixed memberships (#9506).
   * `get_organization` reaches this without a membership check, so we
   * self-gate here — same shape as `members`.
   */
  shopifyStores?: Maybe<Array<GqlShopifyStoreOutput>>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  type: Scalars['GraphqlOrganizationType']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlBrandContextObject {
  /** F2 per-org anomaly-detection settings (Brand Safety panel). */
  anomalySurfacingSettings: GqlAnomalySurfacingSettingsObject;
  competitors: Array<Scalars['String']['output']>;
  enrichedAt?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  industryTags: Array<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
  socialAccounts: Array<GqlBrandSocialAccountObject>;
  status: Scalars['String']['output'];
  toneOfVoice?: Maybe<Scalars['String']['output']>;
  websiteSummary?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
}

/**
 * Per-org F2 anomaly-surfacing settings as exposed under
 * `organization.brandContext.anomalySurfacingSettings`. No score or
 * probability field is ever present — `minPriority` is a band, not a number.
 */
export interface GqlAnomalySurfacingSettingsObject {
  /** `BrandSafetyWarningKind`s the org has switched off. Empty = all on. */
  disabledKinds: Array<GqlBrandSafetyWarningKindEnum>;
  /** Minimum priority band an anomaly recommendation must reach to surface. */
  minPriority: GqlRecommendationPriorityEnum;
}

/**
 * GraphQL mirror of `domain::auth_analytic::BrandSafetyWarningKind`, scoped
 * to the variants the org can toggle. The persistence-only `Legacy` and the
 * forward-compat `Unknown` variants are intentionally NOT exposed — they
 * carry no user-facing toggle.
 */
export const GqlBrandSafetyWarningKindEnum = {
  BrandSafetyFlag: 'BRAND_SAFETY_FLAG',
  EngagementBelowTier: 'ENGAGEMENT_BELOW_TIER',
  FtcDisclosureMissing: 'FTC_DISCLOSURE_MISSING',
  GrowthSpike: 'GROWTH_SPIKE',
  MassFollowPattern: 'MASS_FOLLOW_PATTERN',
  NearZeroEngagement: 'NEAR_ZERO_ENGAGEMENT',
} as const;

export type GqlBrandSafetyWarningKindEnum =
  (typeof GqlBrandSafetyWarningKindEnum)[keyof typeof GqlBrandSafetyWarningKindEnum];
export const GqlRecommendationPriorityEnum = {
  High: 'HIGH',
  Low: 'LOW',
  Medium: 'MEDIUM',
} as const;

export type GqlRecommendationPriorityEnum =
  (typeof GqlRecommendationPriorityEnum)[keyof typeof GqlRecommendationPriorityEnum];
export interface GqlBrandSocialAccountObject {
  followersCount?: Maybe<Scalars['Int']['output']>;
  handle: Scalars['String']['output'];
  source: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface GqlCreatorPreferencesOutput {
  available: Scalars['Boolean']['output'];
  collaborationNotes?: Maybe<Scalars['String']['output']>;
  contentTypes: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  excludedIndustries: Array<Scalars['String']['output']>;
  exclusivityDays?: Maybe<Scalars['Int']['output']>;
  geographicFocus: Array<Scalars['String']['output']>;
  maxActiveCampaigns?: Maybe<Scalars['Int']['output']>;
  minimumDealValue?: Maybe<Scalars['Float']['output']>;
  platformRates: Array<GqlPlatformRateCardOutput>;
  preferredBrandSizes: Array<Scalars['String']['output']>;
  preferredNiches: Array<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
}

export interface GqlPlatformRateCardOutput {
  rateLive?: Maybe<Scalars['Float']['output']>;
  ratePost?: Maybe<Scalars['Float']['output']>;
  rateReel?: Maybe<Scalars['Float']['output']>;
  rateStory?: Maybe<Scalars['Float']['output']>;
  rateVideo?: Maybe<Scalars['Float']['output']>;
  source: Scalars['String']['output'];
}

/**
 * Connected-integration flags for an organization, render-ready for the admin
 * panel badges (issue #513). Booleans rather than a presence-of-record so the
 * FE renders a fixed badge row; extensible — add a field here and source it in
 * `OrgIntegrationsLoader`.
 */
export interface GqlOrgIntegrationsOutput {
  /**
   * Per-org email/SES sender configuration. Always `false` today — sender
   * identities are global, there is no per-org signal yet (see #513 follow-up).
   */
  email: Scalars['Boolean']['output'];
  /** At least one connected Google Analytics connection exists for the org. */
  ga: Scalars['Boolean']['output'];
  /** At least one Shopify store is bound to the org in `Connected` status. */
  shopify: Scalars['Boolean']['output'];
  /**
   * A Stripe Connect account ready to receive payments (not merely
   * mid-onboarding) — see `OrgIntegrations::stripe`.
   */
  stripe: Scalars['Boolean']['output'];
}

export interface GqlOrganizationMemberObject {
  _id: Scalars['ID']['output'];
  /** Account ID is optional for pending members who haven't signed up yet */
  accountId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  department?: Maybe<Scalars['String']['output']>;
  invitedAt?: Maybe<Scalars['String']['output']>;
  invitedByAccountId?: Maybe<Scalars['ID']['output']>;
  invitedByEmail?: Maybe<Scalars['String']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  joinedAt?: Maybe<Scalars['String']['output']>;
  lastActivityAt?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  permissions: Array<GqlOrganizationPermissionItemObject>;
  profile?: Maybe<GqlProfileObject>;
  roleType: GqlGraphqlOrganizationRoleType;
  status: GqlGraphqlOrganizationMemberStatus;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
}

export interface GqlOrganizationPermissionItemObject {
  campaignId?: Maybe<Scalars['String']['output']>;
  editDisabled: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  key: GqlOrganizationPermissionEnum;
  title: Scalars['String']['output'];
}

export const GqlOrganizationPermissionEnum = {
  AiChatSessionManage: 'AI_CHAT_SESSION_MANAGE',
  AiChatSessionView: 'AI_CHAT_SESSION_VIEW',
  AiSearchHistoryManage: 'AI_SEARCH_HISTORY_MANAGE',
  AiSearchHistoryView: 'AI_SEARCH_HISTORY_VIEW',
  AnalyticsManage: 'ANALYTICS_MANAGE',
  AnalyticsView: 'ANALYTICS_VIEW',
  AuthManage: 'AUTH_MANAGE',
  AuthNoteManage: 'AUTH_NOTE_MANAGE',
  AuthNoteView: 'AUTH_NOTE_VIEW',
  AuthView: 'AUTH_VIEW',
  BillingManage: 'BILLING_MANAGE',
  BillingView: 'BILLING_VIEW',
  CampaignExport: 'CAMPAIGN_EXPORT',
  CampaignManage: 'CAMPAIGN_MANAGE',
  CampaignPaymentsView: 'CAMPAIGN_PAYMENTS_VIEW',
  CampaignView: 'CAMPAIGN_VIEW',
  ContentManage: 'CONTENT_MANAGE',
  ContentView: 'CONTENT_VIEW',
  GaConnectionManage: 'GA_CONNECTION_MANAGE',
  GaConnectionView: 'GA_CONNECTION_VIEW',
  LinkbioManage: 'LINKBIO_MANAGE',
  LinkbioView: 'LINKBIO_VIEW',
  MembersAdminManage: 'MEMBERS_ADMIN_MANAGE',
  MembersManage: 'MEMBERS_MANAGE',
  MembersView: 'MEMBERS_VIEW',
  OrganizationManage: 'ORGANIZATION_MANAGE',
  OrganizationView: 'ORGANIZATION_VIEW',
  RolesManage: 'ROLES_MANAGE',
  RolesView: 'ROLES_VIEW',
  SettingsManage: 'SETTINGS_MANAGE',
  SettingsView: 'SETTINGS_VIEW',
} as const;

export type GqlOrganizationPermissionEnum =
  (typeof GqlOrganizationPermissionEnum)[keyof typeof GqlOrganizationPermissionEnum];
export interface GqlProfileObject {
  _id: Scalars['String']['output'];
  avatar?: Maybe<GqlMediaOutput>;
  createdAt: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  onboardingPassed: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlMediaOutput {
  description?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  encoding?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  processed: Scalars['Boolean']['output'];
  s3Key?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /**
   * Returns the signed CloudFront URL for the media.
   *
   * Resolution logic:
   * 1. If raw_url points to our CDN, extract s3Key and sign it
   * 2. If s3_key exists and processed is true, sign it
   * 3. If raw_url exists (external URL), proxy it through image-service `/proxy`
   * 4. Otherwise, return None
   */
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
}

export const GqlGraphqlOrganizationRoleType = {
  Admin: 'ADMIN',
  Manager: 'MANAGER',
  Owner: 'OWNER',
  Viewer: 'VIEWER',
} as const;

export type GqlGraphqlOrganizationRoleType =
  (typeof GqlGraphqlOrganizationRoleType)[keyof typeof GqlGraphqlOrganizationRoleType];
export const GqlGraphqlOrganizationMemberStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Pending: 'PENDING',
  Suspended: 'SUSPENDED',
} as const;

export type GqlGraphqlOrganizationMemberStatus =
  (typeof GqlGraphqlOrganizationMemberStatus)[keyof typeof GqlGraphqlOrganizationMemberStatus];
export interface GqlOrganizationProfileObject {
  _id: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<GqlMediaOutput>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  extraInfo?: Maybe<Scalars['String']['output']>;
  goals: Array<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  size: Scalars['GraphqlOrganizationSize']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
}

/**
 * A Shopify store as seen through the API. `accessToken`, poll cursors and
 * `appClientId` are intentionally omitted — internal-only.
 */
export interface GqlShopifyStoreOutput {
  /**
   * RFC 3339 timestamp of the first successful OAuth. Codebase convention
   * (matches `OrganizationObject`, `UtmTemplateOutput`) is a string scalar.
   */
  connectedAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  /**
   * RFC 3339 timestamp of the *first* disconnect — write-once on the repo
   * side, so a repeated `shopifyStoreDisconnect` preserves the original
   * stamp. `null` for a store that has never been disconnected.
   */
  disconnectedAt?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Derived from `ShopifyOrgSettings.primary_store_id`. */
  isPrimary: Scalars['Boolean']['output'];
  myshopifyDomain: Scalars['String']['output'];
  planDisplay?: Maybe<Scalars['String']['output']>;
  planShopifyPlus: Scalars['Boolean']['output'];
  scopes: Array<Scalars['String']['output']>;
  status: GqlShopifyStoreStatusGql;
}

/** Connection lifecycle of a [`ShopifyStore`], exposed to the API. */
export const GqlShopifyStoreStatusGql = {
  Connected: 'CONNECTED',
  Disconnected: 'DISCONNECTED',
  /**
   * `shop/redact` GDPR webhook processed — terminal; the store and its
   * shop-scoped data are purged and the token cleared.
   */
  Redacted: 'REDACTED',
  ReinstallRequired: 'REINSTALL_REQUIRED',
} as const;

export type GqlShopifyStoreStatusGql =
  (typeof GqlShopifyStoreStatusGql)[keyof typeof GqlShopifyStoreStatusGql];
export interface GqlActiveBackgroundTasksResult {
  hasNextPage: Scalars['Boolean']['output'];
  tasks: Array<GqlBackgroundTaskOutput>;
}

export interface GqlBackgroundTaskOutput {
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /**
   * Typed link to the entity this task represents. Frontend resolves
   * `kind → route`. Source of truth for tray-card click-through.
   */
  entityRef?: Maybe<GqlEntityRefOutput>;
  error?: Maybe<Scalars['String']['output']>;
  failureKind?: Maybe<GqlBackgroundTaskFailureKindEnum>;
  id: Scalars['String']['output'];
  progressPct?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use entityRef. Removal tracked in follow-up issue (TBD). */
  resultUrl?: Maybe<Scalars['String']['output']>;
  runId: Scalars['String']['output'];
  runStartedAt: Scalars['String']['output'];
  /**
   * Org-wide seen-ack (#428). `true` once a terminal row has been
   * acknowledged via `markBackgroundTasksSeen`; such rows are hidden
   * from the tray by default (pass `includeSeen: true` to surface
   * them). Always `false` for `Running` rows.
   */
  seen: Scalars['Boolean']['output'];
  status: GqlBackgroundTaskStatusEnum;
  targetEntityId: Scalars['String']['output'];
  taskType: GqlBackgroundTaskTypeEnum;
  /**
   * Tray API additions (#263) — all nullable. `completed_at` is
   * computed: `Some(updatedAt)` iff status is terminal.
   */
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
}

export interface GqlEntityRefOutput {
  id: Scalars['String']['output'];
  kind: GqlEntityKindEnum;
}

export const GqlEntityKindEnum = {
  AiChatSession: 'AI_CHAT_SESSION',
  AiSearchHistory: 'AI_SEARCH_HISTORY',
  Auth: 'AUTH',
  Draft: 'DRAFT',
  GaProperty: 'GA_PROPERTY',
  /**
   * Forward-compat: the server stored a `kind` this binary does not
   * know about. Frontend should treat as a non-clickable card.
   */
  Unknown: 'UNKNOWN',
} as const;

export type GqlEntityKindEnum =
  (typeof GqlEntityKindEnum)[keyof typeof GqlEntityKindEnum];
export const GqlBackgroundTaskFailureKindEnum = {
  ExecutionError: 'EXECUTION_ERROR',
  StaleTimeout: 'STALE_TIMEOUT',
} as const;

export type GqlBackgroundTaskFailureKindEnum =
  (typeof GqlBackgroundTaskFailureKindEnum)[keyof typeof GqlBackgroundTaskFailureKindEnum];
export const GqlBackgroundTaskStatusEnum = {
  Done: 'DONE',
  Failed: 'FAILED',
  /**
   * Terminal partial-success (#203): produced usable output but a
   * non-fatal sub-step failed. See `BackgroundTaskStatus::Partial`.
   */
  Partial: 'PARTIAL',
  Running: 'RUNNING',
} as const;

export type GqlBackgroundTaskStatusEnum =
  (typeof GqlBackgroundTaskStatusEnum)[keyof typeof GqlBackgroundTaskStatusEnum];
export const GqlBackgroundTaskTypeEnum = {
  AiChat: 'AI_CHAT',
  AiSearch: 'AI_SEARCH',
  DeepLookup: 'DEEP_LOOKUP',
  GaPropertySync: 'GA_PROPERTY_SYNC',
} as const;

export type GqlBackgroundTaskTypeEnum =
  (typeof GqlBackgroundTaskTypeEnum)[keyof typeof GqlBackgroundTaskTypeEnum];
export interface GqlListViewParamsInput {
  pagination?: InputMaybe<GqlPaginationInput>;
  sortBy?: InputMaybe<GqlSortByInput>;
}

export interface GqlPaginationInput {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface GqlSortByInput {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
}

/** A generic list view for pagination */
export interface GqlAiChatMessageList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlChatMessageOutput>;
  limit: Scalars['Int']['output'];
}

export interface GqlChatMessageOutput {
  _id: Scalars['String']['output'];
  blocks: Array<GqlChatBlockOutput>;
  createdAt: Scalars['String']['output'];
  role: GqlGqlChatMessageRole;
  /** Account ID of the sender (present for user messages, None for assistant) */
  senderId?: Maybe<Scalars['String']['output']>;
  /** Profile of the sender (resolved via DataLoader, present for user messages) */
  senderProfile?: Maybe<GqlProfileObject>;
  toolCallsUsed?: Maybe<Array<GqlToolCallRecordOutput>>;
}

export interface GqlChatBlockOutput {
  /** Action type badge (ActionConfirmation blocks only) */
  actionType?: Maybe<GqlGqlActionType>;
  /** Resolved AiSearchHistory entity (populated when entityKey == AiSearchHistory) */
  aiSearchHistory?: Maybe<GqlAiSearchHistoryOutput>;
  /** Resolved Auth entity (populated when entityKey == Auth) */
  auth?: Maybe<GqlAuth>;
  /**
   * Resolved AuthGroup entity (populated when entityKey == AuthGroup)
   * Note: AuthGroup requires organization_id, resolved via direct repo call
   */
  authGroup?: Maybe<GqlAuthGroupOutput>;
  /** Resolved AuthNote entity (populated when entityKey == AuthNote) */
  authNote?: Maybe<GqlAuthNoteOutput>;
  /** Resolved Campaign entity (populated when entityKey == Campaign) */
  campaign?: Maybe<GqlCampaignOutput>;
  /** Resolved CampaignAuthTask entity (populated when entityKey == CampaignAuthTask) */
  campaignAuthTask?: Maybe<GqlCampaignAuthTaskOutput>;
  description?: Maybe<Scalars['String']['output']>;
  /** Download URL for a user-facing file result (Download blocks only) */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityKey?: Maybe<GqlGqlChatEntityType>;
  /** Entity being acted on (ActionConfirmation blocks only) */
  entityName?: Maybe<Scalars['String']['output']>;
  /** Structured key-value fields (ActionConfirmation blocks only) */
  fields?: Maybe<Array<GqlConfirmationFieldOutput>>;
  /** Display filename for a user-facing file result (Download blocks only) */
  filename?: Maybe<Scalars['String']['output']>;
  /** Resolved GaConnection entity (populated when entityKey == GaWebsite) */
  gaConnection?: Maybe<GqlGaConnectionOutput>;
  message?: Maybe<Scalars['String']['output']>;
  /** Optional choices for the user (Action / ActionConfirmation blocks) */
  options?: Maybe<Array<Scalars['String']['output']>>;
  /** Resolved Post entity (populated when entityKey == Post) */
  post?: Maybe<GqlPostOutput>;
  /** Question text (Action blocks only) */
  question?: Maybe<Scalars['String']['output']>;
  /** Exported creator count (Download blocks only) */
  rowCount?: Maybe<Scalars['Int']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: GqlGqlChatBlockType;
  /** Accepted candidates still indexing and omitted from the file */
  skippedUnindexed?: Maybe<Scalars['Int']['output']>;
}

export const GqlGqlActionType = {
  Create: 'CREATE',
  Delete: 'DELETE',
  Search: 'SEARCH',
  Update: 'UPDATE',
} as const;

export type GqlGqlActionType =
  (typeof GqlGqlActionType)[keyof typeof GqlGqlActionType];

export interface GqlAiSearchAcceptedProgressOutput {
  indexed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
}

/** AI Search history (a search session) */
export interface GqlAiSearchHistoryOutput {
  _id: Scalars['String']['output'];
  /**
   * How many accepted creators are ready to render (#32).
   *
   * `aiSearchCandidates` deliberately returns only fully-indexed rows, so a
   * finished search can legitimately list 10 creators while
   * `searchState.totalAccepted` says 22 — the rest are still being indexed.
   * Without this the UI cannot tell that gap from a failure, and reports the
   * search as finished-with-10.
   *
   * Resolved on demand: a client that does not ask for progress pays
   * nothing.
   */
  acceptedIndexed: Scalars['Int']['output'];
  /** Accepted creator indexing progress, resolved with one database count. */
  acceptedProgress: GqlAiSearchAcceptedProgressOutput;
  /**
   * Total accepted, including those still indexing — the denominator for
   * `acceptedIndexed`.
   */
  acceptedTotal: Scalars['Int']['output'];
  /**
   * How much of the loop budget this search has spent (#32).
   *
   * The UI needs it to say "stage 2 of 10" and to show how close a long
   * search is to its time cap. It exists on the domain history and was
   * simply never mapped out, so progress could only ever be reported as a
   * binary running/finished.
   */
  budget: GqlSearchBudgetOutput;
  createdAt: Scalars['String']['output'];
  initialPrompt: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  searchState: GqlSearchStateOutput;
  status: GqlSearchStatusOutput;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
}

/** Loop budget of a search — what it is allowed to spend and what it has spent. */
export interface GqlSearchBudgetOutput {
  maxSeconds: Scalars['Int']['output'];
  maxStages: Scalars['Int']['output'];
  usedSeconds: Scalars['Int']['output'];
  usedStages: Scalars['Int']['output'];
}

/** Current state of the search */
export interface GqlSearchStateOutput {
  currentCriteria?: Maybe<GqlRankingCriteriaOutput>;
  summary: Scalars['String']['output'];
  totalAccepted: Scalars['Int']['output'];
  totalRejected: Scalars['Int']['output'];
}

/** Ranking criteria (hard constraints + soft preferences) */
export interface GqlRankingCriteriaOutput {
  amount: Scalars['Int']['output'];
  hard: GqlHardConstraintsOutput;
  soft: GqlSoftPreferencesOutput;
}

/** Hard constraints for filtering */
export interface GqlHardConstraintsOutput {
  engagementRateMin?: Maybe<Scalars['Float']['output']>;
  excludeLowInfo: Scalars['Boolean']['output'];
  excludePrivate: Scalars['Boolean']['output'];
  followersMax?: Maybe<Scalars['Int']['output']>;
  followersMin?: Maybe<Scalars['Int']['output']>;
  platforms: Array<GqlSourceOutput>;
}

/** Social platform source */
export const GqlSourceOutput = {
  Instagram: 'INSTAGRAM',
  Shopify: 'SHOPIFY',
  ShopifyAttached: 'SHOPIFY_ATTACHED',
  Spotify: 'SPOTIFY',
  Tiktok: 'TIKTOK',
  Twitch: 'TWITCH',
  Twitter: 'TWITTER',
  YouTube: 'YOU_TUBE',
} as const;

export type GqlSourceOutput =
  (typeof GqlSourceOutput)[keyof typeof GqlSourceOutput];
/** Soft preferences for ranking */
export interface GqlSoftPreferencesOutput {
  genderHint?: Maybe<Scalars['String']['output']>;
  geoHint?: Maybe<Scalars['String']['output']>;
  negativeKeywords: Array<Scalars['String']['output']>;
  negativePrompt?: Maybe<Scalars['String']['output']>;
  nicheKeywords: Array<Scalars['String']['output']>;
  prompt: Scalars['String']['output'];
}

/** Overall status of a search session */
export const GqlSearchStatusOutput = {
  Completed: 'COMPLETED',
  Error: 'ERROR',
  Pending: 'PENDING',
  Processing: 'PROCESSING',
} as const;

export type GqlSearchStatusOutput =
  (typeof GqlSearchStatusOutput)[keyof typeof GqlSearchStatusOutput];
export interface GqlAuth {
  _id: Scalars['String']['output'];
  audienceAgeGroup?: Maybe<GqlAudienceAgeGroupOutput>;
  audienceGenderLean?: Maybe<GqlAudienceGenderLeanOutput>;
  audienceGeoHint?: Maybe<Scalars['String']['output']>;
  audioProfile?: Maybe<GqlAudioProfileOutput>;
  authAnalyticsLatest?: Maybe<GqlAuthAnalyticOutput>;
  avatar?: Maybe<GqlMediaOutput>;
  biography?: Maybe<Scalars['String']['output']>;
  brandFitAssessment?: Maybe<Scalars['String']['output']>;
  /**
   * AI brand-match score for this creator against the viewing brand's context.
   * Null if brand context isn't enriched. Triggers computation if not cached.
   */
  brandMatchScore?: Maybe<GqlBrandMatchResultOutput>;
  brandSafetyFlags: Array<GqlBrandSafetyFlagOutput>;
  /** Brand safety score (0-100). 100 = no flags, decreases with each flag by severity. */
  brandSafetyScore: Scalars['Int']['output'];
  /** Brand safety status: "Excellent" (>=80), "Good" (>=60), "Fair" (>=40), "Poor" (<40). */
  brandSafetyStatus: Scalars['String']['output'];
  campaignAuthAnalyticsLatest?: Maybe<GqlCampaignAnalyticsOutput>;
  campaigns: Array<GqlCampaignOutput>;
  campaignTaskLinks: Array<GqlCampaignAuthTaskLinkOutput>;
  campaignTasks: Array<GqlCampaignAuthTaskOutput>;
  cityName?: Maybe<Scalars['String']['output']>;
  /** Brand collaborations detected from this creator's posts. */
  collaborations: Array<GqlAuthCollaborationOutput>;
  connected: Scalars['Boolean']['output'];
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  contentCategories: Array<GqlContentCategoryOutput>;
  contentLanguage?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  creatorStatus?: Maybe<GqlAuthCreatorStatusOutput>;
  /**
   * Deep-lookup enrichment status/result for this creator. Null if never run or
   * the deep-lookup feature isn't wired in this environment.
   */
  deepLookup?: Maybe<GqlDeepLookupOutput>;
  deepSummary?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * #741 — per-lane indexing progress. `discoveredIndex.profile == READY`
   * with `status == not_indexed` is an ENRICHED sweep-discovered creator: a
   * real profile, but no deep index (no posts, no analytics, no AI insights).
   *
   * #747 removed the sibling `discovered: Boolean!` field. It exposed a
   * mutable global marker that one organization's promotion cleared for
   * everyone; the FE never selected it. What it was meant to convey — "this
   * profile is a stub, deep-fetch actions will be refused" — is exactly the
   * lane state above.
   */
  discoveredIndex: GqlDiscoveredIndex;
  expiredDate?: Maybe<Scalars['String']['output']>;
  fetchEnabled: Scalars['Boolean']['output'];
  followersCount?: Maybe<Scalars['Int']['output']>;
  followingCount?: Maybe<Scalars['Int']['output']>;
  ftcDisclosedCount?: Maybe<Scalars['Int']['output']>;
  ftcSponsoredPostsCount?: Maybe<Scalars['Int']['output']>;
  ftcStatus?: Maybe<Scalars['String']['output']>;
  ftcSummary?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  groups: Array<GqlAuthGroupOutput>;
  innerId: Scalars['String']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  latestPosts: Array<GqlPostOutput>;
  narrativeStyle: Array<Scalars['String']['output']>;
  note?: Maybe<GqlAuthNoteOutput>;
  /**
   * Brands the creator organically features in their visual content, ranked as
   * candidates for organic brand partnerships. Derived from
   * `visual_profile.detected_brands`; empty when there is no visual profile.
   */
  organicBrandAffinity: Array<GqlOrganicBrandAffinityOutput>;
  outreachStatus: GqlCampaignAuthOutreachOutput;
  /** Persona this auth belongs to (cross-platform identity grouping). */
  persona?: Maybe<GqlPersonaOutput>;
  /**
   * Cross-platform outreach status aggregated across the sibling auths in
   * this auth's persona, within `campaign_id` (issue #474). Lets a brand see
   * "you're already Negotiating with this person on another platform". Source
   * of truth stays per-`Auth`; this joins through `Auth.persona_id` at read
   * time. `None` when the auth has no persona siblings or none of them have a
   * meaningful status in this campaign.
   */
  personaOutreachStatus?: Maybe<GqlPersonaOutreachSummaryOutput>;
  /**
   * Cross-platform CRM relationship status aggregated across the sibling
   * auths in this auth's persona (issue #474). Org-scoped, campaign-agnostic
   * counterpart of `personaOutreachStatus`. `None` when there are no persona
   * siblings with a relationship status.
   */
  personaRelationshipStatus?: Maybe<GqlPersonaRelationshipSummaryOutput>;
  postCount?: Maybe<Scalars['Int']['output']>;
  postingThemes: Array<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  publicEmail?: Maybe<Scalars['String']['output']>;
  /** Similar creators by content and niche (vector cosine similarity). */
  similarCreators: Array<GqlSimilarCreatorOutput>;
  source: GqlAuthSource;
  sponsoredContentStyle?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  username: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
  videoViewCount?: Maybe<Scalars['Int']['output']>;
  visualProfile?: Maybe<GqlVisualProfileOutput>;
  /**
   * Whitelisting readiness score (0-100) estimating premium-campaign
   * eligibility. Weighted blend of brand safety, visual quality, and visual
   * consistency (see `WHITELISTING_READINESS_WEIGHTS`). `null` until the
   * creator is enriched enough to score all inputs. DRAFT weights — pending
   * product sign-off, tuning tracked as a follow-up to #108.
   */
  whitelistingReadiness?: Maybe<Scalars['Int']['output']>;
}

export interface GqlAuthCampaignAuthAnalyticsLatestArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlAuthCampaignTaskLinksArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlAuthCampaignTasksArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlAuthLatestPostsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface GqlAuthOutreachStatusArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlAuthPersonaOutreachStatusArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlAuthSimilarCreatorsArgs {
  limit?: Scalars['Int']['input'];
  samePlatformOnly?: Scalars['Boolean']['input'];
}

export const GqlAudienceAgeGroupOutput = {
  Age_13_17: 'AGE_13_17',
  Age_18_24: 'AGE_18_24',
  Age_25_34: 'AGE_25_34',
  Age_35_44: 'AGE_35_44',
  Age_45_54: 'AGE_45_54',
  Age_55Plus: 'AGE_55_PLUS',
} as const;

export type GqlAudienceAgeGroupOutput =
  (typeof GqlAudienceAgeGroupOutput)[keyof typeof GqlAudienceAgeGroupOutput];
export const GqlAudienceGenderLeanOutput = {
  Balanced: 'BALANCED',
  Female: 'FEMALE',
  Male: 'MALE',
} as const;

export type GqlAudienceGenderLeanOutput =
  (typeof GqlAudienceGenderLeanOutput)[keyof typeof GqlAudienceGenderLeanOutput];
export interface GqlAudioProfileOutput {
  analyzedAt: Scalars['String']['output'];
  audioSafetyFlags: Array<GqlBrandSafetyFlagOutput>;
  brandMentions: Array<Scalars['String']['output']>;
  contentTones: Array<GqlContentToneOutput>;
  spokenLanguages: Array<Scalars['String']['output']>;
  totalDurationSecs: Scalars['Int']['output'];
  transcriptSnippet?: Maybe<Scalars['String']['output']>;
  videosAnalyzed: Scalars['Int']['output'];
}

export const GqlBrandSafetyFlagOutput = {
  Alcohol: 'ALCOHOL',
  Controversial: 'CONTROVERSIAL',
  Gambling: 'GAMBLING',
  Nsfw: 'NSFW',
  Political: 'POLITICAL',
  Tobacco: 'TOBACCO',
  Violence: 'VIOLENCE',
} as const;

export type GqlBrandSafetyFlagOutput =
  (typeof GqlBrandSafetyFlagOutput)[keyof typeof GqlBrandSafetyFlagOutput];
export const GqlContentToneOutput = {
  Calm: 'CALM',
  Casual: 'CASUAL',
  Comedic: 'COMEDIC',
  Conversational: 'CONVERSATIONAL',
  Dramatic: 'DRAMATIC',
  Educational: 'EDUCATIONAL',
  Energetic: 'ENERGETIC',
  Entertaining: 'ENTERTAINING',
  Inspirational: 'INSPIRATIONAL',
  Professional: 'PROFESSIONAL',
  Promotional: 'PROMOTIONAL',
  Storytelling: 'STORYTELLING',
} as const;

export type GqlContentToneOutput =
  (typeof GqlContentToneOutput)[keyof typeof GqlContentToneOutput];
export interface GqlAuthAnalyticOutput {
  _id?: Maybe<Scalars['String']['output']>;
  authInnerId: Scalars['String']['output'];
  authSource: Scalars['String']['output'];
  averageComments: Scalars['Int']['output'];
  averageEngagementRate?: Maybe<Scalars['Float']['output']>;
  averageLikes: Scalars['Int']['output'];
  averageShares: Scalars['Int']['output'];
  averageVideoViews: Scalars['Int']['output'];
  avgViewsPerPost?: Maybe<Scalars['Int']['output']>;
  avgViewsPerReel?: Maybe<Scalars['Int']['output']>;
  /** Composite brand safety metrics with 5 sub-scores. */
  brandSafety?: Maybe<GqlBrandSafetyMetricsOutput>;
  /** Engagement rate breakdown by content type (computed from post_bucket). */
  contentPerformance: Array<GqlContentPerformanceOutput>;
  createdAt: Scalars['String']['output'];
  createdAtFormatted?: Maybe<Scalars['String']['output']>;
  engagement: GqlAuthAnalyticEngagementOutput;
  engagementMentioned?: Maybe<GqlAuthAnalyticEngagementOutput>;
  /**
   * Engagement rate (%) over the last 30 days. Independent from
   * `averageEngagementRate` (90-day window). Issue #311.
   */
  erRecent30D?: Maybe<Scalars['Float']['output']>;
  followerGrowthRate30D?: Maybe<Scalars['Float']['output']>;
  followersCount: Scalars['Int']['output'];
  followersCount30DAgo?: Maybe<Scalars['Int']['output']>;
  growthTrend?: Maybe<GqlGrowthTrendOutput>;
  lastPostCreatedAt?: Maybe<Scalars['String']['output']>;
  /** Engagement rate for organic (non-sponsored) posts only. */
  organicEngagementRate?: Maybe<Scalars['Float']['output']>;
  postBucket: Array<GqlAuthAnalyticPostBucketItemOutput>;
  postHashtags: Array<Scalars['String']['output']>;
  postingAnomaly?: Maybe<Scalars['Boolean']['output']>;
  postingFrequency?: Maybe<Scalars['Float']['output']>;
  postKeywords: Array<Scalars['String']['output']>;
  postMentions: Array<Scalars['String']['output']>;
  postsCount: Scalars['Int']['output'];
  postsInAveragePeriod: Scalars['Int']['output'];
  postsThisWeek?: Maybe<Scalars['Int']['output']>;
  /** Engagement rate for sponsored posts only. */
  sponsoredEngagementRate?: Maybe<Scalars['Float']['output']>;
  sponsoredPostRate?: Maybe<Scalars['Float']['output']>;
  storiesCount?: Maybe<Scalars['Int']['output']>;
  topLocations: Array<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  videoCount?: Maybe<Scalars['Int']['output']>;
  /**
   * View-prediction signal (#494): reel-median ratio + creator-aggregate
   * view-based engagement rate, exposed alongside the follower-based ER.
   */
  viewPrediction?: Maybe<GqlViewPredictionOutput>;
  /**
   * #698 — `true` when `averageVideoViews` is ESTIMATED because this Instagram
   * creator's reel play counts are hidden (`like_and_view_counts_disabled`).
   * The frontend must label the view figure as an estimate (e.g. "Instagram
   * hides this creator's views — estimated ~N") and never present it as a
   * measured number. `null`/absent when the views are real/measured.
   */
  viewsEstimated?: Maybe<Scalars['Boolean']['output']>;
}

export interface GqlBrandSafetyMetricsOutput {
  authenticityScore?: Maybe<Scalars['Int']['output']>;
  contentSafetyScore?: Maybe<Scalars['Int']['output']>;
  engagementQualityScore?: Maybe<Scalars['Int']['output']>;
  growthHealthScore?: Maybe<Scalars['Int']['output']>;
  professionalismScore?: Maybe<Scalars['Int']['output']>;
  /** Composite score 0-100, null if insufficient data */
  score?: Maybe<Scalars['Int']['output']>;
  status: GqlBrandSafetyStatusOutput;
  structuredWarnings: Array<GqlBrandSafetyWarningOutput>;
  /**
   * Backward-compatible flat list of warning messages.
   * New consumers should read `structured_warnings` for severity + evidence.
   */
  warnings: Array<Scalars['String']['output']>;
}

export const GqlBrandSafetyStatusOutput = {
  Excellent: 'EXCELLENT',
  Fair: 'FAIR',
  Good: 'GOOD',
  Insufficient: 'INSUFFICIENT',
  Poor: 'POOR',
} as const;

export type GqlBrandSafetyStatusOutput =
  (typeof GqlBrandSafetyStatusOutput)[keyof typeof GqlBrandSafetyStatusOutput];
export interface GqlBrandSafetyWarningOutput {
  /** `profileAggregate` | `postList` | `pendingUpstreamWiring` */
  evidenceKind: Scalars['String']['output'];
  /** Post inner_ids when `evidence_kind = postList`, otherwise empty. */
  evidencePostIds: Array<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  message: Scalars['String']['output'];
  /** 0-100, where 100 is most concerning. Sort or pick top-N. */
  severity: Scalars['Int']['output'];
}

export interface GqlContentPerformanceOutput {
  /** Number of posts of this type */
  count: Scalars['Int']['output'];
  /** Engagement rate for this content type */
  engagementRate: Scalars['Float']['output'];
  /** Content type: "Reel", "Post", "Story" */
  type: Scalars['String']['output'];
}

export interface GqlAuthAnalyticEngagementOutput {
  comments: Scalars['Int']['output'];
  likes: Scalars['Int']['output'];
  shares: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
}

export const GqlGrowthTrendOutput = {
  Declining: 'DECLINING',
  Rising: 'RISING',
  Stable: 'STABLE',
} as const;

export type GqlGrowthTrendOutput =
  (typeof GqlGrowthTrendOutput)[keyof typeof GqlGrowthTrendOutput];
export interface GqlAuthAnalyticPostBucketItemOutput {
  engagement: GqlAuthAnalyticEngagementOutput;
  innerId: Scalars['String']['output'];
  type: GqlAuthAnalyticPostType;
}

export const GqlAuthAnalyticPostType = {
  Social: 'SOCIAL',
  Story: 'STORY',
  Video: 'VIDEO',
} as const;

export type GqlAuthAnalyticPostType =
  (typeof GqlAuthAnalyticPostType)[keyof typeof GqlAuthAnalyticPostType];
/**
 * View-prediction signal (#494): per-creator reel-median ratio used to predict
 * static-post views, plus a creator-aggregate view-based engagement rate.
 */
export interface GqlViewPredictionOutput {
  /** Upper confidence-band multiplier (e.g. 2.0). */
  bandHigh: Scalars['Float']['output'];
  /** Lower confidence-band multiplier (e.g. 0.5). */
  bandLow: Scalars['Float']['output'];
  /** Coarse confidence level (High/Medium/Low). */
  confidence: GqlViewPredictionConfidenceOutput;
  /** True when `ratio` is the global fallback (creator had too few reels). */
  isFallback: Scalars['Boolean']['output'];
  /**
   * Median `views/(likes+comments+1)` over the creator's reels-with-views,
   * or the global fallback when too few reels exist.
   */
  ratio: Scalars['Float']['output'];
  /** Number of reels-with-views the ratio was computed from. */
  reelCount: Scalars['Int']['output'];
  /**
   * Creator-aggregate view-based engagement rate (%). Sits alongside the
   * follower-based `averageEngagementRate`, never replaces it.
   */
  viewBasedEngagementRate?: Maybe<Scalars['Float']['output']>;
}

export const GqlViewPredictionConfidenceOutput = {
  High: 'HIGH',
  Low: 'LOW',
  Medium: 'MEDIUM',
} as const;

export type GqlViewPredictionConfidenceOutput =
  (typeof GqlViewPredictionConfidenceOutput)[keyof typeof GqlViewPredictionConfidenceOutput];
export interface GqlBrandMatchResultOutput {
  anchorScore: Scalars['Int']['output'];
  categoryOverlap: Scalars['Float']['output'];
  competitorOverlap: Array<GqlCompetitorFlagOutput>;
  costReasoning?: Maybe<Scalars['String']['output']>;
  engagementScore: Scalars['Float']['output'];
  estimatedCostMaxUsd?: Maybe<Scalars['Int']['output']>;
  estimatedCostMinUsd?: Maybe<Scalars['Int']['output']>;
  expiresAt: Scalars['String']['output'];
  keyRisks: Array<Scalars['String']['output']>;
  keyStrengths: Array<Scalars['String']['output']>;
  keywordOverlap: Scalars['Float']['output'];
  matchReasoning: Array<Scalars['String']['output']>;
  /** Per-factor match reasoning breakdown (MAR-58). */
  matchReasons: Array<GqlMatchReasonOutput>;
  matchScore?: Maybe<Scalars['Int']['output']>;
  matchSummary?: Maybe<Scalars['String']['output']>;
  /**
   * Snapshot of the `auth_detail_events` broadcaster sequence taken at
   * query time (before the DB read). FE persists this and applies a
   * `seq > serverSeq` filter to incoming `authDetailEvents` to drop
   * already-included events on refetch races (#278 / ADR-002).
   */
  serverSeq: Scalars['Int']['output'];
  status: GqlBrandMatchStatusGql;
}

export interface GqlCompetitorFlagOutput {
  collabUsername: Scalars['String']['output'];
  competitorName: Scalars['String']['output'];
  lastPostDate?: Maybe<Scalars['String']['output']>;
  postCount: Scalars['Int']['output'];
}

/** Per-factor match reasoning (MAR-58). Computed at response time from sub-scores. */
export interface GqlMatchReasonOutput {
  /** Factor name: "Content Alignment", "Keyword Match", "Engagement Quality", "Competitor Risk" */
  factor: Scalars['String']['output'];
  /** Factor score 0.0-1.0 */
  score: Scalars['Float']['output'];
  /** "positive" | "neutral" | "negative" */
  sentiment: Scalars['String']['output'];
  /** Human-readable 1-sentence explanation */
  summary: Scalars['String']['output'];
}

export const GqlBrandMatchStatusGql = {
  Completed: 'COMPLETED',
  Computing: 'COMPUTING',
  Failed: 'FAILED',
} as const;

export type GqlBrandMatchStatusGql =
  (typeof GqlBrandMatchStatusGql)[keyof typeof GqlBrandMatchStatusGql];
export interface GqlCampaignAnalyticsOutput {
  authId?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  comments: Scalars['Int']['output'];
  committedBudget: Scalars['Float']['output'];
  cpe: Scalars['Float']['output'];
  /** Cost per order = spent / ga_purchases. 0.0 when there are no purchases. */
  cpo: Scalars['Float']['output'];
  cpv: Scalars['Float']['output'];
  emv: Scalars['Float']['output'];
  endDate: Scalars['String']['output'];
  engagement: Scalars['Int']['output'];
  /** Engagement rate = engagement / total_followers * 100. Null if followers is 0. */
  engagementRate?: Maybe<Scalars['Float']['output']>;
  gaClicks: Scalars['Int']['output'];
  gaPageviews: Scalars['Int']['output'];
  gaPurchases: Scalars['Int']['output'];
  gaRevenue: Scalars['Float']['output'];
  gaSessions: Scalars['Int']['output'];
  /**
   * Impressions (#465). PROXY: impressions ← the `engagement` aggregate
   * (likes + comments + shares — the existing `engagement` field, which
   * excludes views so it never double-counts `reach`). `null` when there is
   * no engagement signal (FE renders "—").
   */
  impressions?: Maybe<Scalars['Int']['output']>;
  likes: Scalars['Int']['output'];
  linkClicks: Scalars['Int']['output'];
  offeredMoney: Scalars['Float']['output'];
  postsCount: Scalars['Int']['output'];
  /**
   * Total reach (#465). PROXY: platforms do not expose true reach to us, so
   * reach ← `views` (sum of views over the window). `null` when there is no
   * view signal at all (FE renders "—"), never a misleading hard 0.
   */
  reach?: Maybe<Scalars['Int']['output']>;
  /**
   * Actual snapshot date used to build the response (YYYY-MM-DD).
   * Differs from `endDate` when the worker has not produced a snapshot for
   * `endDate` yet and the response was built from the latest available
   * snapshot. None when no snapshot data exists at all OR when the only
   * available fallback predates `startDate` (in which case the response
   * is forced to zero metrics rather than leaking pre-window cumulative state).
   */
  resolvedEndDate?: Maybe<Scalars['String']['output']>;
  revenue: Scalars['Float']['output'];
  roas: Scalars['Float']['output'];
  roi: Scalars['Float']['output'];
  shares: Scalars['Int']['output'];
  snapshotFreshness?: Maybe<Scalars['String']['output']>;
  snapshotTimezone?: Maybe<Scalars['String']['output']>;
  spent: Scalars['Float']['output'];
  startDate: Scalars['String']['output'];
  storiesCount: Scalars['Int']['output'];
  totalFollowers: Scalars['Int']['output'];
  videoCount: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
}

export interface GqlCampaignOutput {
  _id: Scalars['String']['output'];
  analyticsSummary?: Maybe<GqlCampaignAnalyticsSummaryOutput>;
  authCount: Scalars['Int']['output'];
  authGaMetrics: Array<GqlAuthGaMetricsOutput>;
  avatar?: Maybe<GqlMediaOutput>;
  /**
   * Display name of the owning brand/organization, sourced from the
   * organization profile (`OrganizationProfile.name`) — the same field the
   * `OrganizationOutput.profile.name` resolver surfaces. Batched per request
   * via `OrganizationProfileLoader` (single `$in` on `organizationId`), so a
   * campaign list avoids N+1. Returns `null` when the org has no profile yet.
   */
  brandName?: Maybe<Scalars['String']['output']>;
  budget: Scalars['Float']['output'];
  campaignType: Scalars['String']['output'];
  /**
   * Track C.5 — Shopify commerce summary for this campaign.
   * Brand-internal: returns `null` for creator viewers, for
   * callers lacking `CampaignPaymentsView`, and (defense-in-depth)
   * for callers whose session org doesn't match the campaign's
   * owner org. An org with no Shopify connection still gets an
   * all-zeros struct (not null).
   */
  commerceSummary?: Maybe<GqlCampaignCommerceSummaryOutput>;
  costConfig?: Maybe<GqlCampaignCostConfigOutput>;
  createdAt: Scalars['String']['output'];
  /** Default code expiry in days after mint (#9104). `null` = no campaign default. */
  defaultExpiryDays?: Maybe<Scalars['Int']['output']>;
  /**
   * Default per-creator-code redeem limit (#9104). `0` = unlimited.
   * `null` = no campaign default (mint uses the value supplied at mint time).
   */
  defaultRedeemLimit?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  excludedPostIds: Array<Scalars['String']['output']>;
  finishDate?: Maybe<Scalars['String']['output']>;
  gaConnection?: Maybe<GqlGaConnectionOutput>;
  gaConnectionId?: Maybe<Scalars['String']['output']>;
  gaMetricsLastUpdatedAt?: Maybe<Scalars['String']['output']>;
  gaReportItems: Array<GqlCampaignGaReportItemOutput>;
  hashtags: Array<Scalars['String']['output']>;
  /**
   * Imported influencer roster — populated only for historical campaigns
   * (`status = HISTORICAL`). `null` for every normal campaign.
   */
  historicalDetail?: Maybe<GqlHistoricalDetailOutput>;
  /**
   * Import lifecycle of a historical campaign — `null` for non-historical
   * campaigns. `null` on a historical campaign means a legacy import
   * (pre-dates this field); infer completeness from `historicalDetail`.
   */
  historicalImportStatus?: Maybe<GqlHistoricalImportStatusEnum>;
  /**
   * Human-readable warning from the last historical-import finalization —
   * e.g. no creators resolved. `null` = no warning.
   */
  historicalImportWarning?: Maybe<Scalars['String']['output']>;
  includedPostIds: Array<Scalars['String']['output']>;
  influencerAuthIds: Array<Scalars['String']['output']>;
  influencerAuths: Array<GqlAuth>;
  keywords: Array<Scalars['String']['output']>;
  /**
   * Per-creator tracking-link coverage (#686): how many of this campaign's
   * rostered creators have at least one *live* tracking link. Reads the same
   * active (non-deleted, non-Invite) link population as `link_health_summary`
   * (`list_active_for_health`), then counts *distinct* `authId`s that are in
   * the current roster and hold a non-`Disabled` link — see
   * `count_creators_with_live_link`. The roster intersection reuses
   * `influencer_auth_ids`, which is already redacted to the viewer's own
   * auths for creator viewers, so the number stays `<= authCount` and is
   * consistent in the creator view without a separate redaction branch.
   */
  linkCoverage: GqlCampaignLinkCoverageOutput;
  /**
   * Aggregate link-health summary for this campaign. Computed on-demand
   * from the materialized `healthStatus` fields on each
   * `CampaignAuthTaskLink` — no `link_health_checks` collection access.
   * Latency-friendly for list views.
   */
  linkHealthSummary: GqlCampaignLinkHealthSummaryOutput;
  mentions: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  offlineRevenue: Array<GqlCampaignOfflineRevenueOutput>;
  organizationId: Scalars['String']['output'];
  payments: Array<GqlCampaignPaymentOutput>;
  payouts: Array<GqlCampaignPayoutOutput>;
  primaryObjective: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  /**
   * Shopify promo codes attached to this campaign — minted via Marble or
   * mirrored from a brand-owned discount. Brand-internal: hidden from
   * creator viewers (the creator drawer surfaces only the code assigned
   * to that specific creator, via a separate read path). Batches across
   * the page via `CampaignPromoCodeLoader` (single `$in` on
   * `campaignId_1`). Includes retained `Revoked` history rows so the
   * admin UI can render lifecycle history; the FE filters by `status`
   * when only live codes are wanted.
   */
  promoCodes: Array<GqlCampaignPromoCodeOutput>;
  startDate?: Maybe<Scalars['String']['output']>;
  /**
   * Lifecycle status. `Setup` is the AI-fill entry state — Campaign
   * Detail renders `mode=draft-setup` while the agent is still
   * working; the user confirms via `markCampaignSetupReviewed`,
   * which transitions `Setup → Draft`.
   */
  status: GqlCampaignStatusEnum;
  /**
   * Commerce attribution target (#9104): connected Shopify store id.
   * `null` = no store linked.
   */
  storeId?: Maybe<Scalars['String']['output']>;
  /**
   * Per-campaign auto-sweep toggle (#712). When `false` the scheduled
   * `CampaignSweepWorker` skips this campaign; the on-demand `runCampaignSweep`
   * button is unaffected. Absent on legacy docs ⇒ `true`.
   */
  sweepEnabled: Scalars['Boolean']['output'];
  targetAudience: Scalars['String']['output'];
  targetReach?: Maybe<Scalars['Int']['output']>;
  totalExpectedDeliverables: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  utmId: Scalars['String']['output'];
  /**
   * Per-campaign UTM template override (Track D Phase 4b).
   * `null` means inherit workspace default at link-creation time.
   */
  utmTemplateId?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
}

/**
 * Pre-computed analytics summary stored on the Campaign document.
 * Lighter than CampaignAnalyticsOutput — omits cost/financial metrics.
 */
export interface GqlCampaignAnalyticsSummaryOutput {
  comments: Scalars['Int']['output'];
  cpc: Scalars['Float']['output'];
  cpe: Scalars['Float']['output'];
  /** Cost per order = spent / ga_purchases. 0.0 when there are no purchases. */
  cpo: Scalars['Float']['output'];
  cpv: Scalars['Float']['output'];
  emv: Scalars['Float']['output'];
  engagement: Scalars['Int']['output'];
  engagementRate?: Maybe<Scalars['Float']['output']>;
  gaClicks: Scalars['Int']['output'];
  gaPageviews: Scalars['Int']['output'];
  gaPurchases: Scalars['Int']['output'];
  gaRevenue: Scalars['Float']['output'];
  gaSessions: Scalars['Int']['output'];
  /**
   * Impressions (#465). PROXY: impressions ← the `engagement` aggregate
   * (likes + comments + shares). `null` when no engagement signal.
   */
  impressions?: Maybe<Scalars['Int']['output']>;
  likes: Scalars['Int']['output'];
  linkClicks: Scalars['Int']['output'];
  postsCount: Scalars['Int']['output'];
  /** Total reach (#465). PROXY: reach ← `views`. `null` when no view signal. */
  reach?: Maybe<Scalars['Int']['output']>;
  roi: Scalars['Float']['output'];
  shares: Scalars['Int']['output'];
  spent: Scalars['Float']['output'];
  storiesCount: Scalars['Int']['output'];
  totalFollowers: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  videoCount: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
}

/** Google Analytics metrics for a specific auth (influencer) within a campaign */
export interface GqlAuthGaMetricsOutput {
  _id: Scalars['String']['output'];
  authId: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  /** Number of clicks (sessions) from GA */
  clicks: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  /** End of the date range for these metrics */
  dateRangeEnd: Scalars['String']['output'];
  /** Start of the date range for these metrics */
  dateRangeStart: Scalars['String']['output'];
  gaConnectionId: Scalars['String']['output'];
  /** Number of page views from GA */
  pageviews: Scalars['Int']['output'];
  /** Number of purchase events */
  purchases: Scalars['Int']['output'];
  /** Total revenue from purchases */
  revenue: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlCampaignCommerceSummaryOutput {
  aov?: Maybe<Scalars['Int']['output']>;
  attributedRevenue: Scalars['Int']['output'];
  byCreator: Array<GqlCreatorCommercePerformanceOutput>;
  /** `null` when no generic-code rows exist on the campaign. */
  genericCodes?: Maybe<GqlGenericCodesCommercePerformanceOutput>;
  orderCount: Scalars['Int']['output'];
  pendingFx: Array<GqlPendingFxBucketOutput>;
  preliminaryRevenue: Scalars['Int']['output'];
  roas?: Maybe<Scalars['Float']['output']>;
  roi?: Maybe<Scalars['Float']['output']>;
  /**
   * Distinct settled orders whose FX rate has not yet resolved
   * or is terminally Unavailable (#445). Brand UI:
   * "{orderCount} confirmed + {unresolvedOrderCount} awaiting FX"
   * so the headline doesn't silently shift when a backfill tick
   * completes. Drill-down per currency lives in `pendingFx[]`.
   */
  unresolvedOrderCount: Scalars['Int']['output'];
}

/**
 * Per-creator slice. `auth: Auth!` non-null is enforced; rows with
 * `auth_id == None` (generic brand-wide codes) aggregate into
 * [`GenericCodesCommercePerformanceOutput`] instead.
 */
export interface GqlCreatorCommercePerformanceOutput {
  aov?: Maybe<Scalars['Int']['output']>;
  attributedRevenue: Scalars['Int']['output'];
  /**
   * `AuthId` hex. FE resolves to the full `Auth` via a separate
   * loader call — keeps this resolver leaf cheap.
   */
  authId: Scalars['ID']['output'];
  orderCount: Scalars['Int']['output'];
  preliminaryRevenue: Scalars['Int']['output'];
  roi?: Maybe<Scalars['Float']['output']>;
  /**
   * Distinct settled orders whose FX rate has not yet resolved
   * (Pending) or is terminally Unavailable (#445). Parallel to
   * `orderCount`; the brand UI renders both ("X confirmed + Y
   * awaiting FX") so the headline stops drifting when the FX
   * backfill ticks complete.
   */
  unresolvedOrderCount: Scalars['Int']['output'];
}

export interface GqlGenericCodesCommercePerformanceOutput {
  attributedRevenue: Scalars['Int']['output'];
  orderCount: Scalars['Int']['output'];
  preliminaryRevenue: Scalars['Int']['output'];
  /**
   * FX-unresolved settled orders attributed to generic codes —
   * see [`CreatorCommercePerformanceOutput::unresolved_order_count`].
   */
  unresolvedOrderCount: Scalars['Int']['output'];
}

/**
 * One currency bucket of orders the USD roll-up could not include.
 * `pending_count` resolves on a later FX backfill tick (provider
 * available, just queued); `unavailable_count` is terminal (provider
 * has no rate for this currency). FE shows them distinctly so a
 * brand UX doesn't promise "resolves soon" for a terminal currency.
 */
export interface GqlPendingFxBucketOutput {
  currency: Scalars['String']['output'];
  pendingCount: Scalars['Int']['output'];
  unavailableCount: Scalars['Int']['output'];
}

export interface GqlCampaignCostConfigOutput {
  cpc?: Maybe<Scalars['Float']['output']>;
  cpe?: Maybe<Scalars['Float']['output']>;
  cpv?: Maybe<Scalars['Float']['output']>;
  flatFee?: Maybe<Scalars['Float']['output']>;
}

/**
 * Phase A4 extends with `is_default` + `status` + `last_sync_at` +
 * `tracked_events`. ComplexObject resolvers hit `OrgGoogleAccountRepository`
 * and `GaTrackedEventRepository` registered via `.data()`.
 */
export interface GqlGaConnectionOutput {
  _id: Scalars['String']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  gaAccountId?: Maybe<Scalars['String']['output']>;
  gaAccountName?: Maybe<Scalars['String']['output']>;
  gaPropertyId?: Maybe<Scalars['String']['output']>;
  gaPropertyName?: Maybe<Scalars['String']['output']>;
  gaWebStreamId?: Maybe<Scalars['String']['output']>;
  gaWebStreamName?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this property is the default of its OWN linked account (#462).
   * See [`is_default_for_link`]. False for orphan / legacy pre-link rows.
   */
  isDefault: Scalars['Boolean']['output'];
  /**
   * Phase A (wiki#14): timestamp of the most recent worker sync. None for
   * legacy rows that have never been synced under the v2 worker.
   */
  lastSyncAt?: Maybe<Scalars['String']['output']>;
  measurementId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  /**
   * Link to the property's own `OrgGoogleAccount`. `None` for legacy
   * pre-#453 rows. The `status` resolver follows THIS link (not the
   * org-wide account) so orphan properties report their true health
   * instead of inheriting a sibling account's CONNECTED status (#459).
   */
  orgGoogleAccountId?: Maybe<Scalars['String']['output']>;
  /**
   * Status of the property's OWN account link, not the org-wide account.
   * See [`ga_property_status`] for the mapping rationale (#459).
   */
  status: GqlGqlGoogleAccountStatus;
  /**
   * Property's tracked events sorted by `(created_at ASC, _id ASC)` per
   * the cover index on `ga_tracked_events`. Empty list for legacy rows
   * pre-backfill. Spec §4.1.
   */
  trackedEvents: Array<GqlGaTrackedEventOutput>;
  updatedAt: Scalars['String']['output'];
  websiteUrl: Scalars['String']['output'];
}

export const GqlGqlGoogleAccountStatus = {
  Connected: 'CONNECTED',
  Disconnected: 'DISCONNECTED',
  NeedsReauth: 'NEEDS_REAUTH',
} as const;

export type GqlGqlGoogleAccountStatus =
  (typeof GqlGqlGoogleAccountStatus)[keyof typeof GqlGqlGoogleAccountStatus];
export interface GqlGaTrackedEventOutput {
  _id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pagePathFilter?: Maybe<Scalars['String']['output']>;
  pagePathOperator: GqlGqlGaPagePathOperator;
}

export const GqlGqlGaPagePathOperator = {
  Contains: 'CONTAINS',
  Exact: 'EXACT',
} as const;

export type GqlGqlGaPagePathOperator =
  (typeof GqlGqlGaPagePathOperator)[keyof typeof GqlGqlGaPagePathOperator];
export interface GqlCampaignGaReportItemOutput {
  _id: Scalars['String']['output'];
  authId?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dimensionName?: Maybe<Scalars['String']['output']>;
  dimensionValue?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  gaConnectionId?: Maybe<Scalars['String']['output']>;
  metricName: Scalars['String']['output'];
  metricValue: Scalars['Float']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
}

/**
 * Imported influencer roster for a historical campaign — `null` on the
 * campaign for every non-historical campaign.
 */
export interface GqlHistoricalDetailOutput {
  influencers: Array<GqlHistoricalInfluencerOutput>;
}

/** One influencer from a historical campaign's imported roster. */
export interface GqlHistoricalInfluencerOutput {
  /** Platform handle as imported (no leading @). */
  handle: Scalars['String']['output'];
  /** Creator platform: "instagram" | "tiktok" | "youtube" | "twitter". */
  platform: Scalars['String']['output'];
  /** Per-influencer promo code, if the import named one. */
  promoCode?: Maybe<Scalars['String']['output']>;
  /** Resolved Marble auth id (hex). `null` = unresolved (creator not tracked). */
  resolvedAuthId?: Maybe<Scalars['String']['output']>;
}

export const GqlHistoricalImportStatusEnum = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Pending: 'PENDING',
} as const;

export type GqlHistoricalImportStatusEnum =
  (typeof GqlHistoricalImportStatusEnum)[keyof typeof GqlHistoricalImportStatusEnum];
/**
 * Per-creator tracking-link coverage for a campaign (#686).
 *
 * Answers "how many of this campaign's rostered creators have at least one
 * *live* tracking link?" — the metric the admin Case-study readiness row
 * uses. Distinct from `CampaignLinkHealthSummaryOutput`, which counts *links*
 * (and their health) rather than *creators covered*. A creator may hold
 * several links; here they count once.
 *
 * - `auth_count` mirrors `CampaignOutput.authCount` (the campaign roster
 * size) so the FE can render `covered / roster (pct)` without a second
 * field read.
 * - `creators_with_live_link` is the count of distinct `authId`s that (a) are
 * in the current roster and (b) have a live link, and is therefore always
 * `<= auth_count` (no false >100% coverage). See [`count_creators_with_live_link`]
 * for the exact "live" predicate.
 */
export interface GqlCampaignLinkCoverageOutput {
  /** Campaign roster size — mirrors `CampaignOutput.authCount`. */
  authCount: Scalars['Int']['output'];
  /** Distinct rostered creators (`authId`) that have at least one live link. */
  creatorsWithLiveLink: Scalars['Int']['output'];
}

export interface GqlCampaignLinkHealthSummaryOutput {
  brokenLinks: Scalars['Int']['output'];
  healthyLinks: Scalars['Int']['output'];
  lastCheckedAt?: Maybe<Scalars['String']['output']>;
  /**
   * Snapshot of the `campaign_link_health_events` broadcaster sequence
   * at query time (#279). FE persists this and applies the standard
   * `seq > serverSeq` filter to incoming `campaignLinkHealthEvents` to
   * drop already-applied events. Mutations + non-realtime call sites
   * leave it at `0`; the `linkHealthSummary` resolver overrides before
   * returning.
   */
  serverSeq: Scalars['Int']['output'];
  totalLinks: Scalars['Int']['output'];
  uncheckedLinks: Scalars['Int']['output'];
  warningLinks: Scalars['Int']['output'];
}

export interface GqlCampaignOfflineRevenueOutput {
  _id: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  authId?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency: GqlCampaignPaymentCurrencyEnum;
  description?: Maybe<Scalars['String']['output']>;
  recordedByMemberId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
}

export const GqlCampaignPaymentCurrencyEnum = {
  Usd: 'USD',
} as const;

export type GqlCampaignPaymentCurrencyEnum =
  (typeof GqlCampaignPaymentCurrencyEnum)[keyof typeof GqlCampaignPaymentCurrencyEnum];
export interface GqlCampaignPaymentOutput {
  _id: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  authItems: Array<GqlCampaignPaymentAuthItemOutput>;
  availableOn?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency: GqlCampaignPaymentCurrencyEnum;
  fee: GqlCampaignPaymentFeeOutput;
  fromOrganizationId: Scalars['String']['output'];
  invoice?: Maybe<GqlCampaignInvoiceOutput>;
  payouts: Array<GqlCampaignPayoutOutput>;
  provider: GqlCampaignPaymentProviderEnum;
  status: GqlCampaignPaymentStatusEnum;
  updatedAt: Scalars['String']['output'];
}

export interface GqlCampaignPaymentAuthItemOutput {
  amount: Scalars['Float']['output'];
  authId: Scalars['String']['output'];
  currency: GqlCampaignPaymentCurrencyEnum;
}

export interface GqlCampaignPaymentFeeOutput {
  initialAmount: Scalars['Float']['output'];
  marbleFee?: Maybe<Scalars['Float']['output']>;
  stripeInvoiceFee?: Maybe<Scalars['Float']['output']>;
  stripePayoutFee?: Maybe<Scalars['Float']['output']>;
  totalAmount: Scalars['Float']['output'];
  totalFee?: Maybe<Scalars['Float']['output']>;
}

export interface GqlCampaignInvoiceOutput {
  _id: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  availableOn?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  campaignPaymentId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency: GqlCampaignPaymentCurrencyEnum;
  customerId: Scalars['String']['output'];
  innerId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  paymentUrl?: Maybe<Scalars['String']['output']>;
  provider: GqlCampaignPaymentProviderEnum;
  status: GqlCampaignInvoiceStatusEnum;
  statusMessage?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
}

export const GqlCampaignPaymentProviderEnum = {
  Offline: 'OFFLINE',
  Paypal: 'PAYPAL',
  Stripe: 'STRIPE',
} as const;

export type GqlCampaignPaymentProviderEnum =
  (typeof GqlCampaignPaymentProviderEnum)[keyof typeof GqlCampaignPaymentProviderEnum];
export const GqlCampaignInvoiceStatusEnum = {
  Draft: 'DRAFT',
  Open: 'OPEN',
  Paid: 'PAID',
  Processing: 'PROCESSING',
  Uncollectible: 'UNCOLLECTIBLE',
  Void: 'VOID',
} as const;

export type GqlCampaignInvoiceStatusEnum =
  (typeof GqlCampaignInvoiceStatusEnum)[keyof typeof GqlCampaignInvoiceStatusEnum];
export interface GqlCampaignPayoutOutput {
  _id: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  authId: Scalars['String']['output'];
  availableOn?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency: GqlCampaignPaymentCurrencyEnum;
  fromOrganizationId: Scalars['String']['output'];
  paymentDetailsId?: Maybe<Scalars['String']['output']>;
  paymentId: Scalars['String']['output'];
  provider: GqlCampaignPaymentProviderEnum;
  status: GqlCampaignPayoutStatusEnum;
  statusMessage?: Maybe<Scalars['String']['output']>;
  toOrganizationId: Scalars['String']['output'];
  transactionInnerId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
}

export const GqlCampaignPayoutStatusEnum = {
  Canceled: 'CANCELED',
  Failed: 'FAILED',
  InTransit: 'IN_TRANSIT',
  Paid: 'PAID',
  Pending: 'PENDING',
  Processing: 'PROCESSING',
} as const;

export type GqlCampaignPayoutStatusEnum =
  (typeof GqlCampaignPayoutStatusEnum)[keyof typeof GqlCampaignPayoutStatusEnum];
export const GqlCampaignPaymentStatusEnum = {
  Failed: 'FAILED',
  Paid: 'PAID',
  Pending: 'PENDING',
  Processing: 'PROCESSING',
} as const;

export type GqlCampaignPaymentStatusEnum =
  (typeof GqlCampaignPaymentStatusEnum)[keyof typeof GqlCampaignPaymentStatusEnum];
/**
 * `CampaignPromoCode` as seen through the API.
 *
 * Two deliberate divergences from the spec's GraphQL block
 * (`docs/modules/integrations/shopify-promocode-mirror.md`, lines 163-179):
 * - **`auth_id: ID` instead of `auth: Auth`** — the FE gets a foreign key
 * only; resolving to a full `Auth` node (via DataLoader) is a follow-up
 * when the `Campaign.promoCodes` resolver ships in B.5.
 * - **Money fields are `Int`** (minor currency units / basis points), not
 * `Float`. The whole-codebase money convention is i64; FE divides at
 * display time. Spec wording is aspirational — track convention wins.
 */
export interface GqlCampaignPromoCodeOutput {
  appliesTo: GqlAppliesToGql;
  /**
   * The creator this promo code is assigned to (handle, source, avatar),
   * resolved from the scalar `authId`. `null` for a generic brand-wide code.
   *
   * Loaded through the shared [`AuthLoader`] `DataLoader` (the same batched
   * source backing every other `auth { username avatar { url } }` resolver),
   * so resolving a list of promo codes issues a single batched `$in` auth
   * query — no N+1 — and the result is per-request cached.
   */
  auth?: Maybe<GqlAuth>;
  /** `null` for a generic brand-wide code. */
  authId?: Maybe<Scalars['ID']['output']>;
  campaignId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  discountType: GqlDiscountTypeGql;
  /** Basis points (`Percentage`) or minor currency units (`FixedAmount`). */
  discountValue: Scalars['Int']['output'];
  endsAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxUses?: Maybe<Scalars['Int']['output']>;
  onePerCustomer: Scalars['Boolean']['output'];
  origin: GqlPromoCodeOriginGql;
  redemptionCount: Scalars['Int']['output'];
  /** Minor currency units; populated by Track C as orders settle. */
  revenueAttributed: Scalars['Int']['output'];
  shopifyStoreId: Scalars['ID']['output'];
  /** RFC 3339 string; `null` when unset. */
  startsAt?: Maybe<Scalars['String']['output']>;
  status: GqlPromoCodeStatusGql;
  updatedAt: Scalars['String']['output'];
}

export const GqlAppliesToGql = {
  All: 'ALL',
  OneTime: 'ONE_TIME',
  Subscription: 'SUBSCRIPTION',
} as const;

export type GqlAppliesToGql =
  (typeof GqlAppliesToGql)[keyof typeof GqlAppliesToGql];
export const GqlDiscountTypeGql = {
  FixedAmount: 'FIXED_AMOUNT',
  Percentage: 'PERCENTAGE',
} as const;

export type GqlDiscountTypeGql =
  (typeof GqlDiscountTypeGql)[keyof typeof GqlDiscountTypeGql];
export const GqlPromoCodeOriginGql = {
  Minted: 'MINTED',
  Mirrored: 'MIRRORED',
} as const;

export type GqlPromoCodeOriginGql =
  (typeof GqlPromoCodeOriginGql)[keyof typeof GqlPromoCodeOriginGql];
export const GqlPromoCodeStatusGql = {
  Active: 'ACTIVE',
  Disabled: 'DISABLED',
  Expired: 'EXPIRED',
  Revoked: 'REVOKED',
} as const;

export type GqlPromoCodeStatusGql =
  (typeof GqlPromoCodeStatusGql)[keyof typeof GqlPromoCodeStatusGql];
export const GqlCampaignStatusEnum = {
  Active: 'ACTIVE',
  Canceled: 'CANCELED',
  Draft: 'DRAFT',
  Finished: 'FINISHED',
  Historical: 'HISTORICAL',
  Setup: 'SETUP',
} as const;

export type GqlCampaignStatusEnum =
  (typeof GqlCampaignStatusEnum)[keyof typeof GqlCampaignStatusEnum];
export interface GqlCampaignAuthTaskLinkOutput {
  _id: Scalars['String']['output'];
  authId: Scalars['String']['output'];
  authTaskId?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  clicks: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  gaPropertyId?: Maybe<Scalars['String']['output']>;
  /** RFC3339 timestamp of the health check that last updated `healthStatus`. */
  healthCheckedAt?: Maybe<Scalars['String']['output']>;
  /**
   * Latest materialized overall health status for this link. `None` when
   * the link has never been checked by the health worker.
   */
  healthStatus?: Maybe<GqlLinkOverallStatusOutput>;
  isCustomLink: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  /**
   * Full detail of the latest `LinkHealthCheck` record (reachability +
   * optional GA check). Loaded via DataLoader — one DB round-trip per
   * batch. `None` when the link has never been checked.
   */
  lastCheck?: Maybe<GqlLinkHealthCheckOutput>;
  /** RFC3339 timestamp of the most recent click; `null` for never-clicked links. */
  lastClickAt?: Maybe<Scalars['String']['output']>;
  longUrl: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  resolvedUtm?: Maybe<GqlResolvedUtmOutput>;
  shortUrl: Scalars['String']['output'];
  source?: Maybe<GqlGraphqlLinkSource>;
  status?: Maybe<GqlGraphqlLinkStatus>;
  templateId?: Maybe<Scalars['String']['output']>;
  /**
   * Approximate distinct-visitor count for this link (#539). `null` for
   * legacy/never-clicked links (no unique data yet); otherwise the size of
   * the salted-hash set, saturating at the server-side cap (e.g. 5000 → FE
   * renders "5000+"). Deliberately approximate; the underlying hashes are
   * never exposed, only this count.
   */
  uniqueClicks?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
}

export const GqlLinkOverallStatusOutput = {
  Broken: 'BROKEN',
  Healthy: 'HEALTHY',
  Warning: 'WARNING',
} as const;

export type GqlLinkOverallStatusOutput =
  (typeof GqlLinkOverallStatusOutput)[keyof typeof GqlLinkOverallStatusOutput];
export interface GqlLinkHealthCheckOutput {
  /** Always `None` in Phase 1 — populated when compliance module ships. */
  compliance?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  /**
   * GA tag check for this link's eTLD+1 group. `None` when no GA
   * connection was configured or this link's domain group did not run
   * Check 2.
   */
  gaCheck?: Maybe<GqlCampaignGaTagCheckOutput>;
  id: Scalars['String']['output'];
  overallStatus: GqlLinkOverallStatusOutput;
  reachability: GqlReachabilityResultOutput;
}

export interface GqlCampaignGaTagCheckOutput {
  capturedRequestsSummary: Array<GqlCapturedGaRequestOutput>;
  createdAt: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measurementIdExpected?: Maybe<Scalars['String']['output']>;
  measurementIdFound?: Maybe<Scalars['String']['output']>;
  scrapperFinalUrl?: Maybe<Scalars['String']['output']>;
  scrapperVersion?: Maybe<Scalars['String']['output']>;
  status: GqlGaTagCheckStatusOutput;
}

export interface GqlCapturedGaRequestOutput {
  host: Scalars['String']['output'];
  path: Scalars['String']['output'];
  statusCode?: Maybe<Scalars['Int']['output']>;
  tid?: Maybe<Scalars['String']['output']>;
}

export const GqlGaTagCheckStatusOutput = {
  BotBlocked: 'BOT_BLOCKED',
  ConsentBlocked: 'CONSENT_BLOCKED',
  GaTagNotFiring: 'GA_TAG_NOT_FIRING',
  Healthy: 'HEALTHY',
  MeasurementIdNotConfigured: 'MEASUREMENT_ID_NOT_CONFIGURED',
  ScrapperError: 'SCRAPPER_ERROR',
  ScrapperProtocolViolation: 'SCRAPPER_PROTOCOL_VIOLATION',
  ScrapperVersionTooLow: 'SCRAPPER_VERSION_TOO_LOW',
  WrongProperty: 'WRONG_PROPERTY',
} as const;

export type GqlGaTagCheckStatusOutput =
  (typeof GqlGaTagCheckStatusOutput)[keyof typeof GqlGaTagCheckStatusOutput];
export interface GqlReachabilityResultOutput {
  errorMessage?: Maybe<Scalars['String']['output']>;
  finalUrl?: Maybe<Scalars['String']['output']>;
  httpCode?: Maybe<Scalars['Int']['output']>;
  redirectCount?: Maybe<Scalars['Int']['output']>;
  responseTimeMs?: Maybe<Scalars['Int']['output']>;
  status: GqlReachabilityStatusOutput;
}

export const GqlReachabilityStatusOutput = {
  Broken: 'BROKEN',
  DnsError: 'DNS_ERROR',
  Healthy: 'HEALTHY',
  RedirectLoop: 'REDIRECT_LOOP',
  SslError: 'SSL_ERROR',
  SsrfBlocked: 'SSRF_BLOCKED',
  Timeout: 'TIMEOUT',
} as const;

export type GqlReachabilityStatusOutput =
  (typeof GqlReachabilityStatusOutput)[keyof typeof GqlReachabilityStatusOutput];
/**
 * Frozen UTM tuple snapshot. Stored once at link-creation time;
 * editing the source `UtmTemplate` does NOT rewrite this.
 */
export interface GqlResolvedUtmOutput {
  campaign: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  medium: Scalars['String']['output'];
  source: Scalars['String']['output'];
  term?: Maybe<Scalars['String']['output']>;
}

/** Provenance of a tracking link. */
export const GqlGraphqlLinkSource = {
  Ga: 'GA',
  /**
   * A marble short link wrapping a task invite URL (#497). Surfaced for
   * completeness; invite links are excluded from the brand tracking-link list
   * so this variant is not expected on tracking-link query results.
   */
  Invite: 'INVITE',
  /** A genuine one-off, ad-hoc user link (#683). Never reconciled. */
  Manual: 'MANUAL',
  /** Provisioned from a task-template `TemplateLink` at apply (#507). */
  Template: 'TEMPLATE',
  /**
   * The source-derived campaign-website / added-website link (#683).
   * Managed by template apply (created/retired as the website target
   * changes). Split out of the historical overloaded `Manual`.
   */
  Website: 'WEBSITE',
} as const;

export type GqlGraphqlLinkSource =
  (typeof GqlGraphqlLinkSource)[keyof typeof GqlGraphqlLinkSource];
/**
 * Lifecycle status of a tracking link. Disabled links return
 * `404` (or `410`, TBD) at redirect time and are excluded from
 * link-health checks.
 */
export const GqlGraphqlLinkStatus = {
  Active: 'ACTIVE',
  Disabled: 'DISABLED',
} as const;

export type GqlGraphqlLinkStatus =
  (typeof GqlGraphqlLinkStatus)[keyof typeof GqlGraphqlLinkStatus];
export interface GqlCampaignAuthTaskOutput {
  _id: Scalars['String']['output'];
  /** Activity timeline — append-only event history for this task. */
  activityTimeline: Array<GqlCampaignTaskTimelineEventOutput>;
  auth: GqlAuth;
  authId: Scalars['String']['output'];
  campaign: GqlCampaignOutput;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  creatorOrganizationId?: Maybe<Scalars['String']['output']>;
  deadline?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Track E Stage 1 — the active (non-Cancelled) gift attached to
   * this task. `None` when no gift exists or the only prior gift
   * was Cancelled. Authorization rides on whoever loaded the
   * parent `CampaignAuthTaskOutput`: a brand caller sees their
   * own org's gift; a creator caller via the secret-link view
   * sees the gift attached to the task they're authorized for.
   * The repo lookup itself is partial-unique-keyed on
   * `campaign_auth_task_id` so cross-org leakage is structurally
   * impossible — a gift always sits under its task's org.
   */
  gift?: Maybe<GqlCampaignGift>;
  isClaimed: Scalars['Boolean']['output'];
  links: Array<GqlCampaignAuthTaskLinkOutput>;
  organizationPaymentDetails?: Maybe<GqlOrganizationPaymentDetailsOutput>;
  /** Paid Media Rights (#157) — greenlit for paid amplification. */
  paidMediaRights: Scalars['Boolean']['output'];
  /** Human-readable rights duration, e.g. "3 months", "perpetual". */
  paidMediaRightsDuration?: Maybe<Scalars['String']['output']>;
  /**
   * Additional fee for paid-media usage rights, in USD minor units (cents),
   * e.g. `150000` = $1500.00, `0` = inclusive/bundled. `None` when not
   * negotiated. Exposed as a GraphQL `Int` (not `Float` dollars) so the
   * amount is exact.
   */
  paidMediaRightsFee?: Maybe<Scalars['Int']['output']>;
  /** Platforms the rights cover, e.g. `["meta", "tiktok", "google"]`. */
  paidMediaRightsPlatforms: Array<Scalars['String']['output']>;
  paymentOptions: GqlCampaignAuthTaskPaymentOptionsOutput;
  postCount: Scalars['Int']['output'];
  secret: Scalars['String']['output'];
  status: GqlCampaignAuthTaskStatusEnum;
  storyCount: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  videoCount: Scalars['Int']['output'];
}

export interface GqlCampaignAuthTaskOutputActivityTimelineArgs {
  limit?: Scalars['Int']['input'];
}

/** A single event in a campaign task's activity timeline. */
export interface GqlCampaignTaskTimelineEventOutput {
  actorId?: Maybe<Scalars['String']['output']>;
  actorType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
  sequence: Scalars['Int']['output'];
}

/**
 * The gift as seen through the API. The `shipping_address` is
 * deliberately omitted — creator PII never leaves the storage layer
 * through this surface; the brand sees only that an address was
 * submitted (via `address_submitted_at`).
 */
export interface GqlCampaignGift {
  /** RFC3339. */
  addressSubmittedAt?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  /** RFC3339. */
  fulfilledAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineItems: Array<GqlGiftLineItem>;
  note?: Maybe<Scalars['String']['output']>;
  /** RFC3339. */
  orderedAt?: Maybe<Scalars['String']['output']>;
  status: GqlGiftStatus;
  tracking?: Maybe<GqlGiftTracking>;
}

export interface GqlGiftLineItem {
  /** Shopify product GID (e.g. `gid://shopify/Product/123`). */
  productId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  /**
   * Product title at attach time — a snapshot so a later catalog
   * edit does not rewrite gift history.
   */
  title: Scalars['String']['output'];
  /**
   * Variant label snapshot (e.g. `"M / Black"`); `None` for
   * single-variant products.
   */
  variant?: Maybe<Scalars['String']['output']>;
  /** Shopify variant GID — the unit actually ordered. */
  variantId: Scalars['ID']['output'];
}

/**
 * 8-state lifecycle exposed to the API as SCREAMING_SNAKE_CASE
 * variants (GraphQL convention). The `Unknown` domain variant is
 * deliberately omitted from this enum: a forward-compat doc written
 * by a newer binary should not surface as a wire variant on a
 * Stage-1 client — the resolver maps `Unknown` to `Failed` (the
 * safest fallback) and the row stays inert. Mirrors how Track B's
 * `PromoCodeStatus` keeps its forward-compat variant out of the
 * public enum.
 */
export const GqlGiftStatus = {
  AddressSubmitted: 'ADDRESS_SUBMITTED',
  Cancelled: 'CANCELLED',
  Draft: 'DRAFT',
  Failed: 'FAILED',
  Fulfilled: 'FULFILLED',
  Ordered: 'ORDERED',
  Ordering: 'ORDERING',
  PendingAddress: 'PENDING_ADDRESS',
} as const;

export type GqlGiftStatus = (typeof GqlGiftStatus)[keyof typeof GqlGiftStatus];
export interface GqlGiftTracking {
  carrier?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface GqlOrganizationPaymentDetailsOutput {
  _id: Scalars['ID']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  dashboardLink?: Maybe<Scalars['String']['output']>;
  isReadyToReceivePayments?: Maybe<Scalars['Boolean']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  onboardingLink?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  paymentProvider: GqlCampaignPaymentProviderEnum;
  payoutAccountInnerId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlCampaignAuthTaskPaymentOptionsOutput {
  commission?: Maybe<Scalars['Float']['output']>;
  flatFee?: Maybe<Scalars['Float']['output']>;
  gift?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<GqlCampaignPaymentTermsEnum>;
}

export const GqlCampaignPaymentTermsEnum = {
  AllAfterCompletion: 'ALL_AFTER_COMPLETION',
  AllBeforeStart: 'ALL_BEFORE_START',
} as const;

export type GqlCampaignPaymentTermsEnum =
  (typeof GqlCampaignPaymentTermsEnum)[keyof typeof GqlCampaignPaymentTermsEnum];
export const GqlCampaignAuthTaskStatusEnum = {
  Accepted: 'ACCEPTED',
  Done: 'DONE',
  Draft: 'DRAFT',
  InProgress: 'IN_PROGRESS',
  Rejected: 'REJECTED',
  Review: 'REVIEW',
  Sent: 'SENT',
} as const;

export type GqlCampaignAuthTaskStatusEnum =
  (typeof GqlCampaignAuthTaskStatusEnum)[keyof typeof GqlCampaignAuthTaskStatusEnum];
export interface GqlAuthCollaborationOutput {
  _id?: Maybe<Scalars['String']['output']>;
  authId: Scalars['String']['output'];
  collaborationType: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  lastPostDate?: Maybe<Scalars['String']['output']>;
  partnerAuthId: Scalars['String']['output'];
  /**
   * Partner brand's avatar URL (e.g. their IG avatar), or `null` when the
   * partner auth has no avatar.
   *
   * Resolved by loading the partner `Auth` through the shared [`AuthLoader`]
   * `DataLoader` — the same batched source that backs a creator's
   * `avatar.url`. Resolving a creator's full `collaborations` list therefore
   * issues a single batched `$in` auth query (no N+1), and the loaded auth
   * is per-request cached. The avatar `Media` is run through the same
   * CloudFront signing path used everywhere else for media URLs.
   */
  partnerAvatar?: Maybe<Scalars['String']['output']>;
  /**
   * Partner brand's display name (`full_name`), or `null` when unset.
   *
   * Comes free from the same [`AuthLoader`] fetch used by `partner_avatar`
   * (no extra round-trip): both fields share the loader's per-request cache.
   */
  partnerDisplayName?: Maybe<Scalars['String']['output']>;
  partnerSource: GqlAuthSource;
  partnerUsername: Scalars['String']['output'];
  /**
   * Number of this creator's posts attributed to the partner brand.
   *
   * #531 — single source of truth: this is a LIVE count over `service_post`
   * using the SAME predicate as the collaboration drill-down feed
   * (`GetAuthFeedUseCase::count` → `PostRepository::count_by_auth` →
   * `build_auth_feed_filters`), NOT the stored AI-detection snapshot. So the
   * badge count equals the drill-down list length by construction: a
   * collaboration whose attributed posts are not in the queryable feed
   * (phantom snapshot) reports 0 and the UI renders it as "Declared" instead
   * of expanding into "No posts found".
   *
   * All other collaboration metadata (partner, confidence, type, last post
   * date) still comes from the stored snapshot. If the live count cannot be
   * computed we degrade to the stored snapshot rather than failing the query.
   */
  postCount: Scalars['Int']['output'];
}

export const GqlAuthSource = {
  Instagram: 'instagram',
  Shopify: 'shopify',
  ShopifyAttached: 'shopify_attached',
  Spotify: 'spotify',
  Tiktok: 'tiktok',
  Twitch: 'twitch',
  Twitter: 'twitter',
  Youtube: 'youtube',
} as const;

export type GqlAuthSource = (typeof GqlAuthSource)[keyof typeof GqlAuthSource];
export interface GqlContentCategoryOutput {
  slug: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
}

export interface GqlAuthCreatorStatusOutput {
  _id: Scalars['String']['output'];
  authId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  status?: Maybe<GqlRelationshipStatus>;
  updatedAt: Scalars['String']['output'];
}

/**
 * Workspace-level CRM annotation per `(org, auth)`. Wire names use the
 * canonical camelCase form — same as the Mongo storage and the playground.
 * The GraphQL type is named `RelationshipStatus` regardless of the Rust
 * `…Output` suffix so the schema matches the design doc (and external
 * codegen sees a clean name).
 */
export const GqlRelationshipStatus = {
  Active: 'active',
  Declined: 'declined',
  Excluded: 'excluded',
  Negotiating: 'negotiating',
  Past: 'past',
  Prospect: 'prospect',
  ReachedOut: 'reachedOut',
} as const;

export type GqlRelationshipStatus =
  (typeof GqlRelationshipStatus)[keyof typeof GqlRelationshipStatus];
/**
 * Deep lookup job output — tracks pipeline execution status and metadata.
 * Content insights (deep_summary, content_analysis, ftc_compliance) have been
 * consolidated onto Auth and are no longer exposed here. See Auth fields:
 * postingThemes, narrativeStyle, brandFitAssessment, deepSummary,
 * sponsoredContentStyle, audienceGeoHint, ftcStatus, ftcSponsoredPostsCount,
 * ftcDisclosedCount, ftcSummary, contentCategories.
 */
export interface GqlDeepLookupOutput {
  _id?: Maybe<Scalars['String']['output']>;
  authId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  crossLinksCreated: Scalars['Int']['output'];
  discoveredLinksCount: Scalars['Int']['output'];
  discoveredProfiles: Array<GqlDiscoveredProfileOutput>;
  error?: Maybe<Scalars['String']['output']>;
  postsFetched: Scalars['Int']['output'];
  scrapedPagesCount: Scalars['Int']['output'];
  status: GqlDeepLookupStatusOutput;
  statusMessage?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  webSearchResultsCount: Scalars['Int']['output'];
}

export interface GqlDiscoveredProfileOutput {
  authId?: Maybe<Scalars['String']['output']>;
  discoveredVia: Scalars['String']['output'];
  indexed: Scalars['Boolean']['output'];
  /**
   * Stable textual platform identifier — `"instagram"`, `"facebook"`,
   * `"threads"`, `"linkedin"`, etc. Always populated.
   */
  platformLabel: Scalars['String']['output'];
  postsFetched: Scalars['Int']['output'];
  /**
   * Indexable creator-graph source. `null` when the evidence lives on a
   * platform we don't index (Facebook/Threads/LinkedIn/personal sites).
   * Frontend should fall back to `platformLabel` for display in that
   * case. Nullable as of the evidence-vs-cross-link split (2026-06-02).
   */
  source?: Maybe<GqlAuthSource>;
  username: Scalars['String']['output'];
}

export const GqlDeepLookupStatusOutput = {
  Analyzing: 'analyzing',
  Completed: 'completed',
  /** Terminal partial-success (#203): data collected, LLM analysis failed. */
  CompletedWithErrors: 'completed_with_errors',
  DiscoveringProfiles: 'discovering_profiles',
  ExtractingLinks: 'extracting_links',
  Failed: 'failed',
  FetchingPosts: 'fetching_posts',
  Pending: 'pending',
  Scraping: 'scraping',
  Searching: 'searching',
} as const;

export type GqlDeepLookupStatusOutput =
  (typeof GqlDeepLookupStatusOutput)[keyof typeof GqlDeepLookupStatusOutput];
/**
 * #741 — both discovered-index lanes of a creator, side by side.
 *
 * This is the per-lane state the FE needs to stop rendering an ENRICHED
 * discovered creator as un-indexed: `auth.status` stays `not_indexed` for them
 * (truthfully — they have no deep index), so `discovered && profile == READY`
 * is what distinguishes "a real profile we discovered" from "a bare stub".
 *
 * All-`PENDING` for every creator who was never discovered.
 */
export interface GqlDiscoveredIndex {
  /** The operator-triggered full deep index (posts, analytics, summary). */
  deep: GqlDiscoveredIndexLaneState;
  /** The sweep's one-shot profile enrichment (shell → real profile). */
  profile: GqlDiscoveredIndexLaneState;
}

/**
 * #741 — state of ONE discovered-index lane, resolved against that lane's
 * lease and attempt ceiling.
 */
export const GqlDiscoveredIndexLaneState = {
  /**
   * A claim lapsed without settling and the attempt ceiling is spent.
   * Nothing retries this lane on its own.
   */
  Exhausted: 'EXHAUSTED',
  /** A claim is held and its lease is live: work is running right now. */
  InProgress: 'IN_PROGRESS',
  /** Settled: the platform account no longer resolves. Terminal. */
  NotFound: 'NOT_FOUND',
  /** Never claimed, or a lapsed claim with attempts left — still owed. */
  Pending: 'PENDING',
  /** Settled: this lane produced a real profile. */
  Ready: 'READY',
} as const;

export type GqlDiscoveredIndexLaneState =
  (typeof GqlDiscoveredIndexLaneState)[keyof typeof GqlDiscoveredIndexLaneState];
export interface GqlAuthGroupOutput {
  _id: Scalars['String']['output'];
  authCount: Scalars['Int']['output'];
  authIds: Array<Scalars['String']['output']>;
  authInnerIds: Array<Scalars['String']['output']>;
  auths: Array<GqlAuth>;
  createdAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlPostOutput {
  _id: Scalars['String']['output'];
  attachments: Array<GqlPostAttachmentOutput>;
  attachmentsProcessed: Scalars['Boolean']['output'];
  audioAnalysis?: Maybe<GqlPostAudioAnalysisOutput>;
  authId: Scalars['String']['output'];
  authInnerId?: Maybe<Scalars['String']['output']>;
  belongToCoAuthor: Scalars['Boolean']['output'];
  coAuthorInnerIds: Array<Scalars['String']['output']>;
  /** Per-post collaboration label (brand_deal/content_collab/mention). */
  collaborationType?: Maybe<GqlCollaborationTypeEnum>;
  createdAt: Scalars['String']['output'];
  customEngagement?: Maybe<GqlPostCustomEngagementOutput>;
  engagement?: Maybe<GqlPostEngagementOutput>;
  /**
   * Per-post historical engagement/ER time-series over `period` (#466),
   * sourced from the existing daily `auth_analytics` snapshots' `postBucket`.
   *
   * `period` is optional; omitted → the last
   * [`ENGAGEMENT_HISTORY_DEFAULT_DAYS`] days (matches
   * `AUTH_ANALYTICS_AVERAGE_DAYS_COUNT`). Returns `[]` (never an error) when
   * the post has no `auth_inner_id`, when there are no snapshots in range, or
   * when the loader fails — so it can never break the surrounding feed.
   *
   * History is naturally sparse and windowed: `postBucket` only retains the
   * creator's recent posts, so a post's series truncates once it ages out of
   * the bucket. Days with no snapshot are gaps (not interpolated) — with ONE
   * exception (#720): the days between a post's publish date and its FIRST
   * real snapshot are filled with a synthesised, front-loaded curve, so a
   * post that predates its own tracking no longer renders as flat zeros and
   * a cliff. Those points are **estimates** and carry `provenance: synthetic`;
   * a measured point always wins over a synthesised one.
   */
  engagementHistory: Array<GqlPostEngagementHistoryPointOutput>;
  hashtags: Array<Scalars['String']['output']>;
  innerId: Scalars['String']['output'];
  keywords: Array<Scalars['String']['output']>;
  linkPreview?: Maybe<GqlLinkPreviewOutput>;
  location?: Maybe<Scalars['String']['output']>;
  mentions: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  postUrl?: Maybe<Scalars['String']['output']>;
  postUrlCta?: Maybe<Scalars['String']['output']>;
  source: GqlAuthSource;
  /** Availability at the original source (#550). `live` | `unavailable`. */
  sourceStatus: GqlSourceStatusEnum;
  type: GqlPostTypeEnum;
  updatedAt: Scalars['String']['output'];
  vectorized?: Maybe<Scalars['Boolean']['output']>;
  visualAnalysis?: Maybe<GqlPostVisualAnalysisOutput>;
}

export interface GqlPostOutputEngagementHistoryArgs {
  period?: InputMaybe<GqlDateRangeInput>;
}

export interface GqlPostAttachmentOutput {
  media: GqlMediaOutput;
  thumbnail: GqlMediaOutput;
}

export interface GqlPostAudioAnalysisOutput {
  analyzedAt: Scalars['String']['output'];
  transcript: Scalars['String']['output'];
}

/**
 * 3-layer brand-content taxonomy: a post's detected collaboration category.
 * Wire values mirror the domain serde renames (brand_deal/content_collab/mention).
 */
export const GqlCollaborationTypeEnum = {
  BrandDeal: 'brand_deal',
  ContentCollab: 'content_collab',
  Mention: 'mention',
} as const;

export type GqlCollaborationTypeEnum =
  (typeof GqlCollaborationTypeEnum)[keyof typeof GqlCollaborationTypeEnum];
export interface GqlPostCustomEngagementOutput {
  comments: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  likes: Scalars['Int']['output'];
  shares: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  views: Scalars['Int']['output'];
}

export interface GqlPostEngagementOutput {
  comments: Scalars['Int']['output'];
  likes: Scalars['Int']['output'];
  shares: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
}

export interface GqlDateRangeInput {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
}

/**
 * One point in a post's historical engagement/ER time-series (#466). Sourced
 * from a daily `auth_analytics` snapshot's `postBucket`; `date` is the snapshot
 * date (these are daily snapshots — time-of-day is noise, so `YYYY-MM-DD`).
 */
export interface GqlPostEngagementHistoryPointOutput {
  comments: Scalars['Int']['output'];
  /** Snapshot date, `YYYY-MM-DD`. */
  date: Scalars['String']['output'];
  /**
   * `(likes + comments) / followers * 100`, codebase convention (shares
   * excluded). `null` when the historical follower count was unknown/zero.
   */
  engagementRate?: Maybe<Scalars['Float']['output']>;
  /** Follower count on that date (the ER denominator). */
  followersCount: Scalars['Int']['output'];
  likes: Scalars['Int']['output'];
  /** Whether this point is measured or reconstructed before tracking began. */
  provenance: GqlPostEngagementHistoryPointProvenanceEnum;
  shares: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
}

export const GqlPostEngagementHistoryPointProvenanceEnum = {
  Measured: 'measured',
  Synthetic: 'synthetic',
} as const;

export type GqlPostEngagementHistoryPointProvenanceEnum =
  (typeof GqlPostEngagementHistoryPointProvenanceEnum)[keyof typeof GqlPostEngagementHistoryPointProvenanceEnum];
export interface GqlLinkPreviewOutput {
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  media?: Maybe<GqlMediaOutput>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
}

/**
 * Availability of a post at its original source (#550). `live` normally;
 * `unavailable` once a thumbnail self-heal finds the source post gone.
 */
export const GqlSourceStatusEnum = {
  Live: 'live',
  Unavailable: 'unavailable',
} as const;

export type GqlSourceStatusEnum =
  (typeof GqlSourceStatusEnum)[keyof typeof GqlSourceStatusEnum];
export const GqlPostTypeEnum = {
  Social: 'social',
  Story: 'story',
  Video: 'video',
} as const;

export type GqlPostTypeEnum =
  (typeof GqlPostTypeEnum)[keyof typeof GqlPostTypeEnum];
export interface GqlPostVisualAnalysisOutput {
  aesthetic: Array<GqlVisualAestheticOutput>;
  analyzedAt: Scalars['String']['output'];
  detectedBrands: Array<GqlDetectedVisualBrandOutput>;
  imagesAnalyzed: Scalars['Int']['output'];
  qualityScore?: Maybe<Scalars['Int']['output']>;
  safetyFlags: Array<GqlBrandSafetyFlagOutput>;
  themes: Array<GqlVisualThemeOutput>;
}

export const GqlVisualAestheticOutput = {
  Bright: 'BRIGHT',
  Casual: 'CASUAL',
  Clean: 'CLEAN',
  Dark: 'DARK',
  Luxury: 'LUXURY',
  Minimalist: 'MINIMALIST',
  Moody: 'MOODY',
  Natural: 'NATURAL',
  Professional: 'PROFESSIONAL',
  Raw: 'RAW',
  Vibrant: 'VIBRANT',
  Vintage: 'VINTAGE',
} as const;

export type GqlVisualAestheticOutput =
  (typeof GqlVisualAestheticOutput)[keyof typeof GqlVisualAestheticOutput];
export interface GqlDetectedVisualBrandOutput {
  brandName: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  detectionType: GqlVisualBrandDetectionTypeOutput;
}

export const GqlVisualBrandDetectionTypeOutput = {
  Logo: 'LOGO',
  Packaging: 'PACKAGING',
  Product: 'PRODUCT',
  Storefront: 'STOREFRONT',
} as const;

export type GqlVisualBrandDetectionTypeOutput =
  (typeof GqlVisualBrandDetectionTypeOutput)[keyof typeof GqlVisualBrandDetectionTypeOutput];
export const GqlVisualThemeOutput = {
  Art: 'ART',
  Automotive: 'AUTOMOTIVE',
  Beauty: 'BEAUTY',
  Family: 'FAMILY',
  Fashion: 'FASHION',
  Fitness: 'FITNESS',
  Food: 'FOOD',
  Lifestyle: 'LIFESTYLE',
  Luxury: 'LUXURY',
  Nature: 'NATURE',
  Other: 'OTHER',
  Pets: 'PETS',
  Product: 'PRODUCT',
  Selfie: 'SELFIE',
  Sports: 'SPORTS',
  Tech: 'TECH',
  Travel: 'TRAVEL',
  Urban: 'URBAN',
} as const;

export type GqlVisualThemeOutput =
  (typeof GqlVisualThemeOutput)[keyof typeof GqlVisualThemeOutput];
export interface GqlAuthNoteOutput {
  _id: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  authId: Scalars['String']['output'];
  campaignAuthNotes: Array<GqlCampaignAuthNoteOutput>;
  createdAt: Scalars['String']['output'];
  documentUrls: Array<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /**
   * Snapshot of the `auth_note_events` broadcaster sequence at query time
   * (#275 / ADR-002). FE filter: events with `seq > serverSeq` are applied
   * on top of this query result; events with `seq <= serverSeq` are
   * dropped (already reflected). Mutations return this field but its
   * value is not load-bearing — only the `auth_note` query response is
   * the canonical refetch anchor.
   */
  serverSeq: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlCampaignAuthNoteOutput {
  campaignId: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

/**
 * A brand the creator organically features, ranked as an organic
 * brand-partnership candidate. Derived from `VisualProfile::detected_brands`.
 */
export interface GqlOrganicBrandAffinityOutput {
  /** Combined detection-confidence × detection-type weight (0.0–1.0). */
  affinityScore: Scalars['Float']['output'];
  brandName: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  detectionType: GqlVisualBrandDetectionTypeOutput;
}

export interface GqlCampaignAuthOutreachOutput {
  status: GqlCampaignAuthOutreachStatusEnum;
}

export const GqlCampaignAuthOutreachStatusEnum = {
  Contacted: 'CONTACTED',
  Declined: 'DECLINED',
  Negotiating: 'NEGOTIATING',
  None: 'NONE',
  OnHold: 'ON_HOLD',
  Outreached: 'OUTREACHED',
  Signed: 'SIGNED',
} as const;

export type GqlCampaignAuthOutreachStatusEnum =
  (typeof GqlCampaignAuthOutreachStatusEnum)[keyof typeof GqlCampaignAuthOutreachStatusEnum];
export interface GqlPersonaOutput {
  /**
   * Count of currently-active F2 anomaly recommendations (status=Pending)
   * across this persona's Auths in the current workspace. Drives the
   * `Anomalies` badge in the CreatorDrawer sidebar — rendered only when
   * the count is > 0. Counts active items (a resolved or auto-aged
   * recommendation drops out), NOT the historical fact stream.
   */
  anomalyFlags: Scalars['Int']['output'];
  /** All member profiles (public data only, no PII). */
  auths: Array<GqlPersonaAuthSummaryOutput>;
  /**
   * Signed CDN URL for the persona avatar. The stored reference may be a
   * bare S3 key (post-migration) or a legacy-host URL; both are resolved
   * onto the live CDN (#477).
   */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  crossSummary?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  /**
   * External (clickable) links discovered across this persona's members,
   * grouped by the origin auth they were scraped from. A flat, origin-tagged
   * list: each group carries its `originAuthId` so the frontend can group or
   * render a single combined list. Aggregates over all member origins.
   */
  externalLinks: Array<GqlPersonaExternalLinkOriginOutput>;
  id: Scalars['String']['output'];
  /**
   * Workspace-scoped "Past with you" rollup — past campaigns this creator
   * has run with the current workspace and their average ROI (issue #439).
   * ROI follows Option 1:
   * `(offline_revenue + tracking_link_attributed_revenue) / paid_amount`,
   * per-campaign, averaged across the creator's past campaigns. Scoped to the
   * caller's organization so one workspace never sees another's figures.
   */
  pastWithYou: GqlPersonaPastWithYouOutput;
  /** Primary auth profile. */
  primaryAuth?: Maybe<GqlPersonaAuthSummaryOutput>;
  sources: Array<GqlAuthSource>;
  /** Total followers across all member auths (aggregated at query time). */
  totalFollowers: Scalars['Int']['output'];
}

/** Lightweight auth view exposed through Persona — no PII fields (phone, email). */
export interface GqlPersonaAuthSummaryOutput {
  /**
   * Signed CDN URL for the member avatar. Legacy-host URLs (#477) and bare
   * S3 keys are both rebuilt onto the live CDN via the shared resolver.
   */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Average comments per post over the 90-day window. `None` when no analytic snapshot exists. */
  averageComments?: Maybe<Scalars['Int']['output']>;
  /** Average likes per post over the 90-day window. `None` when no analytic snapshot exists. */
  averageLikes?: Maybe<Scalars['Int']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  followersCount?: Maybe<Scalars['Int']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isVerified: Scalars['Boolean']['output'];
  profileUrl?: Maybe<Scalars['String']['output']>;
  source: GqlAuthSource;
  summary?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
}

/**
 * External links grouped by the ORIGIN auth they were scraped from. Each
 * persona member contributes one group; the frontend can render a flat or
 * grouped list. `originAuthId` lets the frontend attribute links to a member.
 */
export interface GqlPersonaExternalLinkOriginOutput {
  /** Last time this origin's links were scraped (RFC 3339), if ever. */
  lastScrapedAt?: Maybe<Scalars['String']['output']>;
  links: Array<GqlPersonaExternalLinkOutput>;
  originAuthId: Scalars['String']['output'];
  originSource: GqlAuthSource;
  originUsername: Scalars['String']['output'];
}

/**
 * A single clickable external link surfaced on a persona.
 *
 * `source` is the indexable creator-graph platform — `null` when the link
 * points to a platform we don't cross-link (Spotify/Patreon/personal sites);
 * the frontend falls back to `platformLabel` for display in that case, mirroring
 * `DiscoveredProfileOutput.source`.
 */
export interface GqlPersonaExternalLinkOutput {
  /** How the link was discovered (bio, website, hub outbound, hub social). */
  discoveredVia: GqlPersonaExternalLinkSourceOutput;
  /** Human-readable platform label (e.g. "Spotify", "Patreon"), if known. */
  platformLabel?: Maybe<Scalars['String']['output']>;
  /** Indexable creator-graph source, or `null` for evidence-only platforms. */
  source?: Maybe<GqlAuthSource>;
  /** Normalized, safe (http/https) clickable URL. */
  url: Scalars['String']['output'];
  /** Username on the linked platform, if extractable. */
  username?: Maybe<Scalars['String']['output']>;
}

/**
 * Where a single external link was discovered, for display/grouping on the
 * frontend. Maps the domain `PersonaExternalLinkSource` discriminant.
 */
export const GqlPersonaExternalLinkSourceOutput = {
  /** Found directly in the account bio link list. */
  Bio: 'BIO',
  /** An outbound link harvested from a scraped link hub (Linktree etc.). */
  HubOutbound: 'HUB_OUTBOUND',
  /** A social-profile link surfaced by a scraped link hub. */
  HubSocialProfile: 'HUB_SOCIAL_PROFILE',
  /** The account's website field. */
  Website: 'WEBSITE',
} as const;

export type GqlPersonaExternalLinkSourceOutput =
  (typeof GqlPersonaExternalLinkSourceOutput)[keyof typeof GqlPersonaExternalLinkSourceOutput];
/**
 * Workspace-scoped "Past with you" rollup for the CreatorDrawer sidebar
 * (issue #439). Backs the stat grid of past campaigns the creator has run with
 * the current workspace.
 *
 * `On-time` from the design grid is intentionally not exposed yet: it needs a
 * per-task delivery timestamp (`completedAt` on `CampaignAuthTask`) the schema
 * does not carry.
 */
export interface GqlPersonaPastWithYouOutput {
  /**
   * Average per-campaign ROI, computed as
   * `(offline_revenue + tracking_link_attributed_revenue) / paid_amount`
   * (issue #439, Option 1). A multiplier — `1.5` renders as `1.5×`. `null`
   * when no past campaign has a paid amount (ROI undefined).
   */
  avgRoi?: Maybe<Scalars['Float']['output']>;
  /** Number of past campaigns the creator has run with this workspace. */
  campaigns: Scalars['Int']['output'];
}

/**
 * Aggregated outreach across the sibling auths of a persona, within one
 * campaign. Source of truth stays per-`Auth`; this is computed at read time
 * (issue #474). `None` when there is no sibling with a meaningful status.
 */
export interface GqlPersonaOutreachSummaryOutput {
  /**
   * Most decision-critical status across sibling platforms (e.g. show
   * "already Negotiating on another platform").
   */
  mostSignificantStatus: GqlCampaignAuthOutreachStatusEnum;
  /** Per-platform breakdown of the siblings (excludes this auth). */
  siblings: Array<GqlPersonaSiblingOutreachOutput>;
}

/**
 * One sibling auth's outreach status within a campaign, surfaced for the
 * cross-platform persona view (issue #474).
 */
export interface GqlPersonaSiblingOutreachOutput {
  _id: Scalars['String']['output'];
  source: GqlAuthSource;
  status: GqlCampaignAuthOutreachStatusEnum;
  username: Scalars['String']['output'];
}

/** Aggregated CRM relationship across the sibling auths of a persona. */
export interface GqlPersonaRelationshipSummaryOutput {
  mostSignificantStatus: GqlRelationshipStatus;
  siblings: Array<GqlPersonaSiblingRelationshipOutput>;
}

/**
 * One sibling auth's CRM relationship status, surfaced for the cross-platform
 * persona view (issue #474).
 */
export interface GqlPersonaSiblingRelationshipOutput {
  _id: Scalars['String']['output'];
  source: GqlAuthSource;
  status: GqlRelationshipStatus;
  username: Scalars['String']['output'];
}

/** A creator similar to the source auth, with cosine similarity score. */
export interface GqlSimilarCreatorOutput {
  auth: GqlAuth;
  /** Content categories shared between the source and this creator. */
  sharedCategories: Array<Scalars['String']['output']>;
  similarityScore: Scalars['Float']['output'];
}

export interface GqlVisualProfileOutput {
  analyzedAt: Scalars['String']['output'];
  detectedBrands: Array<GqlDetectedVisualBrandOutput>;
  imagesAnalyzed: Scalars['Int']['output'];
  visualAesthetic: Array<GqlVisualAestheticOutput>;
  visualConsistency?: Maybe<GqlVisualConsistencyOutput>;
  visualQualityScore?: Maybe<Scalars['Int']['output']>;
  visualSafetyFlags: Array<GqlBrandSafetyFlagOutput>;
  visualThemes: Array<GqlVisualThemeOutput>;
}

export const GqlVisualConsistencyOutput = {
  High: 'HIGH',
  Low: 'LOW',
  Medium: 'MEDIUM',
} as const;

export type GqlVisualConsistencyOutput =
  (typeof GqlVisualConsistencyOutput)[keyof typeof GqlVisualConsistencyOutput];
export const GqlGqlChatEntityType = {
  AiSearchHistory: 'AI_SEARCH_HISTORY',
  Auth: 'AUTH',
  AuthGroup: 'AUTH_GROUP',
  AuthNote: 'AUTH_NOTE',
  Campaign: 'CAMPAIGN',
  CampaignAuthTask: 'CAMPAIGN_AUTH_TASK',
  CampaignLink: 'CAMPAIGN_LINK',
  GaWebsite: 'GA_WEBSITE',
  Post: 'POST',
  Property: 'PROPERTY',
} as const;

export type GqlGqlChatEntityType =
  (typeof GqlGqlChatEntityType)[keyof typeof GqlGqlChatEntityType];
export interface GqlConfirmationFieldOutput {
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export const GqlGqlChatBlockType = {
  Action: 'ACTION',
  ActionConfirmation: 'ACTION_CONFIRMATION',
  Download: 'DOWNLOAD',
  Entity: 'ENTITY',
  Message: 'MESSAGE',
} as const;

export type GqlGqlChatBlockType =
  (typeof GqlGqlChatBlockType)[keyof typeof GqlGqlChatBlockType];
export const GqlGqlChatMessageRole = {
  Assistant: 'ASSISTANT',
  User: 'USER',
} as const;

export type GqlGqlChatMessageRole =
  (typeof GqlGqlChatMessageRole)[keyof typeof GqlGqlChatMessageRole];
export interface GqlToolCallRecordOutput {
  durationMs?: Maybe<Scalars['Int']['output']>;
  input: Scalars['String']['output'];
  inputTruncated: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  output: Scalars['String']['output'];
  outputTruncated: Scalars['Boolean']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
}

/** A generic list view for pagination */
export interface GqlAdminAiChatSessionList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAdminChatSessionOutput>;
  limit: Scalars['Int']['output'];
}

export interface GqlAdminChatSessionOutput {
  _id: Scalars['String']['output'];
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  executionMode: GqlGqlExecutionMode;
  messageCount: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
  status: GqlGqlChatSessionStatus;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
}

export const GqlGqlExecutionMode = {
  Auto: 'AUTO',
  Safe: 'SAFE',
} as const;

export type GqlGqlExecutionMode =
  (typeof GqlGqlExecutionMode)[keyof typeof GqlGqlExecutionMode];
export const GqlGqlChatSessionStatus = {
  Cancelled: 'CANCELLED',
  Completed: 'COMPLETED',
  Error: 'ERROR',
  Pending: 'PENDING',
  Processing: 'PROCESSING',
  WaitingForUser: 'WAITING_FOR_USER',
} as const;

export type GqlGqlChatSessionStatus =
  (typeof GqlGqlChatSessionStatus)[keyof typeof GqlGqlChatSessionStatus];
/** A generic list view for pagination */
export interface GqlAdminAiSearchCandidateList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAdminAiSearchCandidateOutput>;
  limit: Scalars['Int']['output'];
}

export interface GqlAdminAiSearchCandidateOutput {
  _id: Scalars['String']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  decision: Scalars['String']['output'];
  engagementRate?: Maybe<Scalars['Float']['output']>;
  followersCount?: Maybe<Scalars['Int']['output']>;
  from: Scalars['String']['output'];
  historyId: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  username: Scalars['String']['output'];
  violation?: Maybe<Scalars['String']['output']>;
}

/** A generic list view for pagination */
export interface GqlAdminAiSearchHistoryList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAdminAiSearchHistoryOutput>;
  limit: Scalars['Int']['output'];
}

export interface GqlAdminAiSearchHistoryOutput {
  _id: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  initialPrompt: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  totalAccepted: Scalars['Int']['output'];
  totalRejected: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlAdminAiSearchStageOutput {
  _id: Scalars['String']['output'];
  accepted: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  dbVectorProcessed: Scalars['Int']['output'];
  durationMs: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  googleProcessed: Scalars['Int']['output'];
  historyId: Scalars['String']['output'];
  rejected: Scalars['Int']['output'];
  relaxationLevel: Scalars['Int']['output'];
  rerankProcessed: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  twitterProcessed: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  userPrompt: Scalars['String']['output'];
}

export interface GqlAdminCampaignFilterInput {
  query?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<GqlCampaignStatusEnum>>;
}

/**
 * Hand-rolled list output (mirrors `define_list_output!`) so we can attach
 * `server_seq: u64` for the realtime refetch-race filter on
 * `campaignListEvents`. Resolver populates `server_seq` from
 * `CampaignListEventBus::current_seq()` taken **before** the DB read.
 */
export interface GqlCampaignListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlCampaignOutput>;
  /**
   * Snapshot of the `campaign_list_events` broadcaster sequence at
   * query time. Default `0` for non-realtime call sites; the
   * `campaign_list` resolver overrides before returning.
   */
  serverSeq: Scalars['Int']['output'];
}

export interface GqlAdminIndustryFilterInput {
  parentIndustryId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GqlCreatorNetworkEntityStatus>;
}

export const GqlCreatorNetworkEntityStatus = {
  Active: 'ACTIVE',
  Draft: 'DRAFT',
  Hidden: 'HIDDEN',
} as const;

export type GqlCreatorNetworkEntityStatus =
  (typeof GqlCreatorNetworkEntityStatus)[keyof typeof GqlCreatorNetworkEntityStatus];
/** A generic list view for pagination */
export interface GqlAdminCreatorNetworkIndustryList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAdminIndustryObject>;
  limit: Scalars['Int']['output'];
}

export interface GqlAdminIndustryObject {
  _id: Scalars['ID']['output'];
  childIndustryIds: Array<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  featured: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ogDescription: Scalars['String']['output'];
  ogImage: Scalars['String']['output'];
  ogTitle: Scalars['String']['output'];
  parentIndustryId?: Maybe<Scalars['ID']['output']>;
  pluralName: Scalars['String']['output'];
  relatedIndustryIds: Array<Scalars['ID']['output']>;
  seoDescription: Scalars['String']['output'];
  seoTitle: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: GqlCreatorNetworkEntityStatus;
  updatedAt: Scalars['String']['output'];
}

/**
 * Detail view: full members (re-sorted by `order`) + joined creator preview
 * + thin-list advisory.
 */
export interface GqlAdminInfluencerListDetail {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  generation?: Maybe<GqlAdminGenerationMetaObject>;
  includedCount: Scalars['Int']['output'];
  industryId: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<GqlAdminInfluencerListMemberObject>;
  name: Scalars['String']['output'];
  status: GqlCreatorNetworkEntityStatus;
  /** `includedCount < THIN_LIST_THRESHOLD` (advisory only; §7). */
  thinListWarning: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlAdminGenerationMetaObject {
  candidateCount: Scalars['Int']['output'];
  generatedAt: Scalars['String']['output'];
  querySummary: Scalars['String']['output'];
}

/**
 * One curation-table row: the member's curation state plus the joined `auth`
 * preview (resolved via `AuthRepository::list_by_ids`). `available=false`
 * when the referenced `auth` no longer exists (#570 §7 — tolerated).
 */
export interface GqlAdminInfluencerListMemberObject {
  authId: Scalars['ID']['output'];
  /** `false` when the joined `auth` is missing (deleted since add). */
  available: Scalars['Boolean']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  contentCategorySlugs: Array<Scalars['String']['output']>;
  curated: Scalars['Boolean']['output'];
  followersCount?: Maybe<Scalars['Int']['output']>;
  included: Scalars['Boolean']['output'];
  locationId: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  primaryIndustryId: Scalars['ID']['output'];
  username?: Maybe<Scalars['String']['output']>;
}

export interface GqlAdminInfluencerListFilterInput {
  industryId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GqlCreatorNetworkEntityStatus>;
}

/** A generic list view for pagination */
export interface GqlAdminCreatorNetworkInfluencerListList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAdminInfluencerListObject>;
  limit: Scalars['Int']['output'];
}

/** List-row view: counts only (no full member list). */
export interface GqlAdminInfluencerListObject {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  generation?: Maybe<GqlAdminGenerationMetaObject>;
  includedCount: Scalars['Int']['output'];
  industryId: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: GqlCreatorNetworkEntityStatus;
  updatedAt: Scalars['String']['output'];
}

export interface GqlAdminLocationObject {
  _id: Scalars['ID']['output'];
  childLocationIds: Array<Scalars['ID']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  featured: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  ogDescription: Scalars['String']['output'];
  ogImage: Scalars['String']['output'];
  ogTitle: Scalars['String']['output'];
  parentLocationId?: Maybe<Scalars['ID']['output']>;
  relatedLocationIds: Array<Scalars['ID']['output']>;
  seoDescription: Scalars['String']['output'];
  seoTitle: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  status: GqlCreatorNetworkEntityStatus;
  type: GqlCreatorNetworkLocationType;
  updatedAt: Scalars['String']['output'];
}

export const GqlCreatorNetworkLocationType = {
  City: 'CITY',
  Country: 'COUNTRY',
  Neighborhood: 'NEIGHBORHOOD',
  Region: 'REGION',
  State: 'STATE',
} as const;

export type GqlCreatorNetworkLocationType =
  (typeof GqlCreatorNetworkLocationType)[keyof typeof GqlCreatorNetworkLocationType];
export interface GqlAdminLocationFilterInput {
  parentLocationId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GqlCreatorNetworkEntityStatus>;
  type?: InputMaybe<GqlCreatorNetworkLocationType>;
}

/** A generic list view for pagination */
export interface GqlAdminCreatorNetworkLocationList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAdminLocationObject>;
  limit: Scalars['Int']['output'];
}

export interface GqlAdminEventTimelineFilterInput {
  aggregateId?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Filter by organization: returns events for the org + all member accounts */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by source: "account" (event store), "activity" (activity log), or null (both) */
  source?: InputMaybe<Scalars['String']['input']>;
}

/** A generic list view for pagination */
export interface GqlAdminEventTimelineList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAdminEventObject>;
  limit: Scalars['Int']['output'];
}

export interface GqlAdminEventObject {
  _id: Scalars['ID']['output'];
  actorId?: Maybe<Scalars['String']['output']>;
  aggregateId: Scalars['String']['output'];
  aggregateType: Scalars['String']['output'];
  correlationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  /** Sanitized JSON payload (password hashes excluded) */
  payload: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
}

/**
 * One aggregated external-API usage+cost row for the admin usage view (#582-D).
 * Grouped by `(organizationId, vendor)` over the requested range. Money is
 * authoritative as integer micro-USD (`estCostUsdMicros`); `estCostUsd` is a
 * convenience `f64` dollars projection at the boundary (#603 convention).
 */
export interface GqlAdminExternalApiUsageRow {
  /** Total external-API calls in the range. */
  callCount: Scalars['Int']['output'];
  /** Failed calls (still billed) in the range. */
  errorCount: Scalars['Int']['output'];
  /**
   * Same spend as fractional USD dollars (= micros / 1_000_000). Display
   * convenience only — do not round-trip money through this field.
   */
  estCostUsd: Scalars['Float']['output'];
  /** Estimated spend in integer micro-USD (authoritative money unit). */
  estCostUsdMicros: Scalars['Int']['output'];
  /** Org hex id, or `null` for the unattributed (shared/background) bucket. */
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Stable vendor tag, e.g. `"hiker_api"`, `"tik_api"`. */
  vendor: Scalars['String']['output'];
}

export interface GqlAdminGaPageAnalyticsFilter {
  daysBack?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
}

export interface GqlAdminGaPageAnalyticsObject {
  endDate: Scalars['String']['output'];
  pages: Array<GqlAdminGaPageMetricsObject>;
  propertyName?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  totalPageViews: Scalars['Int']['output'];
  totalSessions: Scalars['Int']['output'];
}

export interface GqlAdminGaPageMetricsObject {
  avgSessionDuration: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  pagePath: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  pageViews: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
}

export interface GqlAdminAccountObject {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasGoogleLogin: Scalars['Boolean']['output'];
  hasPassword: Scalars['Boolean']['output'];
  isSuperadmin: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
}

export interface GqlOrganizationWithProfileObject {
  organization: GqlOrganizationObject;
  profile: GqlOrganizationProfileObject;
}

export interface GqlAdminStatsObject {
  activeCampaigns: Scalars['Int']['output'];
  activeOrganizations: Scalars['Int']['output'];
  aiChatSessionsInPeriod: Scalars['Int']['output'];
  aiSearchesInPeriod: Scalars['Int']['output'];
  labeledWindowsIsolatedPost: Scalars['Int']['output'];
  labeledWindowsPromoCode: Scalars['Int']['output'];
  /** Intel F1 gate metric — total labeled analysis windows accumulated. */
  labeledWindowsTotal: Scalars['Int']['output'];
  labeledWindowsTrackingLink: Scalars['Int']['output'];
  newUsersInPeriod: Scalars['Int']['output'];
  superadminAccounts: Scalars['Int']['output'];
  totalAccounts: Scalars['Int']['output'];
  totalCampaigns: Scalars['Int']['output'];
  totalOrganizations: Scalars['Int']['output'];
  unverifiedAccounts: Scalars['Int']['output'];
  verifiedAccounts: Scalars['Int']['output'];
}

export interface GqlAdminAccountMembershipObject {
  member: GqlOrganizationMemberObject;
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
}

export interface GqlAdminAccountFilterInput {
  emailContains?: InputMaybe<Scalars['String']['input']>;
  isSuperadmin?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
}

/** A generic list view for pagination */
export interface GqlAdminAccountList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAdminAccountObject>;
  limit: Scalars['Int']['output'];
}

export interface GqlDeadLetteredAuthEnvelopeOutput {
  attempts: Scalars['Int']['output'];
  /** RFC 3339 (UTC). */
  createdAt: Scalars['String']['output'];
  /** RFC 3339 (UTC). */
  deadLetteredAt?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  /** Hex ObjectId, pass to `adminRedriveAuthDlqEnvelope` to retry. */
  id: Scalars['String']['output'];
  /**
   * Truncated to 500 chars (including a trailing ellipsis on overflow)
   * to keep the response small.
   */
  lastError?: Maybe<Scalars['String']['output']>;
}

export interface GqlAdminDemoRequestFilterInput {
  query?: InputMaybe<Scalars['String']['input']>;
}

/** A generic list view for pagination */
export interface GqlAdminDemoRequestList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAdminDemoRequestObject>;
  limit: Scalars['Int']['output'];
}

export interface GqlAdminDemoRequestObject {
  _id: Scalars['ID']['output'];
  company?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  processed: Scalars['Boolean']['output'];
  processedAt?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
}

export interface GqlEmailSuppressionObject {
  address: Scalars['String']['output'];
  categoryScope: GqlEmailCategoryScopeOutput;
  /** Most recent matching event (RFC 3339). */
  lastEventAt: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
  reason: GqlGraphqlSuppressionReason;
  /** First-event timestamp (RFC 3339). */
  recordedAt: Scalars['String']['output'];
  source: GqlGraphqlSuppressionSource;
}

export interface GqlEmailCategoryScopeOutput {
  /** True iff scope is `AllCategories`. */
  allCategories: Scalars['Boolean']['output'];
  /** Sorted+deduped wire categories. Empty when `all_categories` is true. */
  categories: Array<GqlGraphqlEmailCategory>;
}

export const GqlGraphqlEmailCategory = {
  Outreach: 'OUTREACH',
  ProductNotification: 'PRODUCT_NOTIFICATION',
  Transactional: 'TRANSACTIONAL',
} as const;

export type GqlGraphqlEmailCategory =
  (typeof GqlGraphqlEmailCategory)[keyof typeof GqlGraphqlEmailCategory];
export const GqlGraphqlSuppressionReason = {
  HardBounce: 'HARD_BOUNCE',
  ManualBlock: 'MANUAL_BLOCK',
  SpamComplaint: 'SPAM_COMPLAINT',
  Unsubscribed: 'UNSUBSCRIBED',
} as const;

export type GqlGraphqlSuppressionReason =
  (typeof GqlGraphqlSuppressionReason)[keyof typeof GqlGraphqlSuppressionReason];
export const GqlGraphqlSuppressionSource = {
  AdminManual: 'ADMIN_MANUAL',
  SesBounce: 'SES_BOUNCE',
  SesComplaint: 'SES_COMPLAINT',
  UserOptOut: 'USER_OPT_OUT',
} as const;

export type GqlGraphqlSuppressionSource =
  (typeof GqlGraphqlSuppressionSource)[keyof typeof GqlGraphqlSuppressionSource];
/** A generic list view for pagination */
export interface GqlOrganizationMemberList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlOrganizationMemberObject>;
  limit: Scalars['Int']['output'];
}

export interface GqlAdminOrganizationFilterInput {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Free-text search. A 24-char hex value is matched as `_id`; anything
   * else is matched case-insensitively against organization profile name.
   * Mutually exclusive with `ids` — when both are provided, `query` wins.
   */
  query?: InputMaybe<Scalars['String']['input']>;
}

/** A generic list view for pagination */
export interface GqlOrganizationList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlOrganizationObject>;
  limit: Scalars['Int']['output'];
}

export interface GqlAdminOutboxFilterInput {
  aggregateId?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Filter by organization: returns outbox events for all member accounts */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}

/** A generic list view for pagination */
export interface GqlAdminOutboxEntryList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAdminOutboxEntryObject>;
  limit: Scalars['Int']['output'];
}

export interface GqlAdminOutboxEntryObject {
  _id: Scalars['ID']['output'];
  aggregateId: Scalars['String']['output'];
  aggregateType: Scalars['String']['output'];
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  /** JSON payload of the event (password hashes excluded) */
  payload: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
}

/**
 * One event in the MCP OAuth session audit timeline (#372).
 *
 * Typed lens over `EventLog<McpOAuthEvent>::list` for the
 * `mcp_oauth_session` aggregate `(account_id, organization_id)`. Backs the
 * superadmin-only `adminMcpOAuthSessionTimeline` incident-response query.
 * `payload` is the serialized `McpOAuthEvent` body as a JSON scalar — admin
 * tooling renders it; the shape is opaque here by design.
 */
export interface GqlAdminMcpOAuthTimelineEvent {
  actorId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  /**
   * Event-specific fields (grant_type, client_id, reason, revoked_count, …)
   * as a GraphQL JSON scalar.
   */
  payload: Scalars['JSON']['output'];
  /** Monotonic per-aggregate sequence. Use as `afterSequence` for the next page. */
  sequence: Scalars['Int']['output'];
}

export interface GqlProgramEnrollmentOutput {
  /** `AuthId` hex. FE resolves the full creator via a separate loader. */
  authId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  enrolledAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  programId: Scalars['ID']['output'];
  status: GqlAffiliateEnrollmentStatus;
}

export const GqlAffiliateEnrollmentStatus = {
  Active: 'ACTIVE',
  Paused: 'PAUSED',
  Pending: 'PENDING',
  Removed: 'REMOVED',
} as const;

export type GqlAffiliateEnrollmentStatus =
  (typeof GqlAffiliateEnrollmentStatus)[keyof typeof GqlAffiliateEnrollmentStatus];
/**
 * One affiliate program with its read-computed rollups. `commission_percent`
 * is derived from the stored basis points (`bps / 100`) so the FE renders a
 * human percent without re-deriving. `lifetime_commissions` is USD minor
 * units (cents); `payout_schedule` is a static `"Manual"` in the MVP (no
 * automated payout rail — manual settlement).
 */
export interface GqlAffiliateProgramOutput {
  attributionWindowDays: Scalars['Int']['output'];
  /** Raw basis points, in case the FE wants exact integer math. */
  commissionBps: Scalars['Int']['output'];
  /** Commission rate as a human percent (e.g. `10.0` for 10 %). */
  commissionPercent: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  enrolledCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /**
   * Lifetime commission across active enrolled creators, USD minor
   * units (cents).
   */
  lifetimeCommissions: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /**
   * MVP: payouts are settled manually. Static label for the program
   * card until the payout rail lands.
   */
  payoutSchedule: Scalars['String']['output'];
  status: GqlAffiliateProgramStatus;
  updatedAt: Scalars['String']['output'];
}

export const GqlAffiliateProgramStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Draft: 'DRAFT',
  Paused: 'PAUSED',
} as const;

export type GqlAffiliateProgramStatus =
  (typeof GqlAffiliateProgramStatus)[keyof typeof GqlAffiliateProgramStatus];
export interface GqlListMessagesInput {
  listViewParams?: InputMaybe<GqlListViewParamsInput>;
  sessionId: Scalars['String']['input'];
}

export interface GqlListSessionsInput {
  listViewParams?: InputMaybe<GqlListViewParamsInput>;
}

/** A generic list view for pagination */
export interface GqlAiChatSessionList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlChatSessionOutput>;
  limit: Scalars['Int']['output'];
}

export interface GqlChatSessionOutput {
  _id: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  executionMode: GqlGqlExecutionMode;
  kind: GqlGqlChatKind;
  /**
   * Whether the UI should nudge the user to start a fresh chat (#656 /
   * #639). Derived server-side from `turnCount` against the single
   * rotation-threshold source of truth, replacing the FE's former
   * client-side turn counting.
   */
  rotationSuggested: Scalars['Boolean']['output'];
  status: GqlGqlChatSessionStatus;
  systemActor?: Maybe<GqlGqlSystemActor>;
  title?: Maybe<Scalars['String']['output']>;
  /**
   * Authoritative assistant-turn count (#656). Server-computed from the
   * persisted turns, so it is exact and independent of how many messages
   * the client has paginated into view.
   */
  turnCount: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlChatSessionMetadataOutput {
  _id: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  executionMode: GqlGqlExecutionMode;
  kind: GqlGqlChatKind;
  status: GqlGqlChatSessionStatus;
  systemActor?: Maybe<GqlGqlSystemActor>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
}

export const GqlGqlChatKind = {
  Automation: 'AUTOMATION',
  User: 'USER',
} as const;

export type GqlGqlChatKind =
  (typeof GqlGqlChatKind)[keyof typeof GqlGqlChatKind];

export const GqlGqlSystemActor = {
  ApiCallback: 'API_CALLBACK',
} as const;

export type GqlGqlSystemActor =
  (typeof GqlGqlSystemActor)[keyof typeof GqlGqlSystemActor];

export interface GqlThinkingStreamOutput {
  /** Entity description for entity preview */
  entityDescription?: Maybe<Scalars['String']['output']>;
  /** Entity ID for entity preview */
  entityId?: Maybe<Scalars['String']['output']>;
  /** Entity key for entity preview (e.g. "ai_search_history") */
  entityKey?: Maybe<Scalars['String']['output']>;
  /** Entity title for entity preview */
  entityTitle?: Maybe<Scalars['String']['output']>;
  isFinal: Scalars['Boolean']['output'];
  /** Sequence number for frontend deduplication (set in query response, None in subscription) */
  seq?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  /** Tool lifecycle signal: ToolStart or ToolEnd */
  toolEvent?: Maybe<GqlGqlToolEventType>;
  /** JSON-stringified tool input arguments (tool_start only) */
  toolInput?: Maybe<Scalars['String']['output']>;
  /** Human-readable label for the tool call (tool_start only) */
  toolLabel?: Maybe<Scalars['String']['output']>;
  /** Tool name associated with the tool event */
  toolName?: Maybe<Scalars['String']['output']>;
  /** Whether the tool call succeeded (tool_end only) */
  toolSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** Cumulative token usage for this turn (sent after each LLM response) */
  usage?: Maybe<GqlGqlUsageEvent>;
}

export const GqlGqlToolEventType = {
  ToolEnd: 'TOOL_END',
  ToolStart: 'TOOL_START',
} as const;

export type GqlGqlToolEventType =
  (typeof GqlGqlToolEventType)[keyof typeof GqlGqlToolEventType];
/** Cumulative LLM token usage for the current turn (updated after each LLM response) */
export interface GqlGqlUsageEvent {
  inputTokens: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  outputTokens: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
}

/** Input for listing candidates */
export interface GqlListAiSearchCandidatesInput {
  /** ID of the search history */
  historyId: Scalars['String']['input'];
  /** List view parameters (pagination, sorting) */
  listViewParams?: InputMaybe<GqlListViewParamsInput>;
}

export interface GqlAiSearchCandidateListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAiSearchCandidateOutput>;
}

/** AI Search candidate */
export interface GqlAiSearchCandidateOutput {
  _id: Scalars['String']['output'];
  /** Full auth object loaded via DataLoader by authInnerId */
  auth?: Maybe<GqlAuth>;
  authInnerId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  /** All decisions for this candidate (history of ranking decisions) */
  decisions: Array<GqlCandidateDecisionOutput>;
  from: GqlCandidateSourceOutput;
  historyId: Scalars['String']['output'];
  latestDecision: GqlDecisionOutput;
  latestFactReasons: Array<Scalars['String']['output']>;
  latestLlmReasons: Array<Scalars['String']['output']>;
  latestScore: Scalars['Float']['output'];
  originStageId: Scalars['String']['output'];
  source: GqlSourceOutput;
  updatedAt: Scalars['String']['output'];
  username: Scalars['String']['output'];
}

/** Candidate decision record */
export interface GqlCandidateDecisionOutput {
  _id: Scalars['String']['output'];
  candidateId: Scalars['String']['output'];
  decidedAt: Scalars['String']['output'];
  decision: GqlDecisionOutput;
  factReasons: Array<Scalars['String']['output']>;
  historyId: Scalars['String']['output'];
  llmReasons: Array<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  stageId: Scalars['String']['output'];
}

/** Accept/Reject decision */
export interface GqlDecisionOutput {
  type: GqlDecisionTypeOutput;
  violation?: Maybe<Scalars['String']['output']>;
}

export const GqlDecisionTypeOutput = {
  Accept: 'ACCEPT',
  Reject: 'REJECT',
} as const;

export type GqlDecisionTypeOutput =
  (typeof GqlDecisionTypeOutput)[keyof typeof GqlDecisionTypeOutput];
/** Where the candidate came from */
export const GqlCandidateSourceOutput = {
  CommentDiscovery: 'COMMENT_DISCOVERY',
  DbVector: 'DB_VECTOR',
  FollowingDiscovery: 'FOLLOWING_DISCOVERY',
  Google: 'GOOGLE',
  GoogleAi: 'GOOGLE_AI',
  HashtagDiscovery: 'HASHTAG_DISCOVERY',
  LocationDiscovery: 'LOCATION_DISCOVERY',
  Manual: 'MANUAL',
  RejectedRerank: 'REJECTED_RERANK',
  TwitterSearch: 'TWITTER_SEARCH',
} as const;

export type GqlCandidateSourceOutput =
  (typeof GqlCandidateSourceOutput)[keyof typeof GqlCandidateSourceOutput];
/** Input for viewing a search history */
export interface GqlViewAiSearchInput {
  /** ID of the search history */
  historyId: Scalars['String']['input'];
}

export interface GqlAiSearchHistoryListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAiSearchHistoryOutput>;
}

/** AI Search stage (one iteration of the search) */
export interface GqlAiSearchStageOutput {
  _id: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  criteria: GqlRankingCriteriaOutput;
  historyId: Scalars['String']['output'];
  relaxationLevel: Scalars['Int']['output'];
  stats: GqlStageStatsOutput;
  status: GqlStageStatusOutput;
  updatedAt: Scalars['String']['output'];
  userPrompt: Scalars['String']['output'];
}

/** Stage statistics */
export interface GqlStageStatsOutput {
  accepted: Scalars['Int']['output'];
  dbVectorProcessed: Scalars['Int']['output'];
  durationMs: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  googleProcessed: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  rerankProcessed: Scalars['Int']['output'];
  twitterProcessed: Scalars['Int']['output'];
}

/** Stage status */
export const GqlStageStatusOutput = {
  Completed: 'COMPLETED',
  Error: 'ERROR',
  Pending: 'PENDING',
  Processing: 'PROCESSING',
} as const;

export type GqlStageStatusOutput =
  (typeof GqlStageStatusOutput)[keyof typeof GqlStageStatusOutput];
export interface GqlAuthByIdInput {
  authId: Scalars['String']['input'];
}

export interface GqlAuthCrossLinkOutput {
  _id?: Maybe<Scalars['String']['output']>;
  authId: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  discoveredVia: Scalars['String']['output'];
  linkedAuthId: Scalars['String']['output'];
  linkedSource: GqlAuthSource;
  linkedUsername: Scalars['String']['output'];
}

export interface GqlDeepLookupQueryInput {
  authId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlAuthFeedInput {
  authId: Scalars['String']['input'];
  /**
   * Layer-3: stable partner auth id. Resolved server-side to the
   * collaboration's snapshot `@partnerUsername` and matched (via the shared
   * `build_auth_feed_filters` predicate) against the post's structured
   * brand-association fields: `service_post.mentions` (exact + case-insensitive
   * `@?handle`), plus anchored case-insensitive matches on `hashtags` and
   * `keywords`. This is the SAME predicate that backs the collaboration badge
   * count, so the drill-down list length equals that count (#531).
   */
  collaborationPartnerAuthId?: InputMaybe<Scalars['String']['input']>;
  /** Layer-2: restrict the feed to one collaboration category. */
  collaborationType?: InputMaybe<GqlCollaborationTypeEnum>;
  listViewParams: GqlListViewParamsInput;
  postType?: InputMaybe<GqlPostTypeEnum>;
}

export interface GqlPostListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlPostOutput>;
}

export interface GqlAuthGroupInput {
  authGroupId: Scalars['String']['input'];
}

export interface GqlAuthGroupListInput {
  listViewParams: GqlListViewParamsInput;
  searchName?: InputMaybe<Scalars['String']['input']>;
}

/** A generic list view for pagination */
export interface GqlAuthGroupList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAuthGroupOutput>;
  limit: Scalars['Int']['output'];
}

export interface GqlAuthListByGroupIdInput {
  authGroupIds: Array<Scalars['String']['input']>;
  listViewParams?: InputMaybe<GqlListViewParamsInput>;
}

export interface GqlAuthListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAuth>;
}

export interface GqlAuthNoteViewInput {
  authId: Scalars['String']['input'];
}

export interface GqlAuthNoteItemsInput {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  authId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  scope?: InputMaybe<GqlNoteScopeEnum>;
}

export const GqlNoteScopeEnum = {
  Campaign: 'CAMPAIGN',
  General: 'GENERAL',
} as const;

export type GqlNoteScopeEnum =
  (typeof GqlNoteScopeEnum)[keyof typeof GqlNoteScopeEnum];
export interface GqlAuthNoteItemsConnection {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlAuthNoteItemOutput>;
}

export interface GqlAuthNoteItemOutput {
  _id: Scalars['String']['output'];
  attachments: Array<GqlDocument>;
  authId: Scalars['String']['output'];
  authorAvatar?: Maybe<Scalars['String']['output']>;
  authorId: Scalars['String']['output'];
  authorName: Scalars['String']['output'];
  campaignId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  message: Scalars['String']['output'];
  pinned: Scalars['Boolean']['output'];
  scope: GqlNoteScopeEnum;
  updatedAt: Scalars['String']['output'];
}

export interface GqlDocument {
  contentType?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  /**
   * Signed CloudFront URL for the document (24h TTL). Falls back to an
   * unsigned URL when signing config is absent; returns `None` only
   * when signing is configured but fails — same as `MediaOutput::url`.
   */
  url?: Maybe<Scalars['String']['output']>;
}

export interface GqlAuthSearchInput {
  /** Filter by creators who collaborated with this partner username (e.g. "nike"). */
  collaborationPartnerUsername?: InputMaybe<Scalars['String']['input']>;
  /**
   * Negative-fit exclusion: drop creators whose visually detected brands
   * include any of these (e.g. a Nike campaign excluding "Adidas").
   * Case-insensitive exact match against `visual_profile.detected_brands`.
   */
  excludeBrands?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Negative-fit exclusion: drop creators flagged with any of these
   * brand-safety categories (matched against the merged text + visual
   * `brand_safety_flags`).
   */
  excludeSafetyFlags?: InputMaybe<Array<GqlBrandSafetyFlagOutput>>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  listViewParams: GqlListViewParamsInput;
  source?: InputMaybe<GqlAuthSource>;
  username?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlBackgroundTasksTrayInput {
  /** Cursor from the previous page (`BackgroundTasksTrayResult.next_cursor`). */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Include terminal rows already acknowledged via
   * `markBackgroundTasksSeen` (#428). Defaults to `false` so the tray
   * hides seen/completed tasks; pass `true` for a "show all" view.
   */
  includeSeen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default 50, max `MAX_LIMIT`. Values outside the range are clamped. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Optional status filter. `None` means
   * `[Running, Done, Partial, Failed]` — i.e. every retained row.
   */
  statuses?: InputMaybe<Array<GqlBackgroundTaskStatusEnum>>;
}

export interface GqlBackgroundTasksTrayResult {
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<GqlBackgroundTaskOutput>;
  /**
   * Opaque cursor for the next page. `null` when `has_next_page` is
   * false. Pass back as `input.after` to continue.
   */
  nextCursor?: Maybe<Scalars['String']['output']>;
}

export interface GqlBackgroundTaskTimelineEvent {
  actorId?: Maybe<Scalars['String']['output']>;
  actorType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  /**
   * Event-specific fields (message for ProgressUpdated, error + kind for
   * Failed, etc.). GraphQL JSON scalar — frontend parses once.
   */
  payload: Scalars['JSON']['output'];
  sequence: Scalars['Int']['output'];
}

export interface GqlCampaignSingleInput {
  campaignId: Scalars['String']['input'];
}

export interface GqlCampaignActivityTimelineInput {
  campaignId: Scalars['String']['input'];
  /** Opaque cursor returned from the previous page; null on first page. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Retained for wire compatibility. Historically opted into a
   * `totalCount` aggregation, but that full-scanned `campaign_fact` and
   * cost ~10s per drawer open (#621); the value the FE fetched was never
   * rendered. The field is now ignored server-side and `totalCount` always
   * resolves to `null`.
   */
  includeTotal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Page size, clamped 1..=100. Default 20. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Optional type filter — `Unknown`-typed rows are never returned. */
  types?: InputMaybe<Array<GqlCampaignActivityType>>;
}

export const GqlCampaignActivityType = {
  CampaignConfigChanged: 'CAMPAIGN_CONFIG_CHANGED',
  CampaignEndApproaching: 'CAMPAIGN_END_APPROACHING',
  CampaignEnded: 'CAMPAIGN_ENDED',
  CampaignStatusChanged: 'CAMPAIGN_STATUS_CHANGED',
  CreatorAdded: 'CREATOR_ADDED',
  CreatorQualityFlagged: 'CREATOR_QUALITY_FLAGGED',
  CreatorRemoved: 'CREATOR_REMOVED',
  DeliverablesMet: 'DELIVERABLES_MET',
  DeliverablesPartialProgress: 'DELIVERABLES_PARTIAL_PROGRESS',
  NewPostDetected: 'NEW_POST_DETECTED',
  OfflineRevenueAdded: 'OFFLINE_REVENUE_ADDED',
  OfflineRevenueRemoved: 'OFFLINE_REVENUE_REMOVED',
  OutreachStatusChanged: 'OUTREACH_STATUS_CHANGED',
  PaymentDeleted: 'PAYMENT_DELETED',
  PaymentEligible: 'PAYMENT_ELIGIBLE',
  PaymentStatusChanged: 'PAYMENT_STATUS_CHANGED',
  PayoutStatusChanged: 'PAYOUT_STATUS_CHANGED',
  PostBrandSafetyViolation: 'POST_BRAND_SAFETY_VIOLATION',
  PostEngagementAnomaly: 'POST_ENGAGEMENT_ANOMALY',
  PostEngagementUpdated: 'POST_ENGAGEMENT_UPDATED',
  TaskCreated: 'TASK_CREATED',
  TaskDeadlineApproaching: 'TASK_DEADLINE_APPROACHING',
  TaskDeadlinePassed: 'TASK_DEADLINE_PASSED',
  TaskStatusChanged: 'TASK_STATUS_CHANGED',
} as const;

export type GqlCampaignActivityType =
  (typeof GqlCampaignActivityType)[keyof typeof GqlCampaignActivityType];
export interface GqlCampaignActivityTimelineOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlCampaignActivityItemOutput>;
  /**
   * Snapshot of the `task_activity_events` broadcaster sequence taken
   * at query time (before the DB read). FE persists this and applies a
   * `seq > serverSeq` filter to incoming `taskActivityEvents` to drop
   * already-included events on refetch races (#277, ADR-002 / §7).
   */
  serverSeq: Scalars['Int']['output'];
  totalCount?: Maybe<Scalars['Int']['output']>;
}

export interface GqlCampaignActivityItemOutput {
  _id: Scalars['String']['output'];
  authId?: Maybe<Scalars['String']['output']>;
  /** RFC 3339 timestamp. */
  createdAt: Scalars['String']['output'];
  /**
   * Server-rendered English message. Resolves the optional `@username`
   * via the existing `AuthLoader` so the page-level fetch issues a
   * single batched lookup for all distinct auths.
   */
  message: Scalars['String']['output'];
  /**
   * Tagged-union metadata: `{ kind: <camelCase>, ...fields }` — null
   * when the underlying fact carries no payload.
   */
  metadata?: Maybe<Scalars['JSON']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  type: GqlCampaignActivityType;
}

export interface GqlCampaignAllInfluencersInput {
  campaignId: Scalars['String']['input'];
}

export interface GqlCampaignAllInfluencersOutput {
  items: Array<GqlCampaignPosterOutput>;
}

/**
 * One author who has posted for a campaign (#712) — the "all influencers who
 * posted" list, split by campaign membership.
 */
export interface GqlCampaignPosterOutput {
  /** Hydrated author profile (batched via `AuthLoader`). */
  auth?: Maybe<GqlAuth>;
  /** Marble auth id (hex). */
  authId: Scalars['String']['output'];
  /**
   * `true` when this author is a current campaign member
   * (`campaign.influencer_auth_ids`); `false` for a discovered non-member.
   */
  inCampaign: Scalars['Boolean']['output'];
}

export interface GqlCampaignAnalyticsInput {
  authId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
}

export interface GqlCampaignAnalyticsHistoryInput {
  /**
   * When true (default), returns campaign-level aggregate snapshots (one per date).
   * When false, returns all per-auth snapshots (multiple entries per date).
   */
  aggregated?: Scalars['Boolean']['input'];
  campaignId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  listViewParams?: InputMaybe<GqlListViewParamsInput>;
  startDate: Scalars['String']['input'];
}

/** A generic list view for pagination */
export interface GqlCampaignAnalyticsHistoryList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlCampaignAnalyticsHistoryPoint>;
  limit: Scalars['Int']['output'];
}

/** A single day's cumulative snapshot for chart rendering. */
export interface GqlCampaignAnalyticsHistoryPoint {
  /** Auth ID for per-auth snapshots, None for aggregate snapshots. */
  authId?: Maybe<Scalars['String']['output']>;
  commentsCumulative: Scalars['Int']['output'];
  committedBudget: Scalars['Float']['output'];
  cpe: Scalars['Float']['output'];
  cpv: Scalars['Float']['output'];
  emvCumulative: Scalars['Float']['output'];
  engagementCumulative: Scalars['Int']['output'];
  /** Engagement rate = engagement_cumulative / followers_count * 100. Null if followers is 0. */
  engagementRate?: Maybe<Scalars['Float']['output']>;
  /**
   * Estimated views for the posts Instagram publishes no view count for at
   * all — photos and carousels (#752). Priced from the author's reel ratio.
   *
   * A SEPARATE series on purpose: draw it as its own line, never stacked
   * into `viewsCumulative`. It is an inference, not a measurement, and a
   * single post can be 2-3x off; keeping the two lines distinct is what
   * makes the estimate honest.
   */
  estimatedViewsCumulative: Scalars['Int']['output'];
  /**
   * Phase D: per-tracked-event breakdown. Empty for legacy snapshots or
   * snapshots whose source `AuthGaMetrics` had no tracked events.
   */
  eventCounts: Array<GqlEventCountSnapshotOutput>;
  followersCount: Scalars['Int']['output'];
  gaClicksCumulative: Scalars['Int']['output'];
  gaPageviewsCumulative: Scalars['Int']['output'];
  gaPurchasesCumulative: Scalars['Int']['output'];
  gaRevenueCumulative: Scalars['Float']['output'];
  gaSessionsCumulative: Scalars['Int']['output'];
  /**
   * Cumulative impressions (#465). PROXY: impressions ← the cumulative
   * `engagement` aggregate (likes + comments + shares). `null` when zero.
   */
  impressionsCumulative?: Maybe<Scalars['Int']['output']>;
  likesCumulative: Scalars['Int']['output'];
  linkClicks: Scalars['Int']['output'];
  offeredMoney: Scalars['Float']['output'];
  postsCountCumulative: Scalars['Int']['output'];
  /**
   * Cumulative reach (#465). PROXY: reach ← `views_cumulative`. `null` when
   * no cumulative view signal (FE renders "—" / skips the trend point).
   */
  reachCumulative?: Maybe<Scalars['Int']['output']>;
  revenue: Scalars['Float']['output'];
  roas: Scalars['Float']['output'];
  roi: Scalars['Float']['output'];
  sharesCumulative: Scalars['Int']['output'];
  snapshotDate: Scalars['String']['output'];
  spent: Scalars['Float']['output'];
  storiesCountCumulative: Scalars['Int']['output'];
  videoCountCumulative: Scalars['Int']['output'];
  viewsCumulative: Scalars['Int']['output'];
}

/** GraphQL output mirror of `domain::campaign_analytics::EventCountSnapshot`. */
export interface GqlEventCountSnapshotOutput {
  count: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  /** Hex-encoded ID of the `GaTrackedEvent` this row counts conversions for. */
  trackedEventId: Scalars['String']['output'];
}

export interface GqlCampaignAuthInput {
  campaignId: Scalars['String']['input'];
  listViewParams: GqlListViewParamsInput;
}

/** Input for generating an invite message for a campaign auth task. */
export interface GqlCampaignAuthTaskInviteMessageGenerateInput {
  authTaskId: Scalars['String']['input'];
  campaignId: Scalars['String']['input'];
}

export interface GqlCampaignAuthTaskLinkListInput {
  campaignId: Scalars['String']['input'];
  listViewParams: GqlListViewParamsInput;
}

export interface GqlCampaignAuthTaskLinkListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlCampaignAuthTaskLinkOutput>;
}

export interface GqlCampaignAuthTaskListInput {
  authId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  listViewParams: GqlListViewParamsInput;
}

/**
 * Hand-rolled list output (mirrors `define_list_output!`) so we can attach
 * `server_seq: u64` for the realtime refetch-race filter (#276 / ADR-002).
 * Resolver populates `server_seq` from `CampaignTaskEventBus::current_seq()`
 * taken **before** the DB read.
 */
export interface GqlCampaignAuthTaskListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlCampaignAuthTaskOutput>;
  /**
   * Snapshot of the `campaign_auth_task_events` broadcaster sequence at
   * query time. Default `0` for non-realtime call sites; realtime
   * resolver overrides before returning.
   */
  serverSeq: Scalars['Int']['output'];
}

export interface GqlCampaignExportOutput {
  campaignId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  /**
   * Populated on creation. On history listing it's `None` — clients should
   * call `campaignExportDownloadUrl(id)` to mint a fresh signed URL. This
   * keeps the history endpoint cheap (no per-row signing round-trip).
   */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  partial: Scalars['Boolean']['output'];
  sizeBytes: Scalars['Int']['output'];
  sliceWarnings: Array<GqlSliceWarningOutput>;
}

export interface GqlSliceWarningOutput {
  reason: Scalars['String']['output'];
  slice: Scalars['String']['output'];
}

export interface GqlCampaignExportSliceInfo {
  defaultEnabled: Scalars['Boolean']['output'];
  grantedToRequester: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  requiredScope: Scalars['String']['output'];
  slice: GqlCampaignExportSliceEnum;
}

export const GqlCampaignExportSliceEnum = {
  Activity: 'ACTIVITY',
  Analytics: 'ANALYTICS',
  Campaign: 'CAMPAIGN',
  Creators: 'CREATORS',
  GaMetrics: 'GA_METRICS',
  Links: 'LINKS',
  Outreach: 'OUTREACH',
  Payments: 'PAYMENTS',
  Posts: 'POSTS',
  Tasks: 'TASKS',
} as const;

export type GqlCampaignExportSliceEnum =
  (typeof GqlCampaignExportSliceEnum)[keyof typeof GqlCampaignExportSliceEnum];
export interface GqlCampaignListInput {
  filter?: InputMaybe<GqlCampaignListFilterInput>;
  listViewParams: GqlListViewParamsInput;
  query?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCampaignListFilterInput {
  /**
   * Exclusion filter — match none of these statuses (`$nin`). The main
   * campaign list passes `[HISTORICAL]` to hide historical campaigns;
   * combined with `statuses` the two AND together.
   */
  excludeStatuses?: InputMaybe<Array<GqlCampaignStatusEnum>>;
  /** Inclusion filter — match any of these statuses (OR logic / `$in`). */
  statuses?: InputMaybe<Array<GqlCampaignStatusEnum>>;
}

export interface GqlCampaignPostInput {
  campaignId: Scalars['String']['input'];
  dateRange?: InputMaybe<GqlDateRangeInput>;
  listViewParams: GqlListViewParamsInput;
  /** Attribution source to read. Defaults to `Member` (existing behavior). */
  source?: InputMaybe<GqlCampaignPostSource>;
}

/**
 * Which attribution set the campaign content tab reads (#712).
 *
 * - `Member` (default, back-compat): posts authored by campaign members
 * (`authId $in influencer_auth_ids`) — the original query, unchanged.
 * - `Discovered`: posts by NON-members picked up by the hashtag/mention sweep
 * (`CampaignPostRecord.discovered == true`).
 * - `All`: member ∪ discovered.
 */
export const GqlCampaignPostSource = {
  All: 'ALL',
  Discovered: 'DISCOVERED',
  Member: 'MEMBER',
} as const;

export type GqlCampaignPostSource =
  (typeof GqlCampaignPostSource)[keyof typeof GqlCampaignPostSource];
export interface GqlCampaignRecommendationListInput {
  authId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['String']['input'];
  listViewParams: GqlListViewParamsInput;
  priority?: InputMaybe<GqlRecommendationPriorityEnum>;
  status?: InputMaybe<GqlRecommendationStatusEnum>;
}

export const GqlRecommendationStatusEnum = {
  Acknowledged: 'ACKNOWLEDGED',
  ActedOn: 'ACTED_ON',
  Dismissed: 'DISMISSED',
  Pending: 'PENDING',
  Stale: 'STALE',
  Superseded: 'SUPERSEDED',
} as const;

export type GqlRecommendationStatusEnum =
  (typeof GqlRecommendationStatusEnum)[keyof typeof GqlRecommendationStatusEnum];
export interface GqlCampaignRecommendationListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlCampaignRecommendationOutput>;
}

export interface GqlCampaignRecommendationOutput {
  _id: Scalars['String']['output'];
  aiEnhanced: Scalars['Boolean']['output'];
  authId?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  factType: GqlCampaignFactTypeEnum;
  /**
   * Post the originating fact was about, when it had one — the same value
   * `CampaignActivityItemOutput.postId` carries, resolved from the fact
   * rather than stored on the recommendation. `null` for campaign-level
   * recommendations, which is most of them.
   */
  postId?: Maybe<Scalars['String']['output']>;
  priority: GqlRecommendationPriorityEnum;
  recommendationType: GqlCampaignRecommendationTypeEnum;
  status: GqlRecommendationStatusEnum;
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
}

export const GqlCampaignFactTypeEnum = {
  CampaignConfigChanged: 'CAMPAIGN_CONFIG_CHANGED',
  CampaignEndApproaching: 'CAMPAIGN_END_APPROACHING',
  CampaignEnded: 'CAMPAIGN_ENDED',
  CampaignStatusChanged: 'CAMPAIGN_STATUS_CHANGED',
  CreatorQualityFlagged: 'CREATOR_QUALITY_FLAGGED',
  DeliverablesMet: 'DELIVERABLES_MET',
  DeliverablesPartialProgress: 'DELIVERABLES_PARTIAL_PROGRESS',
  InfluencerAdded: 'INFLUENCER_ADDED',
  InfluencerRemoved: 'INFLUENCER_REMOVED',
  NewPostDetected: 'NEW_POST_DETECTED',
  OfflineRevenueAdded: 'OFFLINE_REVENUE_ADDED',
  OfflineRevenueRemoved: 'OFFLINE_REVENUE_REMOVED',
  OutreachStatusChanged: 'OUTREACH_STATUS_CHANGED',
  PaymentDeleted: 'PAYMENT_DELETED',
  PaymentEligible: 'PAYMENT_ELIGIBLE',
  PaymentStatusChanged: 'PAYMENT_STATUS_CHANGED',
  PayoutStatusChanged: 'PAYOUT_STATUS_CHANGED',
  PostBrandSafetyViolation: 'POST_BRAND_SAFETY_VIOLATION',
  PostEngagementAnomaly: 'POST_ENGAGEMENT_ANOMALY',
  PostEngagementUpdated: 'POST_ENGAGEMENT_UPDATED',
  TaskCreated: 'TASK_CREATED',
  TaskDeadlineApproaching: 'TASK_DEADLINE_APPROACHING',
  TaskDeadlinePassed: 'TASK_DEADLINE_PASSED',
  TaskStatusChanged: 'TASK_STATUS_CHANGED',
} as const;

export type GqlCampaignFactTypeEnum =
  (typeof GqlCampaignFactTypeEnum)[keyof typeof GqlCampaignFactTypeEnum];
export const GqlCampaignRecommendationTypeEnum = {
  ContactInfluencer: 'CONTACT_INFLUENCER',
  ProcessPayment: 'PROCESS_PAYMENT',
  ReviewCampaign: 'REVIEW_CAMPAIGN',
  ReviewDeliverables: 'REVIEW_DELIVERABLES',
  ReviewPostPerformance: 'REVIEW_POST_PERFORMANCE',
} as const;

export type GqlCampaignRecommendationTypeEnum =
  (typeof GqlCampaignRecommendationTypeEnum)[keyof typeof GqlCampaignRecommendationTypeEnum];
export interface GqlCampaignSweepStatusInput {
  campaignId: Scalars['String']['input'];
}

/** Poll-able status of a campaign's on-demand sweep job (#712). */
export interface GqlSweepJobStatus {
  campaignId: Scalars['String']['output'];
  /** Populated in `Cooldown`. */
  cooldownSecondsRemaining?: Maybe<Scalars['Int']['output']>;
  /** When the last run finished (RFC3339). `null` while `Running`. */
  finishedAt?: Maybe<Scalars['String']['output']>;
  /**
   * Human-readable detail — error text for `Failed`, note for
   * `Unavailable`/`Disabled`.
   */
  message?: Maybe<Scalars['String']['output']>;
  /**
   * When the current/last run started (RFC3339). `null` in
   * `Idle`/`Unavailable`/`Disabled`.
   */
  startedAt?: Maybe<Scalars['String']['output']>;
  state: GqlSweepJobStateEnum;
  /** Populated in `Done`. */
  stats?: Maybe<GqlSweepRunStatsOutput>;
}

/** Lifecycle of the on-demand sweep job for a campaign (#712). */
export const GqlSweepJobStateEnum = {
  /**
   * A run was requested but rejected because a previous run started within
   * `SWEEP_BUTTON_COOLDOWN` (`cooldownSecondsRemaining` populated).
   */
  Cooldown: 'COOLDOWN',
  /**
   * #744 — the global `SWEEP_ENABLED` flag is off, so the whole feature
   * (auto worker AND button) is disabled for this deployment. Reported by
   * `campaignSweepStatus` too, not only on a rejected trigger, so the client
   * can render the control disabled instead of offering a click that is
   * guaranteed to be refused. Not an error state.
   */
  Disabled: 'DISABLED',
  /** The last sweep finished successfully (`stats` populated). */
  Done: 'DONE',
  /** The last sweep failed (`message` carries the error). */
  Failed: 'FAILED',
  /** No sweep has ever been triggered for this campaign in this process. */
  Idle: 'IDLE',
  /** A sweep is currently in flight. */
  Running: 'RUNNING',
  /**
   * The sweep service is not configured (no HikerAPI key) — the button is a
   * no-op. Not an error state.
   */
  Unavailable: 'UNAVAILABLE',
} as const;

export type GqlSweepJobStateEnum =
  (typeof GqlSweepJobStateEnum)[keyof typeof GqlSweepJobStateEnum];
/** Summary of a completed sweep run (mirror of `SweepStats`). */
export interface GqlSweepRunStatsOutput {
  capped: Scalars['Boolean']['output'];
  discoveredNew: Scalars['Int']['output'];
  /**
   * #723 — newly discovered creators handed to the detached profile-indexing
   * task. Enrichment runs in the background, so the per-creator outcomes are
   * in the server logs, not here.
   */
  indexEnqueued: Scalars['Int']['output'];
  membersHit: Scalars['Int']['output'];
  pagesFetched: Scalars['Int']['output'];
  postsAttributed: Scalars['Int']['output'];
  refreshed: Scalars['Int']['output'];
  scanned: Scalars['Int']['output'];
}

export interface GqlCampaignTaskTemplateOutput {
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deadline?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Brief documents; each `Document` carries a signed `url` resolver. */
  documents: Array<GqlDocument>;
  id: Scalars['String']['output'];
  /** Tracking-link definitions provisioned to each creator on apply (#507). */
  links: Array<GqlTaskTemplateLinkOutput>;
  paymentOptions: GqlCampaignAuthTaskPaymentOptionsOutput;
  postCount: Scalars['Int']['output'];
  storyCount: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  videoCount: Scalars['Int']['output'];
}

/** A tracking-link definition on a task template (#507). */
export interface GqlTaskTemplateLinkOutput {
  longUrl: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

/**
 * #9105 — result of `campaignTrackingLinkCodeStatus`. Lets the AddLink modal
 * surface the format error or the "already taken" error inline on the field.
 */
export interface GqlTrackingLinkCodeStatusOutput {
  /** The code is valid AND not currently taken. Always false when invalid. */
  available: Scalars['Boolean']['output'];
  /** User-facing reason when not valid/available; null when available. */
  error?: Maybe<Scalars['String']['output']>;
  /** Trimmed + lowercased code that was checked (null when invalid). */
  normalizedCode?: Maybe<Scalars['String']['output']>;
  /**
   * The code satisfies the format contract (`[a-z0-9-]`, 2–50 chars, no
   * leading/trailing hyphen, no `--`).
   */
  valid: Scalars['Boolean']['output'];
}

export interface GqlCampaignTrafficLiftReportOutput {
  _id: Scalars['String']['output'];
  aiSummary?: Maybe<Scalars['String']['output']>;
  /** Sessions Marble cannot confidently attribute — the GA `(other)` bucket. */
  ambiguousSessions: Scalars['Int']['output'];
  /**
   * Surfaced creator-quality anomalies (#465). Always empty in v0 —
   * STOP-deferred (see PATCHNOTES-465).
   */
  anomalies: Array<GqlTrafficAnomalyOutput>;
  /** `low` | `medium` | `high`. */
  band: Scalars['String']['output'];
  /** Mandatory user-facing label — render this verbatim, never the bare band. */
  bandLabel: Scalars['String']['output'];
  baselineMethod: Scalars['String']['output'];
  baselineQuality: GqlBaselineQualityOutput;
  baselineWindow: GqlWindowOutput;
  /**
   * Verified/untracked session split per platform (#465) — stacked-bar data.
   * Derived at read time from `influencers`; empty when there are none.
   */
  byPlatform: Array<GqlPlatformLiftOutput>;
  campaignWindow: GqlWindowOutput;
  channels: Array<GqlChannelLiftOutput>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  darkConsistentLiftPct?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /**
   * What GA's last-click attribution credits the campaign = verified tracking
   * sessions.
   */
  gaReportedSessions: Scalars['Int']['output'];
  influencers: Array<GqlInfluencerLiftRowOutput>;
  /**
   * Marble's estimate of total influencer-driven sessions =
   * `verifiedTrackedSessions` + untracked remainder. PROXY — see PATCHNOTES-465.
   */
  marbleEstimatedSessions: Scalars['Int']['output'];
  /**
   * `marbleEstimatedSessions / gaReportedSessions`. `null` when GA reported
   * nothing (cannot divide → FE renders "—").
   */
  multiplierVsGa?: Maybe<Scalars['Float']['output']>;
  organizationId: Scalars['String']['output'];
  otherChannelShare: Scalars['Float']['output'];
  /**
   * 0–100 overall confidence (#465). STOP-DEFERRED → always `null`; use
   * `band` / `bandLabel`. See PATCHNOTES-465.
   */
  overallConfidence?: Maybe<Scalars['Int']['output']>;
  postMarkers: Array<GqlLiftPostMarkerOutput>;
  sessionsAboveForecast: Scalars['Int']['output'];
  /** `processing` | `completed` | `failed`. */
  status: Scalars['String']['output'];
  subjectId: Scalars['String']['output'];
  /** Always `campaign` (the only subject kind). */
  subjectType: Scalars['String']['output'];
  timeline: Array<GqlTimelineBucketOutput>;
  /** Total measured campaign sessions across all channels (denominator). */
  totalSessionsInWindow: Scalars['Int']['output'];
  verifiedTrackedSessions: Scalars['Int']['output'];
}

/**
 * A surfaced creator-quality anomaly (#465). **Never emitted in v0** — the
 * list is always empty (detection deferred, see PATCHNOTES-465). The type
 * exists so the FE can build the card against a complete contract.
 */
export interface GqlTrafficAnomalyOutput {
  confidence?: Maybe<Scalars['Int']['output']>;
  explanation: Scalars['String']['output'];
  kind: GqlTrafficAnomalyKindEnum;
  subject: Scalars['String']['output'];
}

/**
 * Creator-quality anomaly kind (#465). **Never emitted in v0** — detection
 * requires `AuthAnalytic` signals the traffic-lift pipeline does not load. The
 * enum exists so the GraphQL contract is shape-complete; `anomalies` is always
 * empty and `anomalyKind` always `null`. See PATCHNOTES-465 (STOP-deferred).
 */
export const GqlTrafficAnomalyKindEnum = {
  EngagementPadding: 'ENGAGEMENT_PADDING',
  FollowerInflation: 'FOLLOWER_INFLATION',
  GeographicMismatch: 'GEOGRAPHIC_MISMATCH',
  TimingAnomaly: 'TIMING_ANOMALY',
  ViewDisparity: 'VIEW_DISPARITY',
} as const;

export type GqlTrafficAnomalyKindEnum =
  (typeof GqlTrafficAnomalyKindEnum)[keyof typeof GqlTrafficAnomalyKindEnum];
export interface GqlBaselineQualityOutput {
  anomalyDetected: Scalars['Boolean']['output'];
  shortWindow: Scalars['Boolean']['output'];
  truncated: Scalars['Boolean']['output'];
}

export interface GqlWindowOutput {
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
}

/** Verified/untracked session split for one platform (#465) — the stacked bar. */
export interface GqlPlatformLiftOutput {
  /**
   * 0–100 confidence (#465). STOP-DEFERRED → always `null`; use the report's
   * `band` / `bandLabel` for the directional confidence. See PATCHNOTES-465.
   */
  confidence?: Maybe<Scalars['Int']['output']>;
  estimatedUntrackedSessions: Scalars['Int']['output'];
  platform: Scalars['String']['output'];
  totalEstimated: Scalars['Int']['output'];
  /** `estimatedUntrackedSessions / totalEstimated`, in `0.0..=1.0`. */
  untrackedRatio: Scalars['Float']['output'];
  verifiedSessions: Scalars['Int']['output'];
}

export interface GqlChannelLiftOutput {
  baselineSessions: Scalars['Int']['output'];
  campaignSessions: Scalars['Int']['output'];
  channelGroup: Scalars['String']['output'];
  forecastLiftPct?: Maybe<Scalars['Float']['output']>;
  forecastSessions: Scalars['Int']['output'];
  /** `darkConsistent` | `tracked` | `other`. */
  kind: Scalars['String']['output'];
  sessionsAboveForecast: Scalars['Int']['output'];
}

export interface GqlInfluencerLiftRowOutput {
  /** Creator-quality anomaly (#465). Always `null` in v0 — STOP-deferred. */
  anomalyKind?: Maybe<GqlTrafficAnomalyKindEnum>;
  authId?: Maybe<Scalars['String']['output']>;
  /**
   * 0–100 calibrated confidence (#465). STOP-DEFERRED: there is no calibrated
   * basis for a per-creator percentage, so this is always `null` (FE renders
   * "—" / uses `confidenceTier`). See PATCHNOTES-465.
   */
  confidence?: Maybe<Scalars['Int']['output']>;
  /**
   * Grounded confidence tier (#465). Measurable creators inherit the report's
   * directional band; non-measurable creators are `directional`.
   */
  confidenceTier: GqlConfidenceTierEnum;
  /**
   * Estimated untracked influencer-driven sessions (#465). PROXY: the
   * campaign untracked remainder allocated by this creator's share of
   * verified tracking sessions. `null` for a non-measurable creator (no
   * per-creator signal → render "—").
   */
  estimatedUntrackedSessions?: Maybe<Scalars['Int']['output']>;
  handle: Scalars['String']['output'];
  /** `false` → render "not individually measurable — add tracking links". */
  measurable: Scalars['Boolean']['output'];
  platform: Scalars['String']['output'];
  /**
   * `verifiedSessions + estimatedUntrackedSessions` (#465). `null` when not
   * measurable.
   */
  totalEstimatedSessions?: Maybe<Scalars['Int']['output']>;
  verifiedSessions: Scalars['Int']['output'];
}

/**
 * Grounded confidence tier for an attribution estimate (#465). Never a
 * probability. `Directional` is the honest value for a creator with no direct
 * tracking signal — the row is a pure allocation.
 */
export const GqlConfidenceTierEnum = {
  Directional: 'DIRECTIONAL',
  High: 'HIGH',
  Low: 'LOW',
  Medium: 'MEDIUM',
} as const;

export type GqlConfidenceTierEnum =
  (typeof GqlConfidenceTierEnum)[keyof typeof GqlConfidenceTierEnum];
export interface GqlLiftPostMarkerOutput {
  authId?: Maybe<Scalars['String']['output']>;
  handle: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  postedAt: Scalars['String']['output'];
}

export interface GqlTimelineBucketOutput {
  actualSessions: Scalars['Int']['output'];
  bucket: Scalars['String']['output'];
  forecastSessions: Scalars['Int']['output'];
}

export interface GqlAccountContactInput {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}

/** #736 — input for `creatorProfile` / `indexCreatorProfile`. */
export interface GqlCreatorProfileInput {
  /**
   * Platform handle, with or without a leading `@`.
   *
   * A bare handle, NOT a URL — only the MCP `creator_profile` tool parses
   * profile URLs (and derives `source` from them). Pass a full URL here and
   * the lookup will simply miss.
   */
  handle: Scalars['String']['input'];
  /** Defaults to Instagram — the only platform the campaign sweep discovers on. */
  source?: InputMaybe<GqlAuthSource>;
}

/** #736 — result of opening a creator's card. */
export interface GqlCreatorProfileOutput {
  auth: GqlAuth;
  /**
   * `true` once the creator has a summary, i.e. the deep index finished.
   *
   * Deprecated by #741: it collapses "still running", "refused" and
   * "attempts exhausted" into one `false`, and a `true` does not imply the
   * creator is reachable by AI search. Read `state` and `searchable`.
   * @deprecated Too coarse (#741). Use `state` for the lifecycle and `searchable` for AI-search reachability.
   */
  fullyIndexed: Scalars['Boolean']['output'];
  /**
   * #741 — is this creator actually retrievable by AI/embedding search?
   *
   * `state = INDEXED` does NOT imply this: vectorization is skipped for
   * low-info profiles and embedding errors are swallowed rather than failing
   * the run, so a finished index can still leave no vector behind.
   */
  searchable: Scalars['Boolean']['output'];
  /** #741 — the indexing lifecycle state to render. */
  state: GqlCreatorIndexState;
}

/**
 * #741 — what the API says about a creator's indexing, replacing the
 * `fullyIndexed` bool that could not tell "in flight" from "refused" from
 * "attempts exhausted".
 */
export const GqlCreatorIndexState = {
  /**
   * The deep-index attempt ceiling is spent: reopening the card will NOT try
   * again. Promotion into a campaign is the way out.
   */
  AttemptsExhausted: 'ATTEMPTS_EXHAUSTED',
  /** An index run was attempted and terminally failed. */
  Failed: 'FAILED',
  /**
   * A deep index finished and left a usable summary. The full drawer
   * (posts, analytics, AI insights) has data.
   */
  Indexed: 'INDEXED',
  /**
   * A run is in flight — this call started one, the creator was already
   * processing, or another caller holds the claim. Poll again.
   */
  Indexing: 'INDEXING',
  /** Nothing indexed, nothing running. */
  NotIndexed: 'NOT_INDEXED',
  /**
   * A real profile exists but no deep index has run: no posts, no analytics,
   * no AI insights. This is an ENRICHED DISCOVERED creator — the case where
   * `auth.status` still reads `not_indexed` and must not be rendered as
   * "we know nothing about them".
   */
  ProfileOnly: 'PROFILE_ONLY',
  /** The platform account no longer resolves (deleted / renamed). Terminal. */
  Unresolvable: 'UNRESOLVABLE',
} as const;

export type GqlCreatorIndexState =
  (typeof GqlCreatorIndexState)[keyof typeof GqlCreatorIndexState];
export interface GqlGaAccountOutput {
  _id: Scalars['String']['output'];
  defaultPropertyId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  status: GqlGqlGoogleAccountStatus;
}

export interface GqlGaAccountListInput {
  /**
   * Hex id of the org's `OrgGoogleAccount` row (from `gaAccount.id`).
   * Picker queries no longer take a `gaConnectionId` (issue #453 §4.2a).
   */
  googleAccountId: Scalars['String']['input'];
}

/** Available option for GA accounts/properties selection */
export interface GqlGaConnectAvailableOption {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
}

/** A generic list view for pagination */
export interface GqlGaConnectionList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlGaConnectionOutput>;
  limit: Scalars['Int']['output'];
}

export interface GqlGaPropertiesListInput {
  /** GA-side numeric account id (e.g. `"171114564"`), from `gaAccountList`. */
  gaAccountId: Scalars['String']['input'];
  googleAccountId: Scalars['String']['input'];
}

export interface GqlGaWebStreamsListInput {
  gaPropertyId: Scalars['String']['input'];
  googleAccountId: Scalars['String']['input'];
}

export interface GqlGaWebStreamOption {
  defaultUri: Scalars['String']['output'];
  measurementId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  streamId: Scalars['String']['output'];
}

export interface GqlLinkbioPage {
  _id: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<GqlMediaOutput>;
  backgroundSettings?: Maybe<GqlLinkbioBackgroundSettings>;
  birthDate?: Maybe<Scalars['String']['output']>;
  contactDetails?: Maybe<GqlLinkbioContactDetailsEmbedded>;
  createdAt: Scalars['String']['output'];
  customDomain?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  linkIcons: Array<GqlLinkbioLinkIcon>;
  links: Array<GqlLinkbioLink>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  showContactInfo: Scalars['Boolean']['output'];
  showPerformanceProfile: Scalars['Boolean']['output'];
  subdomain?: Maybe<Scalars['String']['output']>;
  tabs: Array<GqlLinkbioTab>;
  tagline?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  username: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
}

export interface GqlLinkbioBackgroundSettings {
  advancedColor?: Maybe<GqlLinkbioBackgroundAdvancedColor>;
  avatarAlignmentType: GqlAvatarAlignmentType;
  avatarStrokeType: GqlAvatarStrokeType;
  backgroundImage?: Maybe<GqlBackgroundImage>;
  brandingHidden: Scalars['Boolean']['output'];
  colorMode: GqlColorMode;
  createdAt: Scalars['String']['output'];
  headerImageUrl: Scalars['String']['output'];
  linkbioId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlLinkbioBackgroundAdvancedColor {
  background: Scalars['String']['output'];
  icons: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  line: Scalars['String']['output'];
  primary: Scalars['String']['output'];
  secondary: Scalars['String']['output'];
  shadow1: Scalars['String']['output'];
  shadow2: Scalars['String']['output'];
  shadow3: Scalars['String']['output'];
  text: Scalars['String']['output'];
}

export const GqlAvatarAlignmentType = {
  Center: 'CENTER',
  Left: 'LEFT',
} as const;

export type GqlAvatarAlignmentType =
  (typeof GqlAvatarAlignmentType)[keyof typeof GqlAvatarAlignmentType];
export const GqlAvatarStrokeType = {
  BlackLine: 'BLACK_LINE',
  BlackLineDashed: 'BLACK_LINE_DASHED',
  BlackLineSolide: 'BLACK_LINE_SOLIDE',
  BlueLineSolide: 'BLUE_LINE_SOLIDE',
  VioletLineSolide: 'VIOLET_LINE_SOLIDE',
} as const;

export type GqlAvatarStrokeType =
  (typeof GqlAvatarStrokeType)[keyof typeof GqlAvatarStrokeType];
export const GqlBackgroundImage = {
  Artdeco: 'ARTDECO',
  Artdeco_1: 'ARTDECO_1',
  Artdeco_2: 'ARTDECO_2',
  Artdeco_3: 'ARTDECO_3',
  Basketball: 'BASKETBALL',
  Basketball_1: 'BASKETBALL_1',
  Beach: 'BEACH',
  Black: 'BLACK',
  Clouds: 'CLOUDS',
  Concrete: 'CONCRETE',
  Desert: 'DESERT',
  Fashion: 'FASHION',
  Flowers: 'FLOWERS',
  Football: 'FOOTBALL',
  Forest: 'FOREST',
  Golf: 'GOLF',
  Golf_4: 'GOLF_4',
  Golf_5: 'GOLF_5',
  GolfCourse: 'GOLF_COURSE',
  GolfPattern: 'GOLF_PATTERN',
  Icecream: 'ICECREAM',
  Lamp: 'LAMP',
  Marble: 'MARBLE',
  Moon: 'MOON',
  Mountains: 'MOUNTAINS',
  Nature: 'NATURE',
  Neon: 'NEON',
  Neon_2: 'NEON_2',
  Pirate: 'PIRATE',
  Pirate_1: 'PIRATE_1',
  Shell: 'SHELL',
  Skateboard: 'SKATEBOARD',
  Soccer: 'SOCCER',
  Soccer_1: 'SOCCER_1',
  Soccer_2: 'SOCCER_2',
  Space: 'SPACE',
  Stars: 'STARS',
  Tacos: 'TACOS',
  Tropical: 'TROPICAL',
  White: 'WHITE',
  Wood: 'WOOD',
} as const;

export type GqlBackgroundImage =
  (typeof GqlBackgroundImage)[keyof typeof GqlBackgroundImage];
export const GqlColorMode = {
  Basketball: 'BASKETBALL',
  Black: 'BLACK',
  Bubble: 'BUBBLE',
  Classic: 'CLASSIC',
  Dark: 'DARK',
  Electric: 'ELECTRIC',
  Football: 'FOOTBALL',
  Forest: 'FOREST',
  Golf: 'GOLF',
  Graphite: 'GRAPHITE',
  Light: 'LIGHT',
  Mint: 'MINT',
  Ocean: 'OCEAN',
  Peach: 'PEACH',
  Soccer: 'SOCCER',
  Summer: 'SUMMER',
  Sunset: 'SUNSET',
  Taco: 'TACO',
  White: 'WHITE',
} as const;

export type GqlColorMode = (typeof GqlColorMode)[keyof typeof GqlColorMode];
export interface GqlLinkbioContactDetailsEmbedded {
  buttonText: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  infoMessage: Scalars['String']['output'];
  targetEmail: Scalars['String']['output'];
}

export interface GqlLinkbioLinkIcon {
  _id: Scalars['ID']['output'];
  authId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  linkbioId: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  organizationId: Scalars['ID']['output'];
  source?: Maybe<GqlSources>;
  updatedAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
}

export const GqlSources = {
  AppleMusic: 'APPLE_MUSIC',
  Facebook: 'FACEBOOK',
  Generic: 'GENERIC',
  Instagram: 'INSTAGRAM',
  Linkedin: 'LINKEDIN',
  Pinterest: 'PINTEREST',
  Snapchat: 'SNAPCHAT',
  Soundcloud: 'SOUNDCLOUD',
  Spotify: 'SPOTIFY',
  Tiktok: 'TIKTOK',
  Twitch: 'TWITCH',
  Twitter: 'TWITTER',
  Youtube: 'YOUTUBE',
} as const;

export type GqlSources = (typeof GqlSources)[keyof typeof GqlSources];
export interface GqlLinkbioLink {
  _id: Scalars['ID']['output'];
  authId?: Maybe<Scalars['ID']['output']>;
  /**
   * Total clicks recorded via the `/b/{linkbioId}/{linkId}` redirect (#9101),
   * mirroring campaign tracking links.
   */
  clicks: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  imageHidden: Scalars['Boolean']['output'];
  /** RFC3339 timestamp of the most recent click; `null` for never-clicked links. */
  lastClickAt?: Maybe<Scalars['String']['output']>;
  linkbioId: Scalars['ID']['output'];
  media?: Maybe<GqlMediaOutput>;
  order: Scalars['Int']['output'];
  organizationId: Scalars['ID']['output'];
  pinned: Scalars['Boolean']['output'];
  pinnedAt?: Maybe<Scalars['String']['output']>;
  postId?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<GqlSources>;
  title: Scalars['String']['output'];
  /**
   * Approximate distinct-visitor count (#539 logic): the size of the salted
   * hash set, saturating at the server-side cap. `null` for legacy/never
   * clicked links. The underlying hashes are never exposed — only this count.
   */
  uniqueClicks?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface GqlLinkbioTab {
  _id: Scalars['ID']['output'];
  authId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  linkbioId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  organizationId: Scalars['ID']['output'];
  source?: Maybe<GqlSources>;
  type: GqlLinkbioMarkupTabType;
  updatedAt: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
}

export const GqlLinkbioMarkupTabType = {
  Donate: 'donate',
  Email: 'email',
  Links: 'links',
  Persona: 'persona',
  Product: 'product',
  Social: 'social',
  Subscribe: 'subscribe',
} as const;

export type GqlLinkbioMarkupTabType =
  (typeof GqlLinkbioMarkupTabType)[keyof typeof GqlLinkbioMarkupTabType];
/** A generic list view for pagination */
export interface GqlLinkbioPageList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlLinkbioPage>;
  limit: Scalars['Int']['output'];
}

export interface GqlOrganizationListInput {
  listViewParams: GqlListViewParamsInput;
}

export interface GqlPostCommentListInput {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['String']['input'];
}

export interface GqlPostCommentListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlPostCommentOutput>;
}

export interface GqlPostCommentOutput {
  _id: Scalars['String']['output'];
  commentedAt?: Maybe<Scalars['String']['output']>;
  commenterUsername?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  isReply: Scalars['Boolean']['output'];
  likes: Scalars['Int']['output'];
  postId: Scalars['String']['output'];
  replyCount: Scalars['Int']['output'];
  text: Scalars['String']['output'];
}

/** Dimension to break the daily usage chart down by (the "By X" toggle). */
export const GqlLlmUsageDimensionInput = {
  /** By feature — "where" the usage went (AI Chat, AI Search, …). */
  Feature: 'FEATURE',
  /** By resolved provider model id. */
  Model: 'MODEL',
} as const;

export type GqlLlmUsageDimensionInput =
  (typeof GqlLlmUsageDimensionInput)[keyof typeof GqlLlmUsageDimensionInput];
/**
 * Daily per-org usage over a date range — flat `(day, key)` points plus range
 * totals. The FE pivots `points` into stacked series keyed by `key`.
 */
export interface GqlLlmUsageDailyOutput {
  callCount: Scalars['Int']['output'];
  estimatedCostUsd: Scalars['Float']['output'];
  points: Array<GqlLlmUsageDailyPointOutput>;
  totalTokens: Scalars['Int']['output'];
}

/**
 * One `(day, key)` bucket of the daily usage chart. `key` is the feature name
 * or model id depending on the query's `groupBy`.
 */
export interface GqlLlmUsageDailyPointOutput {
  callCount: Scalars['Int']['output'];
  /** UTC calendar day, `YYYY-MM-DD`. */
  day: Scalars['String']['output'];
  estimatedCostUsd: Scalars['Float']['output'];
  /** Feature name or model id (per `groupBy`). */
  key: Scalars['String']['output'];
  totalTokens: Scalars['Int']['output'];
}

export interface GqlLlmUsageSummaryOutput {
  breakdown: Array<GqlLlmUsageBreakdownOutput>;
  callCount: Scalars['Int']['output'];
  estimatedCostUsd: Scalars['Float']['output'];
  totalTokens: Scalars['Int']['output'];
}

export interface GqlLlmUsageBreakdownOutput {
  callCount: Scalars['Int']['output'];
  estimatedCostUsd: Scalars['Float']['output'];
  feature: Scalars['String']['output'];
  totalTokens: Scalars['Int']['output'];
}

export const GqlGqlNotificationType = {
  AuthConnected: 'AUTH_CONNECTED',
  AuthTokenExpired: 'AUTH_TOKEN_EXPIRED',
  AuthTokenExpiring: 'AUTH_TOKEN_EXPIRING',
  CampaignAiActionExecuted: 'CAMPAIGN_AI_ACTION_EXECUTED',
  CampaignAiActionSuggested: 'CAMPAIGN_AI_ACTION_SUGGESTED',
  CampaignAutoLaunchBlocked: 'CAMPAIGN_AUTO_LAUNCH_BLOCKED',
  CampaignAutoLaunched: 'CAMPAIGN_AUTO_LAUNCHED',
  CampaignDeliverablesMet: 'CAMPAIGN_DELIVERABLES_MET',
  CampaignDeliverablesPartial: 'CAMPAIGN_DELIVERABLES_PARTIAL',
  CampaignEndApproaching: 'CAMPAIGN_END_APPROACHING',
  CampaignEnded: 'CAMPAIGN_ENDED',
  CampaignInfluencerAdded: 'CAMPAIGN_INFLUENCER_ADDED',
  CampaignInfluencerRemoved: 'CAMPAIGN_INFLUENCER_REMOVED',
  CampaignNewPost: 'CAMPAIGN_NEW_POST',
  CampaignPaymentCompleted: 'CAMPAIGN_PAYMENT_COMPLETED',
  CampaignPaymentEligible: 'CAMPAIGN_PAYMENT_ELIGIBLE',
  CampaignPostEngagementChanged: 'CAMPAIGN_POST_ENGAGEMENT_CHANGED',
  CampaignTaskDeadlineApproaching: 'CAMPAIGN_TASK_DEADLINE_APPROACHING',
  CampaignTaskDeadlinePassed: 'CAMPAIGN_TASK_DEADLINE_PASSED',
  CreatorAgentActionExecuted: 'CREATOR_AGENT_ACTION_EXECUTED',
  CreatorAgentActionSuggested: 'CREATOR_AGENT_ACTION_SUGGESTED',
  CreatorOfferAutoDeclined: 'CREATOR_OFFER_AUTO_DECLINED',
  CreatorOfferExpiring: 'CREATOR_OFFER_EXPIRING',
  CreatorOfferReceived: 'CREATOR_OFFER_RECEIVED',
  CreatorSafetyFlagsDetected: 'CREATOR_SAFETY_FLAGS_DETECTED',
  CreatorTaskDeadlineApproaching: 'CREATOR_TASK_DEADLINE_APPROACHING',
  CreatorTaskPaymentReceived: 'CREATOR_TASK_PAYMENT_RECEIVED',
  CreatorTaskReceived: 'CREATOR_TASK_RECEIVED',
  DeepLookupCompleted: 'DEEP_LOOKUP_COMPLETED',
  DeepLookupFailed: 'DEEP_LOOKUP_FAILED',
  GaConnectionNeedsWebStream: 'GA_CONNECTION_NEEDS_WEB_STREAM',
  InviteAccepted: 'INVITE_ACCEPTED',
  InviteBrandSent: 'INVITE_BRAND_SENT',
  InviteCreatorSent: 'INVITE_CREATOR_SENT',
  PaymentInvoiceSent: 'PAYMENT_INVOICE_SENT',
  PaymentReceived: 'PAYMENT_RECEIVED',
  PayoutFailed: 'PAYOUT_FAILED',
  SystemAlert: 'SYSTEM_ALERT',
  WelcomeMessage: 'WELCOME_MESSAGE',
} as const;

export type GqlGqlNotificationType =
  (typeof GqlGqlNotificationType)[keyof typeof GqlGqlNotificationType];
export interface GqlNotificationListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlNotificationOutput>;
}

export interface GqlNotificationOutput {
  accountId?: Maybe<Scalars['String']['output']>;
  actionUrl?: Maybe<Scalars['String']['output']>;
  actorAccountId?: Maybe<Scalars['String']['output']>;
  actorKind: Scalars['String']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  ctaLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  notificationType: GqlGqlNotificationType;
  organizationId: Scalars['String']['output'];
  readAt?: Maybe<Scalars['String']['output']>;
  secondaryEntityId?: Maybe<Scalars['String']['output']>;
  /**
   * What the notification is *about*, beyond the campaign/deep-lookup it
   * belongs to: `post` / `auth` / `task` / `payment` (#26). Null when the
   * primary entity is the whole story. The domain has carried this pair
   * since deep lookup; campaign notifications now populate it too, and this
   * mapping used to drop it for everything.
   */
  secondaryEntityType?: Maybe<Scalars['String']['output']>;
  severity: GqlGqlNotificationSeverity;
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  sourceEntityType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export const GqlGqlNotificationSeverity = {
  Critical: 'CRITICAL',
  Info: 'INFO',
  Warning: 'WARNING',
} as const;

export type GqlGqlNotificationSeverity =
  (typeof GqlGqlNotificationSeverity)[keyof typeof GqlGqlNotificationSeverity];
export interface GqlOrganizationCampaignAuthTaskListInput {
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  listViewParams: GqlListViewParamsInput;
}

/** Output representing an organization's participation in a campaign. */
export interface GqlOrganizationCampaignOutput {
  _id: Scalars['String']['output'];
  authId: Scalars['String']['output'];
  campaignAuthTaskId: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
}

/** Input for finding organization campaigns by auth task secret. */
export interface GqlOrganizationCampaignBySecretInput {
  authTaskSecret: Scalars['String']['input'];
}

/**
 * Period for the org commerce rollup. RFC3339 timestamps; the window is
 * half-open `[start, end)` so the prior-period delta never double-counts
 * a boundary order.
 */
export interface GqlCommercePeriodInput {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
}

/**
 * wiki#17 — ONE org-scoped query that powers both the home
 * "Revenue & impact" widget AND the cross-campaign Revenue page,
 * without N+1 per-campaign calls. Money is i64 minor USD units.
 *
 * `priorAttributedRevenue` / `priorOrderCount` are the
 * immediately-preceding equal-length window's totals — the FE computes
 * the "+12%" headline from `(attributedRevenue - prior) / prior`
 * (emitting the raw prior keeps us from returning NaN/Inf for a
 * zero baseline).
 */
export interface GqlOrganizationCommerceSummaryOutput {
  aov?: Maybe<Scalars['Int']['output']>;
  attributedRevenue: Scalars['Int']['output'];
  byCampaign: Array<GqlOrgCampaignBreakdownOutput>;
  orderCount: Scalars['Int']['output'];
  pendingFx: Array<GqlOrgPendingFxBucketOutput>;
  priorAttributedRevenue: Scalars['Int']['output'];
  priorOrderCount: Scalars['Int']['output'];
  roas?: Maybe<Scalars['Float']['output']>;
  roi?: Maybe<Scalars['Float']['output']>;
  topCreators: Array<GqlOrgTopCreatorOutput>;
  trend: Array<GqlOrgRevenueTrendPointOutput>;
  unresolvedOrderCount: Scalars['Int']['output'];
}

/**
 * Per-campaign slice of the org rollup, for the cross-campaign Revenue
 * page table.
 */
export interface GqlOrgCampaignBreakdownOutput {
  attributedRevenue: Scalars['Int']['output'];
  campaignId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  roas?: Maybe<Scalars['Float']['output']>;
}

/**
 * Org-wide pendingFx currency bucket. Mirrors
 * [`PendingFxBucketOutput`] but at org scope.
 */
export interface GqlOrgPendingFxBucketOutput {
  currency: Scalars['String']['output'];
  pendingCount: Scalars['Int']['output'];
  unavailableCount: Scalars['Int']['output'];
}

/**
 * Top creator by revenue across ALL of the org's campaigns. `handle` is
 * resolved by the FE from `auth_id` (a separate loader call) — matches
 * `CreatorCommercePerformanceOutput`, which keeps this leaf cheap.
 */
export interface GqlOrgTopCreatorOutput {
  attributedRevenue: Scalars['Int']['output'];
  authId: Scalars['ID']['output'];
  orderCount: Scalars['Int']['output'];
}

/**
 * One UTC-day point of the revenue trend (sparkline). `day` is
 * `YYYY-MM-DD`. Every day in the window is present (zero-filled).
 */
export interface GqlOrgRevenueTrendPointOutput {
  attributedRevenue: Scalars['Int']['output'];
  day: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
}

export interface GqlOrganizationCreditBalanceObject {
  /**
   * Derived from `balanceUsdMicros / 10_000` (#582 Stage C).
   * @deprecated use balanceUsdMicros (integer micro-USD); credits are derived micros/10_000
   */
  balanceCredits: Scalars['Int']['output'];
  /**
   * Current balance in integer micro-USD (`1 credit = 10_000 micros`).
   * Authoritative money value (#582 Stage C).
   */
  balanceUsdMicros: Scalars['Int']['output'];
  lastToppedUpAt?: Maybe<Scalars['String']['output']>;
  lastToppedUpBy?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  /**
   * Per-org overdraft allowance (soft-cap, #381 Option 2). Derived from
   * `overdraftLimitUsdMicros / 10_000`. Set on the org page via
   * `setOrganizationOverdraftLimit`.
   * @deprecated use overdraftLimitUsdMicros (integer micro-USD); credits are derived micros/10_000
   */
  overdraftLimitCredits: Scalars['Int']['output'];
  /**
   * Per-org overdraft allowance in micro-USD (soft-cap, #381 Option 2). A
   * charge is allowed while `balanceUsdMicros + overdraftLimitUsdMicros >=
   * cost`; `0` means hard-block at zero.
   */
  overdraftLimitUsdMicros: Scalars['Int']['output'];
  /**
   * Lifetime sum of positive admin grants. Negative admin reductions are
   * NOT subtracted here — they live in the audit log only. Derived from
   * `totalToppedUpUsdMicros / 10_000`.
   * @deprecated use totalToppedUpUsdMicros (integer micro-USD); credits are derived micros/10_000
   */
  totalToppedUpCredits: Scalars['Int']['output'];
  /**
   * Lifetime sum of positive admin grants, in micro-USD. Negative admin
   * reductions are NOT subtracted here — they live in the audit log only.
   */
  totalToppedUpUsdMicros: Scalars['Int']['output'];
}

export interface GqlOrganizationCreditHistoryPageObject {
  entries: Array<GqlCreditTopUpLogEntryObject>;
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
}

export interface GqlCreditTopUpLogEntryObject {
  /**
   * Derived from `amountAppliedUsdMicros / 10_000`.
   * @deprecated use amountAppliedUsdMicros (integer micro-USD); credits are derived micros/10_000
   */
  amountApplied: Scalars['Int']['output'];
  /** Applied amount in micro-USD. */
  amountAppliedUsdMicros: Scalars['Int']['output'];
  /**
   * Derived from `amountRequestedUsdMicros / 10_000`.
   * @deprecated use amountRequestedUsdMicros (integer micro-USD); credits are derived micros/10_000
   */
  amountRequested: Scalars['Int']['output'];
  /** Requested amount in micro-USD (#582 Stage C). */
  amountRequestedUsdMicros: Scalars['Int']['output'];
  /**
   * Derived from `balanceAfterUsdMicros / 10_000`.
   * @deprecated use balanceAfterUsdMicros (integer micro-USD); credits are derived micros/10_000
   */
  balanceAfter: Scalars['Int']['output'];
  /** Post-top-up balance in micro-USD. */
  balanceAfterUsdMicros: Scalars['Int']['output'];
  byAccountId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
}

/**
 * The org's custom sender domain config as seen through the API. `dnsRecords`
 * are derived from the stored DKIM tokens (DKIM CNAMEs + recommended
 * SPF/DMARC/MAIL FROM) so the settings UI can always re-render them.
 */
export interface GqlOrganizationEmailConfigOutput {
  createdAt: Scalars['String']['output'];
  dnsRecords: Array<GqlDnsRecordOutput>;
  fromAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  senderDomain: Scalars['String']['output'];
  status: GqlDomainVerificationStatusGql;
  updatedAt: Scalars['String']['output'];
}

/** A DNS record the customer must publish to verify + protect their domain. */
export interface GqlDnsRecordOutput {
  name: Scalars['String']['output'];
  /** MX priority, when applicable. */
  priority?: Maybe<Scalars['Int']['output']>;
  /** `CNAME` / `TXT` / `MX`. */
  recordType: Scalars['String']['output'];
  /** `true` for DKIM (required to verify); `false` for SPF/DMARC (recommended). */
  required: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
}

/** SES DKIM verification lifecycle of a custom sender domain. */
export const GqlDomainVerificationStatusGql = {
  Failed: 'FAILED',
  Pending: 'PENDING',
  Verified: 'VERIFIED',
} as const;

export type GqlDomainVerificationStatusGql =
  (typeof GqlDomainVerificationStatusGql)[keyof typeof GqlDomainVerificationStatusGql];
export interface GqlOrganizationMemberListInput {
  listViewParams: GqlListViewParamsInput;
}

export interface GqlOrganizationPaymentDetailsListInput {
  listViewParams: GqlListViewParamsInput;
}

export interface GqlOrganizationPaymentDetailsListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlOrganizationPaymentDetailsOutput>;
}

export interface GqlOrganizationPayoutsListInput {
  listViewParams: GqlListViewParamsInput;
}

export interface GqlCampaignPayoutListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlCampaignPayoutOutput>;
}

export interface GqlOrganizationRoleListInput {
  listViewParams: GqlListViewParamsInput;
}

/** A generic list view for pagination */
export interface GqlOrganizationRoleList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlOrganizationRoleObject>;
  limit: Scalars['Int']['output'];
}

export interface GqlOrganizationRoleObject {
  _id: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  permissions: Array<GqlOrganizationPermissionItemObject>;
  priority?: Maybe<Scalars['Int']['output']>;
  roleType: GqlGraphqlOrganizationRoleType;
  updatedAt: Scalars['String']['output'];
}

export interface GqlOrganizationShippingDetailsListInput {
  listViewParams: GqlListViewParamsInput;
}

export interface GqlOrganizationShippingDetailsListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlOrganizationShippingDetailsOutput>;
}

export interface GqlOrganizationShippingDetailsOutput {
  _id: Scalars['ID']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
}

/**
 * Verdict tier of a membership-edge assessment, mirroring the domain
 * `MembershipEdgeStatus`. `Review` is the conflict-queue state.
 */
export const GqlMembershipEdgeStatusOutput = {
  /** Merge confirmed and applied (membership already lives on `persona_id`). */
  Confirmed: 'CONFIRMED',
  /** Merge refused (brand/referral). Recorded for idempotency. */
  Rejected: 'REJECTED',
  /** Ambiguous — awaiting human/AI resolution. The conflict queue. */
  Review: 'REVIEW',
} as const;

export type GqlMembershipEdgeStatusOutput =
  (typeof GqlMembershipEdgeStatusOutput)[keyof typeof GqlMembershipEdgeStatusOutput];
/**
 * A single non-authoritative persona-membership conflict/evidence edge.
 *
 * Exposes the edge ids only (the frontend resolves candidate/persona detail via
 * existing `persona` / auth queries); `candidateUsername` / `candidateSource`
 * are a cheap convenience hydrated via the shared `AuthLoader`.
 */
export interface GqlPersonaConflictOutput {
  candidateAuthId: Scalars['String']['output'];
  /** Candidate source platform, hydrated via the shared `AuthLoader` (batched). */
  candidateSource?: Maybe<GqlAuthSource>;
  /** Candidate username, hydrated via the shared `AuthLoader` (batched). */
  candidateUsername?: Maybe<Scalars['String']['output']>;
  /** When the edge was first created (RFC 3339). */
  createdAt: Scalars['String']['output'];
  /** The edge document id (hex). Pass back into `resolvePersonaConflict`. */
  id: Scalars['String']['output'];
  personaId: Scalars['String']['output'];
  /** Coarse provenance label (e.g. "BioLink", "TransitiveScrape"). */
  provenanceKind: Scalars['String']['output'];
  /** When the edge was resolved, if it has been (RFC 3339). */
  resolvedAt?: Maybe<Scalars['String']['output']>;
  /** Who resolved it, if resolved. */
  resolvedBy?: Maybe<GqlMembershipEdgeActorOutput>;
  score: Scalars['Float']['output'];
  signals: Array<Scalars['String']['output']>;
  status: GqlMembershipEdgeStatusOutput;
}

/** Who resolved an edge. Mirrors the domain `Actor`. */
export const GqlMembershipEdgeActorOutput = {
  /** Resolved by an AI agent (PR-F). */
  Ai: 'AI',
  /** Resolved automatically by the guard's own verdict. */
  Auto: 'AUTO',
  /** Resolved by a human via the conflict queue. */
  Human: 'HUMAN',
} as const;

export type GqlMembershipEdgeActorOutput =
  (typeof GqlMembershipEdgeActorOutput)[keyof typeof GqlMembershipEdgeActorOutput];
export interface GqlPostByIdInput {
  postId: Scalars['String']['input'];
}

export interface GqlPromoCodePerformanceOutput {
  aov?: Maybe<Scalars['Int']['output']>;
  attributedRevenue: Scalars['Int']['output'];
  orderCount: Scalars['Int']['output'];
  pendingFx: Array<GqlPendingFxBucketOutput>;
  preliminaryRevenue: Scalars['Int']['output'];
  promoCode: GqlCampaignPromoCodeOutput;
  roi?: Maybe<Scalars['Float']['output']>;
  /**
   * FX-unresolved settled orders attributed to this promo code
   * (#445). Parallel to `orderCount` — see
   * [`CampaignCommerceSummaryOutput::unresolved_order_count`].
   */
  unresolvedOrderCount: Scalars['Int']['output'];
}

/**
 * The single public directory payload. The landing fetches this once and does
 * all roll-up in memory.
 */
export interface GqlPublicDirectory {
  industries: Array<GqlPublicIndustry>;
  influencers: Array<GqlPublicInfluencer>;
  locations: Array<GqlPublicLocation>;
}

/**
 * Public industry taxonomy node. Pure SEO/navigation metadata — no sensitive
 * fields exist on the source `EmitIndustry`.
 */
export interface GqlPublicIndustry {
  childIndustryIds: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  featured: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ogDescription: Scalars['String']['output'];
  ogImage: Scalars['String']['output'];
  ogTitle: Scalars['String']['output'];
  parentIndustryId?: Maybe<Scalars['String']['output']>;
  pluralName: Scalars['String']['output'];
  relatedIndustryIds: Array<Scalars['String']['output']>;
  seoDescription: Scalars['String']['output'];
  seoTitle: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
}

/**
 * Public influencer card. Mirrors the leak-safe `EmitInfluencer` shape: only
 * whitelisted public data carries real values; the analytic/pricing teaser
 * fields are always zeroed by the gate; contact/demographics are ABSENT (no
 * field declared). `lockedProfileFields` are label strings, not values.
 */
export interface GqlPublicInfluencer {
  audienceSummary: Scalars['String']['output'];
  brandFitCategories: Array<Scalars['String']['output']>;
  contentSummary: Scalars['String']['output'];
  engagementRate: Scalars['Float']['output'];
  estimatedAverageViews: Scalars['Int']['output'];
  estimatedCost: GqlPublicCostRange;
  handle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isUnlocked: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  lockedProfileFields: Array<Scalars['String']['output']>;
  marbleScore: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  platforms: Array<GqlPublicPlatform>;
  primaryIndustry: Scalars['String']['output'];
  primaryIndustryId?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  publicProfileFields: Array<Scalars['String']['output']>;
  secondaryIndustries: Array<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  topics: Array<Scalars['String']['output']>;
  totalFollowers: Scalars['Int']['output'];
}

/**
 * Zeroed cost teaser (always `{0,0}` from the gate — no real pricing). Kept so
 * the landing can render the locked "estimated cost" affordance.
 */
export interface GqlPublicCostRange {
  currency: Scalars['String']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  per: Scalars['String']['output'];
}

/**
 * A public influencer platform link ("sameAs"). Handle + URL only — no gated
 * analytics.
 */
export interface GqlPublicPlatform {
  followers?: Maybe<Scalars['Int']['output']>;
  handle?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
}

/** Public location taxonomy node. Pure SEO/navigation metadata. */
export interface GqlPublicLocation {
  childLocationIds: Array<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  ogDescription: Scalars['String']['output'];
  ogImage: Scalars['String']['output'];
  ogTitle: Scalars['String']['output'];
  parentLocationId?: Maybe<Scalars['String']['output']>;
  relatedLocationIds: Array<Scalars['String']['output']>;
  seoDescription: Scalars['String']['output'];
  seoTitle: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlAccountPasswordResetTokenRequestInput {
  challengeString: Scalars['String']['input'];
}

export interface GqlAccountTokenOutput {
  access?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  passwordChange?: Maybe<Scalars['String']['output']>;
}

/**
 * One row of the `shopifyDiscounts(storeId)` picker. The picker is a live
 * fetch — no Marble-side persistence — so the shape mirrors only what an
 * admin needs to recognize a discount before linking it.
 */
export interface GqlShopifyDiscountSummaryOutput {
  code: Scalars['String']['output'];
  redemptionCount: Scalars['Int']['output'];
  /** `gid://shopify/DiscountCodeNode/...`. */
  shopifyDiscountId: Scalars['ID']['output'];
  status: GqlPromoCodeStatusGql;
}

/**
 * One row of the `shopifyProducts(storeId)` Marble-mirror read.
 *
 * Two deliberate divergences from the spec's GraphQL block
 * (`docs/modules/integrations/shopify-promocode-mirror.md`, lines
 * 152-161):
 * - **`status` stays a `String`** — Shopify-side value (`active` /
 * `draft` / `archived`), free-form per the domain entity. Modelling
 * it as a GraphQL enum would block the mirror on any new Shopify
 * status value.
 * - **Money fields are `Int`** (minor currency units). The
 * whole-codebase money convention is money-as-i64; FE divides at
 * display time. Spec's `Float` wording is aspirational.
 */
export interface GqlShopifyProductOutput {
  /**
   * RFC 3339 timestamp of the *mirror's* first write (when the poll
   * worker first observed this product). Stable across re-upserts.
   */
  createdAt: Scalars['String']['output'];
  /**
   * ISO 4217 (`USD`, `EUR`, …); `null` when the mirror has no
   * variants to read currency from.
   */
  currency?: Maybe<Scalars['String']['output']>;
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  priceMax?: Maybe<Scalars['Int']['output']>;
  /**
   * Variant price range — minor currency units (e.g. `4500` = $45.00).
   * `null` when the product has no variants yet.
   */
  priceMin?: Maybe<Scalars['Int']['output']>;
  /** Shopify product GID, e.g. `gid://shopify/Product/123`. */
  shopifyProductId: Scalars['String']['output'];
  shopifyStoreId: Scalars['ID']['output'];
  /** Free-form Shopify-side status (`active` / `draft` / `archived`). */
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /**
   * RFC 3339 timestamp of the *mirror's* last write (when the poll
   * worker last upserted this row). Useful for staleness diagnostics;
   * diverges from `updated_at_shopify` on no-op poll boundaries.
   */
  updatedAt: Scalars['String']['output'];
  /**
   * Shopify-side `updated_at` — when this product last changed in
   * the brand's shop. RFC 3339 string. Diverges from the wall-clock
   * `updated_at` (which marks the *mirror's* last write).
   */
  updatedAtShopify: Scalars['String']['output'];
}

/**
 * One variant of a Shopify product — live-fetched for the gifting
 * create picker (`shopifyProductVariants`). The Track B `ShopifyProduct`
 * mirror omits variants, so the gift create form reads `variantId`
 * (+ label + price) from here. `price` is minor currency units in the
 * store's currency (read `ShopifyStoreOutput.currency` for the symbol).
 */
export interface GqlShopifyProductVariantOutput {
  availableForSale: Scalars['Boolean']['output'];
  /**
   * Minor currency units; `null` when Shopify's price string can't be
   * parsed to integer minor units.
   */
  price?: Maybe<Scalars['Int']['output']>;
  /**
   * `gid://shopify/ProductVariant/...` — pass as a line item's
   * `variantId` to `campaignGiftCreate`.
   */
  shopifyVariantId: Scalars['ID']['output'];
  /**
   * Variant label (e.g. `"M / Black"`); `"Default Title"` for
   * single-variant products — treat that as "no variant choice".
   */
  title: Scalars['String']['output'];
}

export interface GqlUtmTemplateOutput {
  _id: Scalars['String']['output'];
  campaignTemplate: Scalars['String']['output'];
  contentTemplate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  mediumTemplate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  /** #540a — vanity short-code template (e.g. `{auth_handle}-{campaign_slug}`). */
  shortLinkTemplate?: Maybe<Scalars['String']['output']>;
  sourceTemplate: Scalars['String']['output'];
  termTemplate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
}

export interface GqlMutationRoot {
  acceptInvitation: Scalars['Boolean']['output'];
  accountContactVerificationResend: Scalars['Boolean']['output'];
  adminAddOrganizationMember: Scalars['Boolean']['output'];
  adminCreateAccount: GqlAdminAccountObject;
  adminCreateOrganization: GqlOrganizationWithProfileObject;
  adminCreatorNetworkCreateIndustry: GqlAdminIndustryObject;
  adminCreatorNetworkCreateInfluencerList: GqlAdminInfluencerListDetail;
  adminCreatorNetworkCreateLocation: GqlAdminLocationObject;
  adminCreatorNetworkGenerateInfluencerList: GqlAdminInfluencerListDetail;
  /**
   * #571 — emit the curated directory (Active taxonomy + lists) to
   * marble-landing. **`dryRun` defaults to `true`**: a dry run builds and
   * validates the JSON, writes it to a scratch dir, and reports the counts +
   * what a live run WOULD publish — it never touches the live site. A live
   * publish (`dryRun: false`) is additionally gated in the infra publisher
   * (`MARBLE_LANDING_DIR` + `CREATOR_NETWORK_EMIT_ALLOW_PUSH`). This is also
   * the clean entry point a future engine-cron can call.
   */
  adminCreatorNetworkPublishDirectory: GqlAdminPublishDirectoryResult;
  adminCreatorNetworkSetIndustryStatus: GqlAdminIndustryObject;
  adminCreatorNetworkSetInfluencerListStatus: GqlAdminInfluencerListObject;
  adminCreatorNetworkSetLocationStatus: GqlAdminLocationObject;
  adminCreatorNetworkUpdateIndustry: GqlAdminIndustryObject;
  adminCreatorNetworkUpdateListMembers: GqlAdminInfluencerListDetail;
  adminCreatorNetworkUpdateLocation: GqlAdminLocationObject;
  adminDeleteOrganization: Scalars['Boolean']['output'];
  adminDeleteOrganizationMember: Scalars['Boolean']['output'];
  adminEnrichBrandContext: GqlBrandContextObject;
  /**
   * Force shallow enrichment for a list of auths. Calibration smoke
   * tool for AI Search recall fix (#357) — drives the same
   * `ShallowEnrichUseCase` the rank flow uses, but bypassing the
   * rank-flow cold-gate so the operator can deterministically
   * populate `contentCategories`/`postingThemes`/etc. for known
   * target IDs without having to land them in a real search's
   * top-N. The use case's own `try_claim`/`shallow_attempted_at`
   * invariants still apply — concurrent admin calls for the same
   * auth_id will short-circuit to `Conflict`.
   *
   * Capped at 20 auth_ids per call: with ~5–8 s LLM latency per
   * auth and the existing `SHALLOW_ENRICH_CONCURRENCY_CAP` semaphore
   * gating the fan-out, 20 fits comfortably under typical GraphQL
   * request timeouts. For the #357 calibration matrix (9 auths)
   * this is ~1 minute end-to-end.
   */
  adminForceShallowEnrich: Array<GqlAdminForceShallowEnrichResultObject>;
  /**
   * Mint a short-lived session token for `accountId` so a superadmin can
   * enter the main app *as* that account (support/debugging).
   *
   * The returned string is an ordinary account-scoped session JWT — same
   * claims shape a password login yields — so the app behaves exactly as
   * that user with no impersonation-aware code path in the frontend. It
   * differs only in lifetime: `IMPERSONATION_TOKEN_TTL_SECS`
   * (5 minutes) rather than the configured `session_expiry_secs`.
   *
   * Security notes for reviewers:
   * - Gated by `require_superadmin`, the same guard every other admin
   * mutation uses.
   * - The target account must exist; we do not mint for unknown ids.
   * - Every call is logged at INFO with both account ids so an
   * impersonation can be reconstructed after the fact.
   * - The short TTL bounds the *handoff window*, not the resulting session:
   * once the frontend loads, it swaps this token for a normal-lifetime
   * organization token via `OrganizationObject::token` (the same upgrade
   * every login performs). Shortening the impersonated session itself
   * would require an impersonation marker in the claims, which would
   * break the "behaves exactly as that user" requirement.
   */
  adminImpersonateAccount: Scalars['String']['output'];
  adminInviteOrganizationMember: Scalars['Boolean']['output'];
  /**
   * Re-drive a dead-lettered auth_outbox envelope back to `pending`.
   * Returns `true` if the envelope was reset, `false` if no matching
   * dead-lettered envelope was found. See issue #305.
   */
  adminRedriveAuthDlqEnvelope: Scalars['Boolean']['output'];
  /**
   * Re-enqueue indexing for auths stranded in `status: processing`
   * past `thresholdMinutes`. Targets the legacy silent-skip class
   * (1k+ rows on stage4) that pre-dates the
   * `is_hiker_user_not_found` narrowing. Idempotent per stuck
   * **epoch**: outbox dedup keys on the `rescue:<processing_run_id>`
   * correlation (#653), so re-running against the same stuck rows is
   * a no-op, while a genuinely-fresh epoch is never suppressed.
   * Bounded by `limit` to keep HikerAPI usage predictable.
   */
  adminRescueStuckAuths: GqlAdminRescueStuckAuthsResult;
  adminSetDemoRequestProcessed: Scalars['Boolean']['output'];
  adminSetSuperadmin: Scalars['Boolean']['output'];
  adminSetVerified: Scalars['Boolean']['output'];
  adminUpdateCampaignStatus: GqlCampaignOutput;
  adminUpdateOrganizationMember: Scalars['Boolean']['output'];
  adminUpdatePassword: Scalars['Boolean']['output'];
  /**
   * Create an affiliate program (lean, single-step — NOT the deferred
   * 6-step drawer). Requires `SettingsManage`.
   */
  affiliateProgramCreate: GqlAffiliateProgramOutput;
  /** Enrol a creator into a program. Requires `SettingsManage`. */
  affiliateProgramEnroll: GqlProgramEnrollmentOutput;
  /** Cancel the active turn in a session (user presses Stop) */
  aiChatCancelTurn: Scalars['Boolean']['output'];
  /** Delete a chat session and all its messages/turns */
  aiChatDeleteSession: Scalars['Boolean']['output'];
  /** Send a message in a chat session (creates session if sessionId is None) */
  aiChatSendMessage: GqlSendMessageOutput;
  /** Set the execution mode for a session (safe = confirm before actions, auto = execute immediately) */
  aiChatSetExecutionMode: Scalars['Boolean']['output'];
  /**
   * Create a new search session and generate ranking criteria from the prompt.
   *
   * Mirrors the MCP `search_create` tool: runs the LLM criteria generator,
   * persists the history + first stage, and returns the created history.
   * Does NOT execute the search — the FE drives subsequent stages.
   *
   * This is the user-initiated product boundary for AI Search, so it charges
   * the flat `AiSearch` package (#580 — closes the priced-but-unwired leak).
   * `create_search.execute` runs inline (returns before the resolver
   * returns), so the closure-based `require_credits` fits: it charges up
   * front and refunds on failure automatically — no detached `charge()`
   * plumbing needed (unlike DeepLookup/BrandEnrichment). The chat-driven
   * path (MCP `search_create` under `ai_chat_send_message`) is deliberately
   * NOT charged here — it already charges `ChatMessage`; charging AiSearch
   * there too would double-bill. Enforcement follows the shared
   * `CreditEnforcementMode`: under prod-default `WarnOnly` an insufficient
   * balance proceeds un-charged (no block) — this phase does not flip that.
   */
  aiSearchCreate: GqlAiSearchHistoryOutput;
  /** Delete a search history and all associated data */
  aiSearchDelete: Scalars['Boolean']['output'];
  authConnectTokenless: GqlAuth;
  /**
   * Contact an influencer via email from the platform (issue #498).
   *
   * Sends the brand member's message from Marble's dedicated outreach SES
   * identity (`EmailCategory::Outreach`), with `Reply-To` set to the
   * sender's account email so the influencer replies straight to the brand.
   * Requires an authenticated organization context; the send is attributed
   * to that org for suppression scoping + audit.
   */
  authContactInfluencer: GqlContactInfluencerOutput;
  authCreatorStatusCreate: GqlAuthCreatorStatusOutput;
  authCreatorStatusEdit: GqlAuthCreatorStatusOutput;
  authDeepLookupStart: GqlDeepLookupOutput;
  authDisconnect: Array<GqlAuth>;
  authGroupCreate: GqlAuthGroupOutput;
  authGroupDelete: Scalars['Boolean']['output'];
  authGroupImportAuthCsv: GqlAuthGroupImportOutput;
  authGroupManageMultipleGroupsForAuth: Scalars['Boolean']['output'];
  authGroupsUpdateBulk: Array<GqlAuthGroupOutput>;
  authGroupUpdate: GqlAuthGroupOutput;
  authIndex: GqlAuth;
  authNoteCreate: GqlAuthNoteOutput;
  /**
   * Delete the AuthNote for `(organization, auth)`. Returns `true` when a
   * document was removed, `false` when there was nothing to remove.
   */
  authNoteDelete: Scalars['Boolean']['output'];
  authNoteEdit: GqlAuthNoteOutput;
  authNoteItemCreate: GqlAuthNoteItemOutput;
  authNoteItemDelete: Scalars['Boolean']['output'];
  authNoteItemEdit: GqlAuthNoteItemOutput;
  authNoteItemPin: GqlAuthNoteItemOutput;
  authNoteItemUnpin: GqlAuthNoteItemOutput;
  authRefetch: Scalars['Boolean']['output'];
  /**
   * Manually trigger an analytics refresh for a campaign.
   * Publishes AuthWorkerEvent for each campaign influencer to re-fetch their data.
   * Analytics refresh is triggered automatically after each auth completes processing.
   * Returns the number of auth re-fetch events triggered.
   */
  campaignAnalyticsRefresh: Scalars['Int']['output'];
  campaignAuthsUpdateBulk: Scalars['Boolean']['output'];
  /**
   * Accept a campaign auth task by secret. Requires JWT auth.
   *
   * Creates OrganizationCampaign, auto-connects auth, marks task as accepted.
   * Idempotent: if the task is already claimed, returns the existing task.
   */
  campaignAuthTaskAccept: Scalars['Boolean']['output'];
  campaignAuthTaskCreate: GqlCampaignAuthTaskOutput;
  campaignAuthTaskEdit: GqlCampaignAuthTaskOutput;
  campaignAuthTaskLinkCreate: GqlCampaignAuthTaskLinkOutput;
  campaignAuthTaskLinkCreateBulk: Array<GqlCampaignAuthTaskLinkOutput>;
  campaignAuthTaskLinkDelete: GqlCampaignAuthTaskLinkOutput;
  campaignAuthTaskLinkDeleteBulk: Scalars['Boolean']['output'];
  /**
   * Reject a campaign auth task by secret. No auth needed.
   *
   * graphql:public-resolver (#564) — capability-gated by `input.secret`, not
   * an org session. The invited creator rejects their own task via the
   * magic-link secret (use-case resolves via `find_by_secret`) and has no
   * organization context to `require_*`. Intentionally public — audited in
   * #564, NOT an omitted-guard bug.
   */
  campaignAuthTaskReject: Scalars['Boolean']['output'];
  campaignCreate: GqlCampaignOutput;
  /**
   * Create a placeholder draft campaign and start an AIChat Automation
   * session that fills it out from the user's brief / prompt. Unlike
   * `campaign_create`, this resolver returns the chat session id so the
   * frontend can immediately open the chat view — the agent will render
   * the campaign card inline as it works.
   *
   * The campaign is created with `name = "Untitled campaign"` and
   * `setupReviewPassed = false`; the agent is instructed to rename the
   * campaign as one of its first updates, and the user confirms the
   * finished draft via `markCampaignSetupReviewed`.
   *
   * Requires at least one of `documentIds` / `aiPrompt` — without a
   * brief or instruction the agent has nothing to act on, and spawning
   * an empty chat would just burn tokens.
   */
  campaignCreateWithChat: GqlCampaignChatSessionOutput;
  /**
   * Archive (soft-delete) a campaign, removing it from the campaigns board
   * (frontend #76 Delete button). The campaign and all its child data remain
   * in the DB — this only flips the campaign's `isDeleted` flag, and the
   * board/list queries exclude archived campaigns. Reversible, no cascade.
   * Requires `CampaignManage` and is scoped to the caller's organization — a
   * campaign belonging to another org cannot be archived. Idempotent:
   * archiving an already-archived campaign returns `true`. Returns `true` on
   * success.
   */
  campaignDelete: Scalars['Boolean']['output'];
  campaignEdit: GqlCampaignOutput;
  /**
   * Assemble a campaign export bundle and return a signed download URL.
   *
   * Spec: `docs/modules/campaigns/data-export.md`.
   */
  campaignExportCreate: GqlCampaignExportOutput;
  campaignFinish: GqlCampaignOutput;
  /**
   * Brand cancels a gift in any state pre-`Ordering`, plus
   * `Failed`. `Ordered` / `Fulfilled` cannot be cancelled — a
   * real Shopify order exists and the merchant owns its
   * lifecycle. Requires `SettingsManage`. Cross-org gift →
   * `GIFT_NOT_FOUND` (no existence disclosure).
   */
  campaignGiftCancel: GqlCampaignGift;
  /**
   * Brand creates a gift attached to a `CampaignAuthTask`. The
   * gift lands in `PendingAddress`; the creator submits the
   * shipping address via `campaignGiftSubmitAddress`. Requires
   * `SettingsManage`. Idempotency-guarded: a second create for a
   * task that already has a non-cancelled gift surfaces as
   * `GIFT_ALREADY_EXISTS` (the brand edits the existing gift
   * instead).
   */
  campaignGiftCreate: GqlCampaignGift;
  /**
   * Brand triggers the send flow on a gift that has the
   * creator's address. Idempotent — a double-click is a no-op
   * (second CAS matches 0 docs). A retry of a `Failed` gift
   * advances the gift to `Ordering` and returns immediately;
   * the Stage 3 recovery worker resumes the actual Shopify
   * chain (a Failed gift may already hold a draft/order id).
   * First-send hot-path runs `draftOrderCreate` →
   * `draftOrderComplete` synchronously; transient Shopify
   * failures leave the gift in `Ordering` (recovery resumes
   * on the next tick — surfaces to FE as "send in flight").
   * Requires `SettingsManage`. Cross-org → `GIFT_NOT_FOUND`.
   */
  campaignGiftSend: GqlCampaignGift;
  /**
   * Creator submits the shipping address via the task secret link
   * (existing pattern — same shape as `campaignAuthTaskAccept`).
   * Unauthenticated. The task must be in `Accepted`, `InProgress`,
   * or `Review` AND its gift must be in `PendingAddress`; any
   * other state surfaces as `NOT_SUBMITTABLE` (no leak of which
   * secrets are valid).
   */
  campaignGiftSubmitAddress: GqlCampaignGift;
  /**
   * Import a historical campaign that ran on another platform, for
   * retroactive traffic-lift analysis. Creates a campaign directly in the
   * terminal `Historical` status (name + dates set), then spawns an AIChat
   * extraction session that fills `historicalDetail` and the content
   * fields from the uploaded documents. Returns the campaign and the chat
   * session id for the frontend to open.
   */
  campaignImportHistorical: GqlCampaignChatSessionOutput;
  /**
   * Force a health re-check for all active links in a campaign (max 50).
   *
   * Returns `BAD_REQUEST` when the campaign has more than 50 active links;
   * use `campaignLinkHealthCheckOne` per link instead or wait for the
   * scheduled worker tick.
   *
   * Returns `CONFLICT` when the hourly per-campaign throttle is active.
   */
  campaignLinkHealthCheckAll: GqlCampaignLinkHealthSummaryOutput;
  /**
   * Force a health re-check for a single link.
   *
   * Throttled per-campaign to once per hour across all server replicas.
   * Returns `CONFLICT` extension code with `retry_at` (ISO 8601) in the
   * error message when the hourly quota is already spent.
   */
  campaignLinkHealthCheckOne: GqlLinkHealthCheckOutput;
  campaignOfflineRevenueCreate: GqlCampaignOfflineRevenueOutput;
  campaignOfflineRevenueDelete: Scalars['Boolean']['output'];
  campaignPaymentCreate: GqlCampaignPaymentOutput;
  campaignPaymentDelete: Scalars['Boolean']['output'];
  campaignRecommendationUpdateStatus: GqlCampaignRecommendationOutput;
  /**
   * Start (activate) a campaign, transitioning it from Draft to Active status.
   * Validates that required fields (budget, at least one creator) are filled.
   */
  campaignStart: GqlCampaignOutput;
  campaignTaskTemplateApply: GqlApplyTemplateResultOutput;
  campaignTaskTemplateDelete: Scalars['Boolean']['output'];
  campaignTaskTemplateSave: GqlCampaignTaskTemplateOutput;
  cancelMemberInvitation: Scalars['Boolean']['output'];
  changePassword: GqlAccountWithTokens;
  /**
   * Open a Stripe Checkout session to buy credits for the caller's
   * organization, returning the hosted payment URL.
   *
   * Credits are NOT granted here — only the signature-verified
   * `checkout.session.completed` webhook grants them. `success_url` is just
   * where the browser lands afterwards and can be opened without paying.
   */
  createCreditCheckoutSession: Scalars['String']['output'];
  createLinkbioLink: GqlLinkbioLink;
  /**
   * Creates a LinkBio icon by automatically resolving an auth through tokenless API.
   *
   * # Tokenless Icon Creation Flow
   *
   * Unlike links and tabs which accept direct `authId`, icons require automatic resolution
   * through the tokenless API. This is because icons represent social media profiles
   * (Instagram, TikTok, YouTube, etc.) and need their profile pictures automatically fetched.
   *
   * ## When to use tokenless vs direct authId:
   *
   * **Use tokenless (this mutation):**
   * - Creating icons - always requires automatic profile picture resolution
   * - User provides username/URL instead of authId
   * - Supported platforms: Instagram, TikTok, YouTube, Twitter, Twitch, Spotify
   *
   * **Use direct authId (links/tabs):**
   * - Creating links or tabs with pre-existing auth
   * - Auth already exists in system
   * - No need for automatic data fetching
   *
   * ## Tokenless Limitations
   *
   * Only platforms with public profile APIs are supported:
   * - ✅ Instagram, TikTok, YouTube, Twitter, Twitch, Spotify
   * - ❌ Facebook, LinkedIn, Snapchat, Pinterest (no public API or auth required)
   *
   * ## 6-Step Flow
   *
   * ```text
   * User Input (username/URL + source)
   * ↓
   * 1. BuildTokenlessUseCase → resolve platform profile
   * ↓
   * 2. IndexAuthUseCase → store/update auth in database
   * ↓
   * 3. Extract authId + profile_url from indexed auth
   * ↓
   * 4. Convert shared::sources::Source → domain::linkbio::Source
   * ↓
   * 5. LinkBioService.create_icon → add to aggregate
   * ↓
   * 6. Return updated aggregate with new icon
   * ```
   *
   * # Errors
   *
   * - Returns error if source is not supported by tokenless API
   * - Returns error if username/URL cannot be resolved
   * - Returns error if profile indexing fails
   * - Returns error if user doesn't own the LinkBio page
   */
  createLinkbioLinkIcon: GqlLinkbioLinkIcon;
  createLinkbioPage: GqlLinkbioPage;
  createLinkbioTab: GqlLinkbioTab;
  createOrganization: GqlOrganizationObject;
  creatorPreferencesUpsert: GqlCreatorPreferencesOutput;
  deleteLinkbioLink: Scalars['Boolean']['output'];
  deleteLinkbioLinkIcon: Scalars['Boolean']['output'];
  deleteLinkbioPage: Scalars['Boolean']['output'];
  deleteLinkbioTab: Scalars['Boolean']['output'];
  deleteMember: Scalars['Boolean']['output'];
  dismissNotification: Scalars['Boolean']['output'];
  /**
   * Kick off brand-context enrichment (scrape org website + LLM analysis)
   * as a background task and return immediately. Uses org's configured
   * website if no URL provided.
   *
   * The actual scrape + LLM pass runs detached (#72) — historically it ran
   * inline on the request and could outlast the HTTP/ALB timeout, leaving
   * the `BrandContext` stuck in `Pending` forever. The resolver now only
   * performs the cheap synchronous setup (resolve URL, persist + broadcast
   * the `Pending` marker, charge credits) and spawns the slow work, mirroring
   * `deep_lookup_start`. Clients observe completion via the
   * `brandContextUpdated` subscription; the background task always writes a
   * terminal `Completed`/`Failed` state (a `tokio::time::timeout` guard
   * converts a hung enrichment into `Failed`, so `Pending` can no longer
   * leak).
   */
  enrichBrandContext: Scalars['String']['output'];
  /**
   * Set a property as the org's default for new campaigns. Atomic write to
   * `OrgGoogleAccount.default_property_id`. Idempotent on re-run.
   */
  gaConnectionSetDefault: GqlGaConnectionOutput;
  /**
   * Trigger an off-schedule sync for one property. Creates a
   * `BackgroundTask` (kind=`GaProperty`) + spawns the worker iteration.
   * Idempotent: returns the existing Running task if one is already in
   * flight for this property.
   */
  gaConnectionSyncNow: GqlBackgroundTaskOutput;
  /**
   * Replace the tracked events for a property. Full-replace semantics; per
   * §4.3: ≥1 event, ≤50, regex-validated name, tuple unique within input.
   */
  gaConnectionUpdateTrackedEvents: GqlGaConnectionOutput;
  /** Create a new GA connection */
  gaCreate: GqlGaConnectionOutput;
  /** Delete a GA connection */
  gaDelete: Scalars['Boolean']['output'];
  /** Disconnect a GA connection (clear tokens) */
  gaDisconnect: Scalars['Boolean']['output'];
  /** Update a GA connection */
  gaUpdate: GqlGaConnectionOutput;
  /**
   * Generate an AI-authored campaign brief synchronously. Returns the full
   * `AiDraftResult` once the LLM call completes (~15–25s on Smart model).
   * The caller is expected to show a loader for the duration of the request.
   *
   * Invariants (ownership, terminal-status pre-check, BrandContext readiness,
   * post-LLM status recheck) live in `GenerateAiDraftUseCase`, not here, so
   * non-GraphQL callers (MCP, admin) inherit them. The resolver only
   * translates transport concerns: auth, input parsing, concurrency cap,
   * overall deadline, error sanitization.
   */
  generateCampaignDraft: GqlAiDraftResultOutput;
  /**
   * (Re)generate the traffic-lift report for a Marble campaign — live or
   * historical. Brand-owner only — the use-case rejects a campaign owned by
   * another org. The report is computed asynchronously; poll
   * `campaignTrafficLiftReport` for status.
   */
  generateCampaignTrafficLiftReport: GqlCampaignTrafficLiftReportOutput;
  /**
   * #736/#743 — index a creator "because an operator opened their card", and
   * wait (up to 60s) for the result.
   *
   * This is the side-effecting half that `Query.creatorProfile` used to hide:
   * it takes a CAS claim, starts a background pipeline and blocks. For a
   * campaign-sweep DISCOVERED creator it is the ONLY path allowed to start a
   * one-shot deep index (posts, analytics, enrichment, summary); nothing else
   * about the discovered contract changes — `fetch_enabled` stays `false` and
   * no background process may deep-fetch them. Re-issuing it for the same
   * creator does not re-index.
   *
   * Authorization (#743): `auth:manage`, not bare org membership. A first
   * call can spend provider quota and LLM budget, so it is gated on the same
   * scope as mutating a creator record — which excludes Viewers — and is
   * additionally rate-limited per organization (`TOO_MANY_REQUESTS` when
   * over, with the retry delay in the message).
   */
  indexCreatorProfile: GqlCreatorProfileOutput;
  inviteMember: GqlOrganizationMemberObject;
  markAllNotificationsRead: Scalars['Int']['output'];
  /**
   * Acknowledge terminal tray rows as "seen" (#428) so completed tasks
   * stop showing in the tray by default. Org-wide ack (`seen: bool` on
   * the row) — the org is taken from auth, never the client. Only
   * terminal (`Done`/`Failed`) rows are flipped; `Running` rows and
   * ids belonging to another org are silently ignored by the
   * org-scoped, terminal-only repo filter. Returns the number of rows
   * actually flipped.
   */
  markBackgroundTasksSeen: Scalars['Int']['output'];
  /**
   * Confirm the user has reviewed the AI-generated draft on Campaign
   * Detail's inline `draft-setup` view. Transitions the campaign from
   * `Setup` → `Draft` and returns the updated row — frontend
   * re-renders in regular `draft` mode (tabs visible, Activate CTA in
   * header). Idempotent on already-`Draft` rows. Owner-scoped via the
   * same `CampaignManage` permission as `campaign_create`.
   */
  markCampaignSetupReviewed: GqlCampaignOutput;
  markNotificationsRead: Scalars['Boolean']['output'];
  /**
   * F2 — update the org's "Brand Safety → Anomaly detection" settings.
   * Returns the persisted settings. The read side is
   * `organization.brandContext.anomalySurfacingSettings`; this is the
   * matching write half — no standalone query is introduced.
   */
  organizationAnomalySurfacingSettingsUpdate: GqlAnomalySurfacingSettingsObject;
  /**
   * Delete an organization campaign relationship.
   * Removes the link between a creator's organization and a campaign.
   */
  organizationCampaignDelete: Scalars['Boolean']['output'];
  /**
   * Custom sender domain (#529): register a custom sending domain as an SES
   * domain identity in Marble's SES account and return the DNS records the
   * customer must publish (DKIM CNAMEs + recommended SPF/DMARC/MAIL FROM).
   * Re-runnable — reconnecting the same verified domain preserves status.
   * Gated on `SettingsManage` (modifies org config, like other destructive
   * integration mutations).
   */
  organizationConnectSenderDomain: GqlConnectSenderDomainOutput;
  organizationPaymentDetailsCreateStripe: GqlOrganizationPaymentDetailsOutput;
  organizationPaymentDetailsDelete: Scalars['Boolean']['output'];
  organizationPaymentDetailsUpdateStatus: GqlOrganizationPaymentDetailsOutput;
  /**
   * Custom sender domain (#529): re-query SES for the org's domain identity
   * DKIM status and persist `Verified`/`Failed`/`Pending`. Used to poll after
   * the customer adds the DNS records. Gated on `SettingsManage`.
   */
  organizationRefreshSenderDomainVerification: GqlOrganizationEmailConfigOutput;
  organizationShippingDetailsCreate: GqlOrganizationShippingDetailsOutput;
  organizationShippingDetailsDelete: Scalars['Boolean']['output'];
  organizationShippingDetailsUpdate: GqlOrganizationShippingDetailsOutput;
  /**
   * Add a profile to an existing persona (manual discovery).
   * Auth must already be indexed. If not found, returns error.
   */
  personaAddAuth: GqlPersonaOutput;
  postCustomCreate: GqlPostOutput;
  postCustomEngagementUpdate: GqlPostOutput;
  postLoadMore: GqlLoadMorePostsOutput;
  postUrlCtaUpdate: GqlPostOutput;
  /**
   * Link a pre-existing Shopify discount code to a campaign / creator.
   * Marble does not touch the brand-owned discount; only a `Mirrored`
   * row is persisted. Requires `SettingsManage`.
   */
  promoCodeLink: GqlCampaignPromoCodeOutput;
  /**
   * Mint a fresh discount code in Shopify and tie it to a campaign /
   * creator. Failure ordering: Shopify call FIRST; on Shopify rejection
   * no Marble row is written (no orphan). Requires `SettingsManage`.
   */
  promoCodeMint: GqlCampaignPromoCodeOutput;
  /**
   * Revoke a promo code. For `Minted` rows on a still-connected store
   * the Shopify discount is deactivated; the Marble row's status flips
   * to `Revoked`. Idempotent (re-revoke returns the existing row).
   * Requires `SettingsManage`.
   */
  promoCodeRevoke: GqlCampaignPromoCodeOutput;
  /**
   * Edit a promo code's metadata. For `Minted` rows the change is
   * pushed to Shopify (`discountCodeBasicUpdate`) FIRST; on Shopify
   * failure the Marble row stays unchanged. For `Mirrored` rows Marble
   * edits only its own metadata — the brand owns the Shopify side.
   * Requires `SettingsManage`.
   */
  promoCodeUpdate: GqlCampaignPromoCodeOutput;
  /** Force recompute brand match score (invalidates cache). */
  refreshBrandMatchScore: GqlBrandMatchResultOutput;
  /**
   * Lazy per-thumbnail self-heal (#550). Called by the frontend on a broken
   * thumbnail `onError`. Re-scrapes THIS post's media from source, re-hosts
   * the fresh thumbnail to S3 and returns the patched post. If the source
   * post is gone, the returned post carries `sourceStatus = unavailable` so
   * the client renders the dead-post UI. Anti-storm: per-post Redis cooldown
   * + in-flight dedupe in the use case.
   */
  refreshPostThumbnail: GqlPostOutput;
  reorderLinkbioLinkIcons: GqlLinkbioLinkIconListOutput;
  reorderLinkbioLinks: GqlLinkbioLinkList;
  reorderLinkbioTabs: GqlLinkbioTabListOutput;
  /** Submit a demo / partnership request from the public marketing site. */
  requestDemo: GqlRequestDemoOutput;
  requestPasswordReset: Scalars['Boolean']['output'];
  resetPassword: GqlAccountWithTokens;
  /**
   * Resolve a `Review` conflict edge with a human decision.
   *
   * **Confirm** merges the candidate into the persona: the persona's
   * `primary_auth_id` is used as the seed and paired with the candidate via
   * `PersonaResolveInput::manual` (manual = bypass the identity guard, an
   * intentional human override). The edge is then upserted `Confirmed` /
   * `resolved_by = Human`.
   *
   * **Reject** upserts the edge `Rejected` / `resolved_by = Human` with NO
   * membership change — the candidate stays a separate identity.
   */
  resolvePersonaConflict: GqlPersonaConflictOutput;
  /**
   * #712: on-demand "fetch now" sweep trigger. Non-blocking — spawns a
   * detached run of the shared `CampaignSweepUseCase` and returns the current
   * `SweepJobStatus`; the FE polls `campaignSweepStatus`. NOT gated on
   * `SWEEP_ENABLED` (that gates only the auto worker); cooldown-guarded per
   * campaign (`SWEEP_BUTTON_COOLDOWN`, default 5 min). Returns an `Unavailable`
   * status (not an error) when no sweep service is configured.
   */
  runCampaignSweep: GqlSweepJobStatus;
  /**
   * Set an organization's overdraft allowance (soft-cap, #381 Option 2).
   *
   * Configured on the org page in the admin portal. A non-zero allowance
   * lets cost-bearing operations proceed into a bounded overdraft (balance
   * dips negative down to `-overdraftLimitCredits`) and emit a
   * `credit_overdraft_charged_total` alert instead of being hard-rejected.
   * `0` restores the hard-block-at-zero behaviour. Validated
   * `0 <= limit <= 10_000_000`.
   */
  setOrganizationOverdraftLimit: GqlOrganizationCreditBalanceObject;
  /**
   * Disconnect a store — `status` becomes `DISCONNECTED`, its access token
   * and poll cursors are cleared, `disconnectedAt` is stamped. If it was
   * the org's primary, the primary marker is cleared (a disconnected store
   * must never stay primary). Requires `SettingsManage`. Cross-org or
   * missing store → generic "not found".
   */
  shopifyStoreDisconnect: GqlShopifyStoreOutput;
  /**
   * Promote a connected store to the caller-org's primary. The store must
   * belong to the caller's organization and be `Connected`. Requires
   * `SettingsManage` — matches the destructive-integration-mutation gate
   * shape used by GA (`GaConnectionManage`). Cross-org or missing store →
   * generic "not found" (no existence disclosure).
   */
  shopifyStoreSetPrimary: GqlShopifyStoreOutput;
  signIn: GqlAccountWithTokens;
  signInGoogle: GqlAccountWithTokens;
  signUp: Scalars['Boolean']['output'];
  /**
   * Split / un-merge a single persona member back into its own persona (PR-D).
   *
   * Detaches `authId` from its current persona into a FRESH singleton: moves
   * the member's external-link slices with it and writes a `Rejected`
   * membership edge (`resolved_by = Human`) so the discovery path will not
   * re-merge it. Refuses to split a persona's un-absorbed original anchor.
   *
   * Returns the `Rejected` conflict edge that records the detach. Global,
   * cross-org surface: superadmin only.
   */
  splitPersonaMember: GqlPersonaConflictOutput;
  /**
   * Apply a signed top-up to an organization's credit balance.
   *
   * Positive `amountCredits` grants credits and accumulates in
   * `totalToppedUpCredits`. Negative `amountCredits` is a manual
   * reduction clamped at `balance=0`; it is recorded in the audit log
   * but does NOT decrement `totalToppedUpCredits` (see spec §"Negative
   * top-up floor"). Inspect `clamped` + `amountApplied` on the response
   * to detect a clamped reduction.
   */
  topUpOrganizationCredits: GqlTopUpOutcomeObject;
  /**
   * Flip a tracking link between `ACTIVE` and `DISABLED`. Disabled
   * links return 404 at redirect time and are skipped by the
   * health-check worker. Permission re-uses `CampaignManage` (same
   * authz envelope as `campaignAuthTaskLink*` mutations).
   */
  trackingLinkSetStatus: GqlCampaignAuthTaskLinkOutput;
  /**
   * Phase 1c (#286). Delete an email-suppression entry. Returns `true`
   * iff a row was removed; `false` when no matching row was found
   * (idempotent — operator may safely retry).
   *
   * `categoryScope` is exactly one of `allCategories: true` or
   * `categories: [EmailCategory!]` with at least one category. Other
   * shapes are rejected at the resolver entry.
   */
  unsuppressEmail: Scalars['Boolean']['output'];
  updateCampaignAuthOutreachStatus: GqlCampaignAuthOutreachOutput;
  /**
   * Update a campaign auth task status by task ID (authenticated).
   * Validates the state machine transition and triggers side-effects (e.g. payment check on Done).
   */
  updateCampaignAuthTaskStatus: GqlCampaignAuthTaskOutput;
  updateCampaignExcludedPostIds: Scalars['Boolean']['output'];
  updateCampaignIncludedPostIds: Scalars['Boolean']['output'];
  updateLinkbioBackground: GqlLinkbioBackgroundSettings;
  updateLinkbioLink: GqlLinkbioLink;
  updateLinkbioLinkIcon: GqlLinkbioLinkIcon;
  updateLinkbioPage: GqlLinkbioPage;
  updateLinkbioTab: GqlLinkbioTab;
  updateLinkBioVisibility: GqlLinkbioPage;
  updateMember: GqlOrganizationMemberObject;
  updateOrganizationProfile: GqlOrganizationProfileObject;
  updateProfile: GqlProfileObject;
  upsertContactDetails: GqlLinkbioContactDetails;
  /**
   * Create a new template. Newly created rows are never the default —
   * caller must promote explicitly via `utmTemplateSetDefault`.
   */
  utmTemplateCreate: GqlUtmTemplateOutput;
  /**
   * Delete a non-default template. Rejecting the workspace default
   * is enforced in the use-case (spec invariant: exactly one default).
   */
  utmTemplateDelete: Scalars['Boolean']['output'];
  /**
   * Promote a template to workspace default. Atomic per repo
   * transaction.
   */
  utmTemplateSetDefault: GqlUtmTemplateOutput;
  /** Patch name + pattern fields. `is_default` is unaffected. */
  utmTemplateUpdate: GqlUtmTemplateOutput;
  verifyEmail: GqlAccountWithTokens;
}

export interface GqlMutationRootAcceptInvitationArgs {
  input: GqlAcceptInvitationInput;
}

export interface GqlMutationRootAccountContactVerificationResendArgs {
  input: GqlAccountResendVerificationEmailInput;
}

export interface GqlMutationRootAdminAddOrganizationMemberArgs {
  input: GqlAdminAddOrganizationMemberInput;
}

export interface GqlMutationRootAdminCreateAccountArgs {
  input: GqlAdminCreateAccountInput;
}

export interface GqlMutationRootAdminCreateOrganizationArgs {
  input: GqlAdminCreateOrganizationInput;
}

export interface GqlMutationRootAdminCreatorNetworkCreateIndustryArgs {
  input: GqlAdminIndustryInput;
}

export interface GqlMutationRootAdminCreatorNetworkCreateInfluencerListArgs {
  input: GqlAdminCreateInfluencerListInput;
}

export interface GqlMutationRootAdminCreatorNetworkCreateLocationArgs {
  input: GqlAdminLocationInput;
}

export interface GqlMutationRootAdminCreatorNetworkGenerateInfluencerListArgs {
  listId: Scalars['String']['input'];
  overrides?: InputMaybe<GqlAdminGenerateInfluencerListOverridesInput>;
}

export interface GqlMutationRootAdminCreatorNetworkPublishDirectoryArgs {
  dryRun?: Scalars['Boolean']['input'];
}

export interface GqlMutationRootAdminCreatorNetworkSetIndustryStatusArgs {
  id: Scalars['String']['input'];
  status: GqlCreatorNetworkEntityStatus;
}

export interface GqlMutationRootAdminCreatorNetworkSetInfluencerListStatusArgs {
  listId: Scalars['String']['input'];
  status: GqlCreatorNetworkEntityStatus;
}

export interface GqlMutationRootAdminCreatorNetworkSetLocationStatusArgs {
  id: Scalars['String']['input'];
  status: GqlCreatorNetworkEntityStatus;
}

export interface GqlMutationRootAdminCreatorNetworkUpdateIndustryArgs {
  id: Scalars['String']['input'];
  input: GqlAdminIndustryInput;
}

export interface GqlMutationRootAdminCreatorNetworkUpdateListMembersArgs {
  listId: Scalars['String']['input'];
  members: Array<GqlAdminInfluencerListMemberInput>;
}

export interface GqlMutationRootAdminCreatorNetworkUpdateLocationArgs {
  id: Scalars['String']['input'];
  input: GqlAdminLocationInput;
}

export interface GqlMutationRootAdminDeleteOrganizationArgs {
  organizationId: Scalars['String']['input'];
}

export interface GqlMutationRootAdminDeleteOrganizationMemberArgs {
  memberId: Scalars['String']['input'];
}

export interface GqlMutationRootAdminEnrichBrandContextArgs {
  organizationId: Scalars['String']['input'];
}

export interface GqlMutationRootAdminForceShallowEnrichArgs {
  authIds: Array<Scalars['String']['input']>;
}

export interface GqlMutationRootAdminImpersonateAccountArgs {
  accountId: Scalars['String']['input'];
}

export interface GqlMutationRootAdminInviteOrganizationMemberArgs {
  input: GqlAdminInviteMemberInput;
}

export interface GqlMutationRootAdminRedriveAuthDlqEnvelopeArgs {
  envelopeId: Scalars['String']['input'];
}

export interface GqlMutationRootAdminRescueStuckAuthsArgs {
  input: GqlAdminRescueStuckAuthsInput;
}

export interface GqlMutationRootAdminSetDemoRequestProcessedArgs {
  input: GqlAdminSetDemoRequestProcessedInput;
}

export interface GqlMutationRootAdminSetSuperadminArgs {
  input: GqlAdminSetSuperadminInput;
}

export interface GqlMutationRootAdminSetVerifiedArgs {
  input: GqlAdminSetVerifiedInput;
}

export interface GqlMutationRootAdminUpdateCampaignStatusArgs {
  campaignId: Scalars['String']['input'];
  status: GqlCampaignStatusEnum;
}

export interface GqlMutationRootAdminUpdateOrganizationMemberArgs {
  input: GqlAdminUpdateMemberInput;
}

export interface GqlMutationRootAdminUpdatePasswordArgs {
  input: GqlAdminUpdatePasswordInput;
}

export interface GqlMutationRootAffiliateProgramCreateArgs {
  input: GqlCreateAffiliateProgramInputGql;
}

export interface GqlMutationRootAffiliateProgramEnrollArgs {
  input: GqlEnrollCreatorInputGql;
}

export interface GqlMutationRootAiChatCancelTurnArgs {
  input: GqlCancelTurnInput;
}

export interface GqlMutationRootAiChatDeleteSessionArgs {
  input: GqlDeleteSessionInput;
}

export interface GqlMutationRootAiChatSendMessageArgs {
  input: GqlSendMessageInput;
}

export interface GqlMutationRootAiChatSetExecutionModeArgs {
  input: GqlSetExecutionModeInput;
}

export interface GqlMutationRootAiSearchCreateArgs {
  input: GqlCreateAiSearchInput;
}

export interface GqlMutationRootAiSearchDeleteArgs {
  input: GqlDeleteAiSearchInput;
}

export interface GqlMutationRootAuthConnectTokenlessArgs {
  input: GqlConnectTokenlessInput;
}

export interface GqlMutationRootAuthContactInfluencerArgs {
  input: GqlContactInfluencerInput;
}

export interface GqlMutationRootAuthCreatorStatusCreateArgs {
  input: GqlAuthCreatorStatusInput;
}

export interface GqlMutationRootAuthCreatorStatusEditArgs {
  input: GqlAuthCreatorStatusInput;
}

export interface GqlMutationRootAuthDeepLookupStartArgs {
  input: GqlDeepLookupStartInput;
}

export interface GqlMutationRootAuthDisconnectArgs {
  input: GqlDisconnectAuthInput;
}

export interface GqlMutationRootAuthGroupCreateArgs {
  input: GqlAuthGroupCreateInput;
}

export interface GqlMutationRootAuthGroupDeleteArgs {
  input: GqlAuthGroupDeleteInput;
}

export interface GqlMutationRootAuthGroupImportAuthCsvArgs {
  input: GqlAuthGroupImportFromCsvInput;
}

export interface GqlMutationRootAuthGroupManageMultipleGroupsForAuthArgs {
  input: GqlAuthGroupManageMultipleGroupsForAuthInput;
}

export interface GqlMutationRootAuthGroupsUpdateBulkArgs {
  input: GqlAuthGroupsUpdateBulkInput;
}

export interface GqlMutationRootAuthGroupUpdateArgs {
  input: GqlAuthGroupUpdateInput;
}

export interface GqlMutationRootAuthIndexArgs {
  input: GqlAuthPrefetchInput;
}

export interface GqlMutationRootAuthNoteCreateArgs {
  input: GqlAuthNoteInput;
}

export interface GqlMutationRootAuthNoteDeleteArgs {
  input: GqlAuthNoteDeleteInput;
}

export interface GqlMutationRootAuthNoteEditArgs {
  input: GqlAuthNoteInput;
}

export interface GqlMutationRootAuthNoteItemCreateArgs {
  input: GqlAuthNoteItemCreateInput;
}

export interface GqlMutationRootAuthNoteItemDeleteArgs {
  input: GqlAuthNoteItemDeleteInput;
}

export interface GqlMutationRootAuthNoteItemEditArgs {
  input: GqlAuthNoteItemEditInput;
}

export interface GqlMutationRootAuthNoteItemPinArgs {
  input: GqlAuthNoteItemPinInput;
}

export interface GqlMutationRootAuthNoteItemUnpinArgs {
  input: GqlAuthNoteItemUnpinInput;
}

export interface GqlMutationRootAuthRefetchArgs {
  input: GqlAuthRefetchInput;
}

export interface GqlMutationRootCampaignAnalyticsRefreshArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlMutationRootCampaignAuthsUpdateBulkArgs {
  input: GqlCampaignAuthsUpdateBulkInput;
}

export interface GqlMutationRootCampaignAuthTaskAcceptArgs {
  input: GqlCampaignAuthTaskAcceptInput;
}

export interface GqlMutationRootCampaignAuthTaskCreateArgs {
  input: GqlCampaignAuthTaskInput;
}

export interface GqlMutationRootCampaignAuthTaskEditArgs {
  input: GqlCampaignAuthTaskInput;
}

export interface GqlMutationRootCampaignAuthTaskLinkCreateArgs {
  input: GqlCampaignAuthTaskLinkInput;
}

export interface GqlMutationRootCampaignAuthTaskLinkCreateBulkArgs {
  input: GqlCampaignAuthTaskLinkInputBulk;
}

export interface GqlMutationRootCampaignAuthTaskLinkDeleteArgs {
  input: GqlCampaignAuthTaskLinkDeleteInput;
}

export interface GqlMutationRootCampaignAuthTaskLinkDeleteBulkArgs {
  input: GqlCampaignAuthTaskLinkDeleteBulkInput;
}

export interface GqlMutationRootCampaignAuthTaskRejectArgs {
  input: GqlCampaignAuthTaskRejectInput;
}

export interface GqlMutationRootCampaignCreateArgs {
  input: GqlCampaignBuildInput;
}

export interface GqlMutationRootCampaignCreateWithChatArgs {
  input: GqlCampaignCreateWithChatInput;
}

export interface GqlMutationRootCampaignDeleteArgs {
  input: GqlCampaignDeleteInput;
}

export interface GqlMutationRootCampaignEditArgs {
  input: GqlCampaignUpdateInput;
}

export interface GqlMutationRootCampaignExportCreateArgs {
  campaignId: Scalars['ID']['input'];
  options?: InputMaybe<GqlCampaignExportOptionsInput>;
}

export interface GqlMutationRootCampaignFinishArgs {
  input: GqlCampaignFinishInput;
}

export interface GqlMutationRootCampaignGiftCancelArgs {
  giftId: Scalars['ID']['input'];
}

export interface GqlMutationRootCampaignGiftCreateArgs {
  input: GqlCampaignGiftCreateInput;
}

export interface GqlMutationRootCampaignGiftSendArgs {
  giftId: Scalars['ID']['input'];
}

export interface GqlMutationRootCampaignGiftSubmitAddressArgs {
  address: GqlGiftAddressInput;
  secret: Scalars['String']['input'];
}

export interface GqlMutationRootCampaignImportHistoricalArgs {
  input: GqlCampaignImportHistoricalInput;
}

export interface GqlMutationRootCampaignLinkHealthCheckAllArgs {
  input: GqlCampaignLinkHealthCheckAllInput;
}

export interface GqlMutationRootCampaignLinkHealthCheckOneArgs {
  input: GqlCampaignLinkHealthCheckOneInput;
}

export interface GqlMutationRootCampaignOfflineRevenueCreateArgs {
  input: GqlCampaignOfflineRevenueCreateInput;
}

export interface GqlMutationRootCampaignOfflineRevenueDeleteArgs {
  input: GqlCampaignOfflineRevenueDeleteInput;
}

export interface GqlMutationRootCampaignPaymentCreateArgs {
  input: GqlCampaignPaymentCreateInput;
}

export interface GqlMutationRootCampaignPaymentDeleteArgs {
  input: GqlCampaignPaymentDeleteInput;
}

export interface GqlMutationRootCampaignRecommendationUpdateStatusArgs {
  input: GqlCampaignRecommendationUpdateStatusInput;
}

export interface GqlMutationRootCampaignStartArgs {
  input: GqlCampaignStartInput;
}

export interface GqlMutationRootCampaignTaskTemplateApplyArgs {
  input: GqlCampaignTaskTemplateApplyInput;
}

export interface GqlMutationRootCampaignTaskTemplateDeleteArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlMutationRootCampaignTaskTemplateSaveArgs {
  input: GqlCampaignTaskTemplateSaveInput;
}

export interface GqlMutationRootCancelMemberInvitationArgs {
  input: GqlCancelOrganizationMemberInvitationInput;
}

export interface GqlMutationRootChangePasswordArgs {
  input: GqlAccountPasswordChangeInput;
}

export interface GqlMutationRootCreateCreditCheckoutSessionArgs {
  amountUsd: Scalars['Float']['input'];
  returnPath?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlMutationRootCreateLinkbioLinkArgs {
  input: GqlCreateLinkBioLinkInput;
}

export interface GqlMutationRootCreateLinkbioLinkIconArgs {
  input: GqlCreateLinkBioLinkIconInput;
}

export interface GqlMutationRootCreateLinkbioPageArgs {
  input: GqlCreateLinkBioPageInput;
}

export interface GqlMutationRootCreateLinkbioTabArgs {
  input: GqlCreateLinkBioTabInput;
}

export interface GqlMutationRootCreateOrganizationArgs {
  input: GqlCreateOrganizationInput;
}

export interface GqlMutationRootCreatorPreferencesUpsertArgs {
  input: GqlCreatorPreferencesInput;
}

export interface GqlMutationRootDeleteLinkbioLinkArgs {
  linkbioId: Scalars['ID']['input'];
  linkId: Scalars['ID']['input'];
}

export interface GqlMutationRootDeleteLinkbioLinkIconArgs {
  input: GqlDeleteLinkBioLinkIconInput;
}

export interface GqlMutationRootDeleteLinkbioPageArgs {
  linkbioId: Scalars['ID']['input'];
}

export interface GqlMutationRootDeleteLinkbioTabArgs {
  input: GqlDeleteLinkBioTabInput;
}

export interface GqlMutationRootDeleteMemberArgs {
  input: GqlDeleteOrganizationMemberInput;
}

export interface GqlMutationRootDismissNotificationArgs {
  id: Scalars['String']['input'];
}

export interface GqlMutationRootEnrichBrandContextArgs {
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlMutationRootGaConnectionSetDefaultArgs {
  id: Scalars['ID']['input'];
}

export interface GqlMutationRootGaConnectionSyncNowArgs {
  id: Scalars['ID']['input'];
}

export interface GqlMutationRootGaConnectionUpdateTrackedEventsArgs {
  propertyId: Scalars['ID']['input'];
  trackedEvents: Array<GqlGaTrackedEventInput>;
}

export interface GqlMutationRootGaCreateArgs {
  input: GqlGaConnectionCreateInput;
}

export interface GqlMutationRootGaDeleteArgs {
  input: GqlGaConnectionDeleteInput;
}

export interface GqlMutationRootGaDisconnectArgs {
  input: GqlGaConnectionDisconnectInput;
}

export interface GqlMutationRootGaUpdateArgs {
  input: GqlGaConnectionUpdateInput;
}

export interface GqlMutationRootGenerateCampaignDraftArgs {
  input: GqlGenerateCampaignDraftInput;
}

export interface GqlMutationRootGenerateCampaignTrafficLiftReportArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlMutationRootIndexCreatorProfileArgs {
  input: GqlCreatorProfileInput;
}

export interface GqlMutationRootInviteMemberArgs {
  input: GqlInviteMemberInput;
}

export interface GqlMutationRootMarkBackgroundTasksSeenArgs {
  ids: Array<Scalars['ID']['input']>;
}

export interface GqlMutationRootMarkCampaignSetupReviewedArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlMutationRootMarkNotificationsReadArgs {
  ids: Array<Scalars['String']['input']>;
}

export interface GqlMutationRootOrganizationAnomalySurfacingSettingsUpdateArgs {
  input: GqlAnomalySurfacingSettingsInput;
}

export interface GqlMutationRootOrganizationCampaignDeleteArgs {
  input: GqlOrganizationCampaignDeleteInput;
}

export interface GqlMutationRootOrganizationConnectSenderDomainArgs {
  input: GqlConnectSenderDomainInputGql;
}

export interface GqlMutationRootOrganizationPaymentDetailsDeleteArgs {
  paymentDetailsId: Scalars['String']['input'];
}

export interface GqlMutationRootOrganizationPaymentDetailsUpdateStatusArgs {
  dashboardLink?: InputMaybe<Scalars['String']['input']>;
  isReadyToReceivePayments?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDetailsId: Scalars['String']['input'];
}

export interface GqlMutationRootOrganizationShippingDetailsCreateArgs {
  input: GqlCreateOrganizationShippingDetailsInput;
}

export interface GqlMutationRootOrganizationShippingDetailsUpdateArgs {
  input: GqlUpdateOrganizationShippingDetailsInput;
}

export interface GqlMutationRootPersonaAddAuthArgs {
  personaId: Scalars['String']['input'];
  source: GqlAuthSource;
  username: Scalars['String']['input'];
}

export interface GqlMutationRootPostCustomCreateArgs {
  input: GqlCreateCustomPostInput;
}

export interface GqlMutationRootPostCustomEngagementUpdateArgs {
  input: GqlUpdatePostCustomEngagementInput;
}

export interface GqlMutationRootPostLoadMoreArgs {
  input: GqlLoadMorePostsInput;
}

export interface GqlMutationRootPostUrlCtaUpdateArgs {
  input: GqlUpdatePostUrlCtaInput;
}

export interface GqlMutationRootPromoCodeLinkArgs {
  input: GqlLinkPromoCodeInputGql;
}

export interface GqlMutationRootPromoCodeMintArgs {
  input: GqlMintPromoCodeInputGql;
}

export interface GqlMutationRootPromoCodeRevokeArgs {
  promoCodeId: Scalars['ID']['input'];
}

export interface GqlMutationRootPromoCodeUpdateArgs {
  input: GqlUpdatePromoCodeInputGql;
}

export interface GqlMutationRootRefreshBrandMatchScoreArgs {
  authId: Scalars['String']['input'];
}

export interface GqlMutationRootRefreshPostThumbnailArgs {
  postId: Scalars['String']['input'];
}

export interface GqlMutationRootReorderLinkbioLinkIconsArgs {
  input: GqlReorderInput;
  linkbioId: Scalars['ID']['input'];
}

export interface GqlMutationRootReorderLinkbioLinksArgs {
  input: GqlReorderInput;
  linkbioId: Scalars['ID']['input'];
}

export interface GqlMutationRootReorderLinkbioTabsArgs {
  input: GqlReorderInput;
  linkbioId: Scalars['ID']['input'];
}

export interface GqlMutationRootRequestDemoArgs {
  input: GqlRequestDemoInput;
}

export interface GqlMutationRootRequestPasswordResetArgs {
  input: GqlAccountPasswordResetRequestInput;
}

export interface GqlMutationRootResetPasswordArgs {
  input: GqlAccountPasswordResetInput;
  token: Scalars['String']['input'];
}

export interface GqlMutationRootResolvePersonaConflictArgs {
  decision: GqlConflictDecision;
  edgeId: Scalars['String']['input'];
}

export interface GqlMutationRootRunCampaignSweepArgs {
  input: GqlRunCampaignSweepInput;
}

export interface GqlMutationRootSetOrganizationOverdraftLimitArgs {
  input: GqlAdminSetOrganizationOverdraftLimitInput;
}

export interface GqlMutationRootShopifyStoreDisconnectArgs {
  storeId: Scalars['ID']['input'];
}

export interface GqlMutationRootShopifyStoreSetPrimaryArgs {
  storeId: Scalars['ID']['input'];
}

export interface GqlMutationRootSignInArgs {
  input: GqlAccountSignInInput;
}

export interface GqlMutationRootSignInGoogleArgs {
  input: GqlAccountSignInGoogleInput;
}

export interface GqlMutationRootSignUpArgs {
  input: GqlAccountSignUpInput;
}

export interface GqlMutationRootSplitPersonaMemberArgs {
  authId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlMutationRootTopUpOrganizationCreditsArgs {
  input: GqlAdminTopUpOrganizationCreditsInput;
}

export interface GqlMutationRootTrackingLinkSetStatusArgs {
  input: GqlTrackingLinkSetStatusInput;
}

export interface GqlMutationRootUnsuppressEmailArgs {
  input: GqlUnsuppressEmailInput;
}

export interface GqlMutationRootUpdateCampaignAuthOutreachStatusArgs {
  input: GqlUpdateCampaignAuthOutreachStatusInput;
}

export interface GqlMutationRootUpdateCampaignAuthTaskStatusArgs {
  input: GqlUpdateCampaignAuthTaskStatusInput;
}

export interface GqlMutationRootUpdateCampaignExcludedPostIdsArgs {
  input: GqlUpdateCampaignExcludedPostIdsInput;
}

export interface GqlMutationRootUpdateCampaignIncludedPostIdsArgs {
  input: GqlUpdateCampaignIncludedPostIdsInput;
}

export interface GqlMutationRootUpdateLinkbioBackgroundArgs {
  input: GqlUpdateLinkBioBackgroundInput;
}

export interface GqlMutationRootUpdateLinkbioLinkArgs {
  input: GqlUpdateLinkBioLinkInput;
}

export interface GqlMutationRootUpdateLinkbioLinkIconArgs {
  input: GqlUpdateLinkBioLinkIconInput;
}

export interface GqlMutationRootUpdateLinkbioPageArgs {
  input: GqlUpdateLinkBioPageInput;
  linkbioId: Scalars['ID']['input'];
}

export interface GqlMutationRootUpdateLinkbioTabArgs {
  input: GqlUpdateLinkBioTabInput;
}

export interface GqlMutationRootUpdateLinkBioVisibilityArgs {
  linkbioId: Scalars['ID']['input'];
  showContactInfo: Scalars['Boolean']['input'];
  showPerformanceProfile: Scalars['Boolean']['input'];
}

export interface GqlMutationRootUpdateMemberArgs {
  input: GqlUpdateMemberInput;
}

export interface GqlMutationRootUpdateOrganizationProfileArgs {
  input: GqlUpdateOrganizationProfileInput;
}

export interface GqlMutationRootUpdateProfileArgs {
  input: GqlProfileUpdateInput;
}

export interface GqlMutationRootUpsertContactDetailsArgs {
  input: GqlUpdateLinkBioContactDetailsInput;
}

export interface GqlMutationRootUtmTemplateCreateArgs {
  input: GqlUtmTemplateCreateInput;
}

export interface GqlMutationRootUtmTemplateDeleteArgs {
  id: Scalars['String']['input'];
}

export interface GqlMutationRootUtmTemplateSetDefaultArgs {
  id: Scalars['String']['input'];
}

export interface GqlMutationRootUtmTemplateUpdateArgs {
  id: Scalars['String']['input'];
  input: GqlUtmTemplateUpdateInput;
}

export interface GqlMutationRootVerifyEmailArgs {
  input: GqlAccountVerifyEmailInput;
}

export interface GqlAcceptInvitationInput {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}

export interface GqlAccountResendVerificationEmailInput {
  email: Scalars['String']['input'];
}

export interface GqlAdminAddOrganizationMemberInput {
  accountId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  roleType: GqlGraphqlOrganizationRoleType;
}

export interface GqlAdminCreateAccountInput {
  email: Scalars['String']['input'];
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
}

export interface GqlAdminCreateOrganizationInput {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerAccountId: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
}

export interface GqlAdminIndustryInput {
  childIndustryIds?: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  parentIndustryId?: InputMaybe<Scalars['String']['input']>;
  pluralName?: InputMaybe<Scalars['String']['input']>;
  relatedIndustryIds?: Array<Scalars['String']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  status?: InputMaybe<GqlCreatorNetworkEntityStatus>;
}

export interface GqlAdminCreateInfluencerListInput {
  industryId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status?: InputMaybe<GqlCreatorNetworkEntityStatus>;
}

export interface GqlAdminLocationInput {
  childLocationIds?: Array<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  parentLocationId?: InputMaybe<Scalars['String']['input']>;
  relatedLocationIds?: Array<Scalars['String']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  stateCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GqlCreatorNetworkEntityStatus>;
  type: GqlCreatorNetworkLocationType;
}

export interface GqlAdminGenerateInfluencerListOverridesInput {
  contentCategorySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  followersMin?: InputMaybe<Scalars['Int']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * Result of `adminCreatorNetworkPublishDirectory` (#571): emitted counts, the
 * dry-run flag, and a human-readable summary of what was (or would be) done.
 */
export interface GqlAdminPublishDirectoryResult {
  dryRun: Scalars['Boolean']['output'];
  industries: Scalars['Int']['output'];
  influencers: Scalars['Int']['output'];
  locations: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
}

export interface GqlAdminInfluencerListMemberInput {
  authId: Scalars['String']['input'];
  included: Scalars['Boolean']['input'];
  locationId: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  primaryIndustryId: Scalars['String']['input'];
}

/**
 * Result row of `adminForceShallowEnrich`. One entry per requested
 * auth_id, in the same order. `outcome` is the
 * `ShallowOutcome::label()` value (`ok`, `conflict`, `empty_posts`,
 * `empty_analysis`, `timeout`, `error`) plus the `invalid_id` synthetic
 * label when the input string was not a valid hex ObjectId. `error`
 * carries the raw analyzer/repo error string only for the `error`
 * outcome.
 */
export interface GqlAdminForceShallowEnrichResultObject {
  authId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
}

export interface GqlAdminInviteMemberInput {
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  roleType: GqlGraphqlOrganizationRoleType;
}

/** Input for `adminRescueStuckAuths`. */
export interface GqlAdminRescueStuckAuthsInput {
  /** Cap on rows enqueued per call. Default 200, max 1000. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Minimum age (minutes) since `meta.statusChangedAt` for a row
   * to qualify. Default: 60.
   */
  thresholdMinutes?: InputMaybe<Scalars['Int']['input']>;
}

/** Result payload for `adminRescueStuckAuths`. */
export interface GqlAdminRescueStuckAuthsResult {
  /** Rows where the publish call errored (non-fatal, logged). */
  failed: Scalars['Int']['output'];
  /** Rows matching the threshold (≤ `limit`). */
  found: Scalars['Int']['output'];
  /**
   * Worker events successfully enqueued. Outbox dedup may suppress
   * duplicates within the same UTC day.
   */
  published: Scalars['Int']['output'];
}

export interface GqlAdminSetDemoRequestProcessedInput {
  id: Scalars['String']['input'];
  processed: Scalars['Boolean']['input'];
}

export interface GqlAdminSetSuperadminInput {
  accountId: Scalars['String']['input'];
  isSuperadmin: Scalars['Boolean']['input'];
}

export interface GqlAdminSetVerifiedInput {
  accountId: Scalars['String']['input'];
  isVerified: Scalars['Boolean']['input'];
}

export interface GqlAdminUpdateMemberInput {
  memberId: Scalars['String']['input'];
  roleType?: InputMaybe<GqlGraphqlOrganizationRoleType>;
  status?: InputMaybe<GqlGraphqlOrganizationMemberStatus>;
}

export interface GqlAdminUpdatePasswordInput {
  accountId: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}

export interface GqlCreateAffiliateProgramInputGql {
  attributionWindowDays: Scalars['Int']['input'];
  /** Commission rate in basis points (1000 == 10 %). */
  commissionBps: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status: GqlAffiliateProgramStatus;
}

export interface GqlEnrollCreatorInputGql {
  authId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}

export interface GqlCancelTurnInput {
  sessionId: Scalars['String']['input'];
}

export interface GqlDeleteSessionInput {
  sessionId: Scalars['String']['input'];
}

export interface GqlSendMessageInput {
  prompt: Scalars['String']['input'];
  /**
   * Parent session to auto-rotate off of (#639/#657). Set by the client only
   * when `sessionId` is null (minting a fresh session to continue a long
   * conversation) — the new session's first turn carries the parent's rolling
   * summary over. Ignored when `sessionId` is present.
   */
  rotatedFromSessionId?: InputMaybe<Scalars['String']['input']>;
  s3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  uiContext?: InputMaybe<GqlUiContextInput>;
}

export interface GqlUiContextInput {
  entity: GqlGqlChatEntityType;
  entityId: Scalars['String']['input'];
}

export interface GqlSendMessageOutput {
  message: GqlChatMessageOutput;
  sessionId: Scalars['String']['output'];
  status: GqlGqlChatSessionStatus;
}

export interface GqlSetExecutionModeInput {
  mode: GqlGqlExecutionMode;
  sessionId: Scalars['String']['input'];
}

/** Input for creating a new AI search */
export interface GqlCreateAiSearchInput {
  /** Natural language search prompt */
  prompt: Scalars['String']['input'];
}

/** Input for deleting a search history */
export interface GqlDeleteAiSearchInput {
  /** ID of the search history to delete */
  historyId: Scalars['String']['input'];
}

export interface GqlConnectTokenlessInput {
  source: GqlAuthSource;
  url: Scalars['String']['input'];
}

export interface GqlContactInfluencerInput {
  authId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
}

export interface GqlContactInfluencerOutput {
  status: GqlContactInfluencerStatus;
}

/** Result of sending an outreach email to an influencer (issue #498). */
export const GqlContactInfluencerStatus = {
  /** Duplicate of an already-accepted message — deduped. */
  AlreadySent: 'ALREADY_SENT',
  /**
   * Handed to the delivery layer (queued/sent from Marble's outreach
   * identity).
   */
  Sent: 'SENT',
  /** Recipient is on the suppression list — nothing was sent. */
  Suppressed: 'SUPPRESSED',
} as const;

export type GqlContactInfluencerStatus =
  (typeof GqlContactInfluencerStatus)[keyof typeof GqlContactInfluencerStatus];
export interface GqlAuthCreatorStatusInput {
  authId: Scalars['String']['input'];
  status?: InputMaybe<GqlRelationshipStatus>;
}

export interface GqlDeepLookupStartInput {
  authId: Scalars['String']['input'];
}

export interface GqlDisconnectAuthInput {
  authId: Scalars['String']['input'];
}

export interface GqlAuthGroupCreateInput {
  authIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
}

export interface GqlAuthGroupDeleteInput {
  authGroupId: Scalars['String']['input'];
}

export interface GqlAuthGroupImportFromCsvInput {
  authGroupId?: InputMaybe<Scalars['String']['input']>;
  csv: Scalars['String']['input'];
}

export interface GqlAuthGroupImportOutput {
  _id: Scalars['String']['output'];
  authGroupId: Scalars['String']['output'];
  failedItems: Scalars['Int']['output'];
  processedItems: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  totalItems: Scalars['Int']['output'];
}

export interface GqlAuthGroupManageMultipleGroupsForAuthInput {
  addedGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  authId: Scalars['String']['input'];
  removedGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface GqlAuthGroupsUpdateBulkInput {
  addedAuthIds: Array<Scalars['String']['input']>;
  authGroupIds: Array<Scalars['String']['input']>;
}

export interface GqlAuthGroupUpdateInput {
  addedAuthIds?: InputMaybe<Array<Scalars['String']['input']>>;
  authGroupId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  removedAuthIds?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface GqlAuthPrefetchInput {
  innerId?: InputMaybe<Scalars['String']['input']>;
  source: GqlAuthSource;
  username?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlAuthNoteInput {
  address?: InputMaybe<Scalars['String']['input']>;
  authId: Scalars['String']['input'];
  campaignAuthNotes?: InputMaybe<Array<GqlAuthNoteCampaignInput>>;
  documentUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  message?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlAuthNoteCampaignInput {
  campaignId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}

export interface GqlAuthNoteDeleteInput {
  authId: Scalars['String']['input'];
}

export interface GqlAuthNoteItemCreateInput {
  attachments?: InputMaybe<Array<GqlDocumentInput>>;
  authId: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  scope?: GqlNoteScopeEnum;
}

export interface GqlDocumentInput {
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
}

export interface GqlAuthNoteItemDeleteInput {
  noteId: Scalars['String']['input'];
}

export interface GqlAuthNoteItemEditInput {
  attachments?: InputMaybe<Array<GqlDocumentInput>>;
  message?: InputMaybe<Scalars['String']['input']>;
  noteId: Scalars['String']['input'];
}

export interface GqlAuthNoteItemPinInput {
  noteId: Scalars['String']['input'];
}

export interface GqlAuthNoteItemUnpinInput {
  noteId: Scalars['String']['input'];
}

export interface GqlAuthRefetchInput {
  authId: Scalars['String']['input'];
}

export interface GqlCampaignAuthsUpdateBulkInput {
  addedAuthIds: Array<Scalars['String']['input']>;
  campaignIds: Array<Scalars['String']['input']>;
}

export interface GqlCampaignAuthTaskAcceptInput {
  secret: Scalars['String']['input'];
}

export interface GqlCampaignAuthTaskInput {
  authId: Scalars['String']['input'];
  campaignId: Scalars['String']['input'];
  deadline?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Paid Media Rights (#157) — greenlit for paid amplification. On edit,
   * `None` leaves the stored value unchanged; `Some(_)` overwrites it.
   */
  paidMediaRights?: InputMaybe<Scalars['Boolean']['input']>;
  /** Human-readable rights duration, e.g. "3 months", "perpetual". */
  paidMediaRightsDuration?: InputMaybe<Scalars['String']['input']>;
  /**
   * Additional fee for paid-media usage rights, in USD minor units (cents),
   * e.g. `150000` = $1500.00, `0` = inclusive/bundled. Must be `>= 0`.
   */
  paidMediaRightsFee?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Platforms the rights cover, e.g. `["meta", "tiktok", "google"]`.
   * On edit, `None` leaves the stored list unchanged; `Some(_)` replaces it.
   */
  paidMediaRightsPlatforms?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentOptions: GqlCampaignAuthTaskPaymentOptionsInput;
  postCount?: InputMaybe<Scalars['Int']['input']>;
  storyCount?: InputMaybe<Scalars['Int']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  videoCount?: InputMaybe<Scalars['Int']['input']>;
}

export interface GqlCampaignAuthTaskPaymentOptionsInput {
  commission?: InputMaybe<Scalars['Float']['input']>;
  flatFee?: InputMaybe<Scalars['Float']['input']>;
  gift?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<GqlCampaignPaymentTermsEnum>;
}

export interface GqlCampaignAuthTaskLinkInput {
  authId: Scalars['String']['input'];
  campaignId: Scalars['String']['input'];
  /**
   * Optional user-supplied human-readable short code for `/l/{code}`
   * (#9105). Validated + normalized server-side; rejected (CONFLICT) if
   * already taken — never silently auto-suffixed.
   */
  customCode?: InputMaybe<Scalars['String']['input']>;
  isCustomLink?: InputMaybe<Scalars['Boolean']['input']>;
  longUrl: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCampaignAuthTaskLinkInputBulk {
  items: Array<GqlCampaignAuthTaskLinkBulkItemInput>;
}

export interface GqlCampaignAuthTaskLinkBulkItemInput {
  authId: Scalars['String']['input'];
  campaignId: Scalars['String']['input'];
  /**
   * Optional user-supplied human-readable short code for `/l/{code}`
   * (#9105). Validated + normalized server-side; the batch is rejected
   * (BAD_REQUEST for a malformed code, CONFLICT if already taken) — a
   * custom code is never silently auto-suffixed.
   */
  customCode?: InputMaybe<Scalars['String']['input']>;
  longUrl: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCampaignAuthTaskLinkDeleteInput {
  linkId: Scalars['String']['input'];
}

export interface GqlCampaignAuthTaskLinkDeleteBulkInput {
  linkIds: Array<Scalars['String']['input']>;
}

export interface GqlCampaignAuthTaskRejectInput {
  secret: Scalars['String']['input'];
}

/**
 * Input for creating a new campaign.
 * Campaigns are created in Draft status and can be started later using campaignStart mutation.
 * Only `name` is required - all other fields can be filled in before starting the campaign.
 */
export interface GqlCampaignBuildInput {
  /** S3 key for campaign avatar image */
  avatarS3Key?: InputMaybe<Scalars['String']['input']>;
  /**
   * Total campaign budget in USD. Defaults to 0.0 if not provided.
   * **Must be greater than 0 before starting campaign** (activating from Draft to Active).
   */
  budget?: InputMaybe<Scalars['Float']['input']>;
  /** Type of campaign (e.g., "awareness", "conversion"). Defaults to empty string if not provided. */
  campaignType?: InputMaybe<Scalars['String']['input']>;
  /** Default code expiry in days after mint (#9104). */
  defaultExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Default per-creator-code redeem limit (#9104). `0` = unlimited. */
  defaultRedeemLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Detailed campaign description. Defaults to empty string if not provided. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Campaign end date (ISO 8601 format) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Actual finish date when campaign was completed */
  finishDate?: InputMaybe<Scalars['String']['input']>;
  /** Google Analytics connection ID for tracking */
  gaConnectionId?: InputMaybe<Scalars['String']['input']>;
  /** Hashtags to track (e.g., #campaign) */
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of influencer auth IDs to participate in campaign */
  influencerAuthIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Keywords for content matching */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Social media mentions to track (e.g., @brand) */
  mentions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Campaign name (required, 1-200 characters) */
  name: Scalars['String']['input'];
  /**
   * One-line statement of the campaign's main aim (replaces the
   * legacy `goals` + `keyPerformanceIndicator` pair). Optional —
   * the user can launch without it.
   */
  primaryObjective?: InputMaybe<Scalars['String']['input']>;
  /** Type of product being promoted. Defaults to empty string if not provided. */
  productType?: InputMaybe<Scalars['String']['input']>;
  /** Campaign start date (ISO 8601 format) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Commerce attribution target (#9104): connected Shopify store id. */
  storeId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Free-form description of the audience the campaign is meant to
   * reach (e.g. "US Gen Z runners 18-25, urban"). Optional.
   */
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  /** Aspirational reach (number of unique people). Optional. */
  targetReach?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Per-campaign UTM template override (Track D Phase 4b). When `null`
   * the campaign inherits the workspace default at link-creation time.
   */
  utmTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** Brand's website URL for the campaign */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Input for `campaign_create_with_chat`. The resolver creates a placeholder
 * draft campaign (name = `Untitled campaign`) and immediately spawns an
 * AIChat Automation session whose first message hands the agent everything
 * in this input. The agent is expected to rename the campaign as one of its
 * first updates.
 *
 * At least one of `documentIds` / `aiPrompt` must be non-empty — without a
 * brief or instruction the agent has nothing to act on.
 */
export interface GqlCampaignCreateWithChatInput {
  /**
   * Free-form instruction handed to the agent verbatim. Falls back to a
   * generic default when omitted but `documentIds` is supplied.
   */
  aiPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pre-uploaded S3 keys (e.g. brief PDFs) attached to the agent's first
   * message.
   */
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
}

/**
 * Output of `campaign_create_with_chat`. Frontend opens the chat at
 * `chatSessionId` and uses `campaign` to render the inline draft card.
 */
export interface GqlCampaignChatSessionOutput {
  campaign: GqlCampaignOutput;
  chatSessionId: Scalars['String']['output'];
}

/** Input for archiving (soft-deleting) a campaign (frontend #76 Delete button). */
export interface GqlCampaignDeleteInput {
  campaignId: Scalars['String']['input'];
}

export interface GqlCampaignUpdateInput {
  avatarS3Key?: InputMaybe<Scalars['String']['input']>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  campaignId: Scalars['String']['input'];
  campaignType?: InputMaybe<Scalars['String']['input']>;
  costConfig?: InputMaybe<GqlCampaignCostConfigInput>;
  /**
   * Default code expiry in days after mint (#9104).
   * Set to null to clear; omit to leave unchanged.
   */
  defaultExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Default per-creator-code redeem limit (#9104). `0` = unlimited.
   * Set to null to clear; omit to leave unchanged.
   */
  defaultRedeemLimit?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Set to null to clear the end date */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Set to null to clear the finish date */
  finishDate?: InputMaybe<Scalars['String']['input']>;
  /** Set to null to clear the GA connection */
  gaConnectionId?: InputMaybe<Scalars['String']['input']>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  influencerAuthIds?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  mentions?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryObjective?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  /** Set to null to clear the start date */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Commerce attribution target (#9104): connected Shopify store id.
   * Set to null to clear; omit to leave unchanged.
   */
  storeId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Per-campaign auto-sweep toggle (#712). Omit to leave unchanged. Gates
   * only the scheduled sweep worker; the `runCampaignSweep` button is always
   * available regardless.
   */
  sweepEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  /** Set to null to clear target_reach */
  targetReach?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Per-campaign UTM template override (Track D Phase 4b).
   * Set to null to clear (inherit workspace default); omit to leave unchanged.
   */
  utmTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** Set to null to clear the website URL */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCampaignCostConfigInput {
  cpc?: InputMaybe<Scalars['Float']['input']>;
  cpe?: InputMaybe<Scalars['Float']['input']>;
  cpv?: InputMaybe<Scalars['Float']['input']>;
  flatFee?: InputMaybe<Scalars['Float']['input']>;
}

export interface GqlCampaignExportOptionsInput {
  includeActivity?: InputMaybe<Scalars['Boolean']['input']>;
  includeAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  includeCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  includeCreators?: InputMaybe<Scalars['Boolean']['input']>;
  includeGaMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  includeLinks?: InputMaybe<Scalars['Boolean']['input']>;
  includeOutreach?: InputMaybe<Scalars['Boolean']['input']>;
  includePayments?: InputMaybe<Scalars['Boolean']['input']>;
  includePosts?: InputMaybe<Scalars['Boolean']['input']>;
  includeTasks?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlCampaignFinishInput {
  campaignId: Scalars['String']['input'];
}

export interface GqlCampaignGiftCreateInput {
  campaignAuthTaskId: Scalars['ID']['input'];
  lineItems: Array<GqlGiftLineItemInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  shopifyStoreId: Scalars['ID']['input'];
}

/**
 * **Spec deviation, documented in
 * `application/src/campaign_gift/usecases/create_gift.rs`.** The spec's
 * input is `{ variantId, quantity }`; the implementation extends it to
 * `{ productId, variantId, quantity, variant }` because the Track B
 * `ShopifyProduct` mirror does not carry variants, so the server
 * cannot resolve variant → product to snapshot the title. FE sends
 * what it already has from the picker.
 */
export interface GqlGiftLineItemInput {
  /**
   * Shopify product GID — server uses this to look up the title
   * snapshot in the product mirror.
   */
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  /**
   * Optional variant label snapshot (e.g. `"M / Black"`); FE has
   * this at attach time from the picker.
   */
  variant?: InputMaybe<Scalars['String']['input']>;
  /** Shopify variant GID — sent to Shopify in the Stage-2 send flow. */
  variantId: Scalars['ID']['input'];
}

export interface GqlGiftAddressInput {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  /** ISO 3166-1 alpha-2. */
  countryCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
}

/**
 * Input for `campaign_import_historical` — import a past campaign that ran
 * on another platform for retroactive traffic-lift analysis. The campaign
 * is created directly in the terminal `Historical` status; the extraction
 * agent then fills its detail from the supplied documents.
 */
export interface GqlCampaignImportHistoricalInput {
  /** Optional extra instruction handed to the extraction agent verbatim. */
  aiPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the historical campaign. */
  campaignName: Scalars['String']['input'];
  /** Campaign end — RFC 3339 timestamp. Must not precede `startDate`. */
  endDate: Scalars['String']['input'];
  /**
   * GA connection the traffic-lift analysis reads. Required — the report
   * cannot be produced without a connected GA property.
   */
  gaConnectionId: Scalars['String']['input'];
  /**
   * Pre-uploaded S3 keys of the source documents (campaign reports,
   * influencer spreadsheets). At least one is required.
   */
  s3Keys: Array<Scalars['String']['input']>;
  /** Campaign start — RFC 3339 timestamp (e.g. `2026-03-01T00:00:00Z`). */
  startDate: Scalars['String']['input'];
}

export interface GqlCampaignLinkHealthCheckAllInput {
  campaignId: Scalars['String']['input'];
}

export interface GqlCampaignLinkHealthCheckOneInput {
  campaignId: Scalars['String']['input'];
  linkId: Scalars['String']['input'];
}

export interface GqlCampaignOfflineRevenueCreateInput {
  amount: Scalars['Float']['input'];
  authId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['String']['input'];
  currency: GqlCampaignPaymentCurrencyEnum;
  description?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCampaignOfflineRevenueDeleteInput {
  campaignId: Scalars['String']['input'];
  revenueId: Scalars['String']['input'];
}

export interface GqlCampaignPaymentCreateInput {
  authItems: Array<GqlCampaignPaymentAuthItemInput>;
  campaignId: Scalars['String']['input'];
  provider: GqlCampaignPaymentProviderEnum;
}

export interface GqlCampaignPaymentAuthItemInput {
  amount: Scalars['Float']['input'];
  authId: Scalars['String']['input'];
  currency: GqlCampaignPaymentCurrencyEnum;
}

export interface GqlCampaignPaymentDeleteInput {
  paymentId: Scalars['String']['input'];
}

export interface GqlCampaignRecommendationUpdateStatusInput {
  recommendationId: Scalars['String']['input'];
  status: GqlRecommendationStatusEnum;
}

/**
 * Input for starting (activating) a campaign from Draft to Active status.
 * This operation validates that all required fields are filled before activation.
 */
export interface GqlCampaignStartInput {
  campaignId: Scalars['String']['input'];
}

export interface GqlCampaignTaskTemplateApplyInput {
  authIds?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignId: Scalars['String']['input'];
}

export interface GqlApplyTemplateResultOutput {
  created: Scalars['Int']['output'];
  errors: Array<GqlApplyTemplateErrorOutput>;
  failed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
}

export interface GqlApplyTemplateErrorOutput {
  authId: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

export interface GqlCampaignTaskTemplateSaveInput {
  campaignId: Scalars['String']['input'];
  deadline?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Brief documents. Omitted/null preserves the existing set;
   * `[]` clears all; a list replaces.
   */
  documents?: InputMaybe<Array<GqlDocumentInput>>;
  /**
   * Tracking-link definitions (#507). Omitted/null preserves the existing
   * set; `[]` clears all; a list replaces (same semantics as `documents`).
   */
  links?: InputMaybe<Array<GqlTaskTemplateLinkInput>>;
  paymentOptions: GqlCampaignAuthTaskPaymentOptionsInput;
  postCount: Scalars['Int']['input'];
  storyCount: Scalars['Int']['input'];
  videoCount: Scalars['Int']['input'];
}

export interface GqlTaskTemplateLinkInput {
  longUrl: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCancelOrganizationMemberInvitationInput {
  memberId: Scalars['String']['input'];
}

export interface GqlAccountPasswordChangeInput {
  oldPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface GqlAccountWithTokens {
  account: GqlAccount;
  tokens: GqlAccountTokenOutput;
}

/**
 * Input for creating a LinkBio link.
 *
 * Note: The `source` field is automatically fetched from the auth entity
 * based on `authId` if provided. This ensures data consistency.
 */
export interface GqlCreateLinkBioLinkInput {
  authId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageHidden?: InputMaybe<Scalars['Boolean']['input']>;
  imageS3Key?: InputMaybe<Scalars['String']['input']>;
  linkbioId: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  postId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
}

/**
 * Input for creating a LinkBio link icon.
 *
 * The user provides a social network source and URL/username. The system will:
 * 1. Resolve the auth through tokenless service
 * 2. Index the auth in the database
 * 3. Create the icon with the resolved auth
 */
export interface GqlCreateLinkBioLinkIconInput {
  linkbioId: Scalars['ID']['input'];
  /** Social network source (must be supported by tokenless service) */
  source: GqlSources;
  /** URL or username of the social media profile */
  urlOrUsername: Scalars['String']['input'];
}

export interface GqlCreateLinkBioPageInput {
  avatarS3Key?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  customDomain?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  previewImageUrl?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Input for creating a LinkBio tab.
 *
 * Note: The `source` field is automatically fetched from the auth entity
 * based on `authId` if provided. This ensures data consistency.
 */
export interface GqlCreateLinkBioTabInput {
  authId?: InputMaybe<Scalars['ID']['input']>;
  linkbioId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: GqlLinkbioMarkupTabType;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlCreateOrganizationInput {
  avatarS3Key?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  goals?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  socialProfilesUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlCreatorPreferencesInput {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  collaborationNotes?: InputMaybe<Scalars['String']['input']>;
  contentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  excludedIndustries?: InputMaybe<Array<Scalars['String']['input']>>;
  exclusivityDays?: InputMaybe<Scalars['Int']['input']>;
  geographicFocus?: InputMaybe<Array<Scalars['String']['input']>>;
  maxActiveCampaigns?: InputMaybe<Scalars['Int']['input']>;
  minimumDealValue?: InputMaybe<Scalars['Float']['input']>;
  platformRates?: InputMaybe<Array<GqlPlatformRateCardInput>>;
  preferredBrandSizes?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredNiches?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface GqlPlatformRateCardInput {
  rateLive?: InputMaybe<Scalars['Float']['input']>;
  ratePost?: InputMaybe<Scalars['Float']['input']>;
  rateReel?: InputMaybe<Scalars['Float']['input']>;
  rateStory?: InputMaybe<Scalars['Float']['input']>;
  rateVideo?: InputMaybe<Scalars['Float']['input']>;
  source: Scalars['String']['input'];
}

export interface GqlDeleteLinkBioLinkIconInput {
  iconId: Scalars['ID']['input'];
  linkbioId: Scalars['ID']['input'];
}

export interface GqlDeleteLinkBioTabInput {
  linkbioId: Scalars['ID']['input'];
  tabId: Scalars['ID']['input'];
}

export interface GqlDeleteOrganizationMemberInput {
  memberId: Scalars['String']['input'];
}

export interface GqlGaTrackedEventInput {
  name: Scalars['String']['input'];
  pagePathFilter?: InputMaybe<Scalars['String']['input']>;
  pagePathOperator?: InputMaybe<GqlGqlGaPagePathOperator>;
}

export interface GqlGaConnectionCreateInput {
  /**
   * The picked web stream's `defaultUri`. Server stores this as
   * `websiteUrl` (see issue #453 §4.3) — the user no longer types a
   * site URL by hand.
   */
  defaultUri: Scalars['String']['input'];
  /** GA-side numeric account id from `gaAccountList` (e.g. `"171114564"`). */
  gaAccountId: Scalars['String']['input'];
  gaAccountName: Scalars['String']['input'];
  /** GA Admin API property identifier — `properties/{numeric_id}`. */
  gaPropertyId: Scalars['String']['input'];
  gaPropertyName: Scalars['String']['input'];
  /** Web stream numeric id, from the picked option in `gaWebStreamsList`. */
  gaWebStreamId: Scalars['String']['input'];
  gaWebStreamName: Scalars['String']['input'];
  /**
   * GA4 measurement id (`G-XXXXXXXXXX`). Validated regex-side as
   * `^G-[A-Z0-9]{10}$`.
   */
  measurementId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /**
   * Optional tracked events to seed on the new property. When omitted, a
   * default `{ name: "purchase", operator: contains, filter: null }` is
   * inserted server-side (§4.1 / Phase B). Caller-provided events pass
   * through `UpdateTrackedEventsUseCase` validation (regex, ≥1, ≤50,
   * tuple uniqueness, path starts with `/`).
   */
  trackedEvents?: InputMaybe<Array<GqlGaTrackedEventInput>>;
}

export interface GqlGaConnectionDeleteInput {
  id: Scalars['String']['input'];
}

export interface GqlGaConnectionDisconnectInput {
  id: Scalars['String']['input'];
}

export interface GqlGaConnectionUpdateInput {
  /**
   * Picked web stream's `defaultUri`. Required by the use case whenever
   * `gaWebStreamId` is being changed; otherwise optional. When set, the
   * server rewrites `websiteUrl` to mirror it.
   */
  defaultUri?: InputMaybe<Scalars['String']['input']>;
  gaAccountId?: InputMaybe<Scalars['String']['input']>;
  gaAccountName?: InputMaybe<Scalars['String']['input']>;
  gaPropertyId?: InputMaybe<Scalars['String']['input']>;
  gaPropertyName?: InputMaybe<Scalars['String']['input']>;
  gaWebStreamId?: InputMaybe<Scalars['String']['input']>;
  gaWebStreamName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  measurementId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlGenerateCampaignDraftInput {
  budget?: InputMaybe<Scalars['Float']['input']>;
  /** Campaign the draft is for. Ownership is verified against the caller's org. */
  campaignId: Scalars['String']['input'];
  campaignType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Target channels fed into the LLM prompt (transient — not persisted).
   * Per-item length is bounded in the prompt builder; `max_items` here
   * caps the list itself so callers can't blow out the request size.
   */
  channels?: Array<Scalars['String']['input']>;
  /** GA connection ID (NOT inferred from org — orgs can have multiple). */
  gaConnectionId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productType?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlAiDraftResultOutput {
  contextQuality: GqlContextQualityOutput;
  description: Scalars['String']['output'];
  hashtags: Array<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
  mentions: Array<Scalars['String']['output']>;
  objective: GqlCampaignObjectiveOutput;
  suggestedBudget?: Maybe<GqlSuggestedBudgetOutput>;
}

export interface GqlContextQualityOutput {
  historyCount: Scalars['Int']['output'];
  usedBrandContext: Scalars['Boolean']['output'];
  usedGa: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
}

/**
 * Campaign objective returned by AI Draft. Maps to
 * `domain::campaigns::CampaignObjective`.
 */
export const GqlCampaignObjectiveOutput = {
  Awareness: 'AWARENESS',
  Conversions: 'CONVERSIONS',
  Engagement: 'ENGAGEMENT',
  Loyalty: 'LOYALTY',
} as const;

export type GqlCampaignObjectiveOutput =
  (typeof GqlCampaignObjectiveOutput)[keyof typeof GqlCampaignObjectiveOutput];
export interface GqlSuggestedBudgetOutput {
  currency: Scalars['String']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
}

export interface GqlInviteMemberInput {
  department?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<GqlOrganizationPermissionItemInput>>;
  roleType: GqlGraphqlOrganizationRoleType;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlOrganizationPermissionItemInput {
  enabled: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
}

/**
 * Input for the `organizationAnomalySurfacingSettingsUpdate` mutation. Full
 * desired state — both fields are required; the panel always sends both.
 */
export interface GqlAnomalySurfacingSettingsInput {
  disabledKinds: Array<GqlBrandSafetyWarningKindEnum>;
  minPriority: GqlRecommendationPriorityEnum;
}

/** Input for deleting an organization campaign relationship. */
export interface GqlOrganizationCampaignDeleteInput {
  organizationCampaignId: Scalars['String']['input'];
}

export interface GqlConnectSenderDomainInputGql {
  /** Bare sending domain, e.g. `brand.com`. */
  domain: Scalars['String']['input'];
  /** Optional local-part for the From address; defaults to `outreach`. */
  localPart?: InputMaybe<Scalars['String']['input']>;
}

/** Result of the connect mutation: the config + the DNS records to publish. */
export interface GqlConnectSenderDomainOutput {
  config: GqlOrganizationEmailConfigOutput;
  dnsRecords: Array<GqlDnsRecordOutput>;
}

export interface GqlCreateOrganizationShippingDetailsInput {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
}

export interface GqlUpdateOrganizationShippingDetailsInput {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Input for creating a custom post.
 *
 * Note: The `source` and `auth_inner_id` fields are automatically fetched
 * from the auth entity based on `auth_id`. This ensures data consistency.
 */
export interface GqlCreateCustomPostInput {
  authId: Scalars['String']['input'];
  createdAt: Scalars['String']['input'];
  engagement: GqlCustomPostEngagementInput;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  imageS3Key: Scalars['String']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  mentions?: InputMaybe<Array<Scalars['String']['input']>>;
  postType: GqlPostTypeEnum;
}

export interface GqlCustomPostEngagementInput {
  comments: Scalars['Int']['input'];
  likes: Scalars['Int']['input'];
  shares: Scalars['Int']['input'];
  views: Scalars['Int']['input'];
}

export interface GqlUpdatePostCustomEngagementInput {
  comments: Scalars['Int']['input'];
  likes: Scalars['Int']['input'];
  postId: Scalars['String']['input'];
  shares: Scalars['Int']['input'];
  views: Scalars['Int']['input'];
}

export interface GqlLoadMorePostsInput {
  authId: Scalars['String']['input'];
}

export interface GqlLoadMorePostsOutput {
  hasMore: Scalars['Boolean']['output'];
  posts: Array<GqlPostOutput>;
}

export interface GqlUpdatePostUrlCtaInput {
  postId: Scalars['String']['input'];
  urlCta: Scalars['String']['input'];
}

export interface GqlLinkPromoCodeInputGql {
  appliesTo: GqlAppliesToGql;
  authId?: InputMaybe<Scalars['ID']['input']>;
  campaignId: Scalars['ID']['input'];
  shopifyDiscountId: Scalars['ID']['input'];
  shopifyStoreId: Scalars['ID']['input'];
}

export interface GqlMintPromoCodeInputGql {
  appliesTo: GqlAppliesToGql;
  /** `null` mints a brand-wide generic code (e.g. `JLB15`). */
  authId?: InputMaybe<Scalars['ID']['input']>;
  campaignId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  discountType: GqlDiscountTypeGql;
  discountValue: Scalars['Int']['input'];
  endsAt?: InputMaybe<Scalars['String']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  onePerCustomer: Scalars['Boolean']['input'];
  shopifyStoreId: Scalars['ID']['input'];
  /**
   * RFC 3339 timestamp (e.g. `2026-05-20T12:00:00Z`). The codebase
   * convention is string-typed datetimes on the wire; the resolver
   * parses to `DateTime<Utc>` before handing off to the use case.
   */
  startsAt?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlUpdatePromoCodeInputGql {
  discountType: GqlDiscountTypeGql;
  discountValue: Scalars['Int']['input'];
  endsAt?: InputMaybe<Scalars['String']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  onePerCustomer: Scalars['Boolean']['input'];
  promoCodeId: Scalars['ID']['input'];
  startsAt?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlReorderInput {
  itemsToReorder: Array<GqlReorderInputItem>;
}

export interface GqlReorderInputItem {
  _id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
}

/** A generic list view for pagination */
export interface GqlLinkbioLinkIconListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlLinkbioLinkIcon>;
  limit: Scalars['Int']['output'];
}

/** A generic list view for pagination */
export interface GqlLinkbioLinkList {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlLinkbioLink>;
  limit: Scalars['Int']['output'];
}

/** A generic list view for pagination */
export interface GqlLinkbioTabListOutput {
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<GqlLinkbioTab>;
  limit: Scalars['Int']['output'];
}

export interface GqlRequestDemoInput {
  company?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Which form the lead came from, e.g. "request-demo" or "join". */
  source?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlRequestDemoOutput {
  success: Scalars['Boolean']['output'];
}

export interface GqlAccountPasswordResetRequestInput {
  email: Scalars['String']['input'];
}

export interface GqlAccountPasswordResetInput {
  newPassword: Scalars['String']['input'];
}

/** A human decision over a `Review` conflict edge. */
export const GqlConflictDecision = {
  /** Merge the candidate into the persona (human override; bypasses the guard). */
  Confirm: 'CONFIRM',
  /** Keep the candidate separate; remember the rejection. */
  Reject: 'REJECT',
} as const;

export type GqlConflictDecision =
  (typeof GqlConflictDecision)[keyof typeof GqlConflictDecision];
export interface GqlRunCampaignSweepInput {
  campaignId: Scalars['String']['input'];
}

export interface GqlAdminSetOrganizationOverdraftLimitInput {
  organizationId: Scalars['String']['input'];
  /**
   * Non-negative overdraft allowance in **credits**. `0` disables overdraft
   * (hard-block at zero). Optional twin of `overdraftLimitUsdMicros` —
   * exactly one of the two must be provided. Validated
   * `0 <= limit <= 10_000_000` in the use case. Kept for one release (#582
   * Stage C); prefer `overdraftLimitUsdMicros`.
   */
  overdraftLimitCredits?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Non-negative overdraft allowance in **micro-USD** (`1 credit = 10_000
   * micros`). Additive twin (#582 Stage C). Must be a multiple of 10_000
   * (whole credits) — rejected otherwise (never truncated).
   */
  overdraftLimitUsdMicros?: InputMaybe<Scalars['Int']['input']>;
}

export interface GqlAccountSignInInput {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  urlParams?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlAccountSignInGoogleInput {
  googleToken: Scalars['String']['input'];
  urlParams?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlAccountSignUpInput {
  email?: InputMaybe<Scalars['String']['input']>;
  organizationInvitationToken?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  urlParams?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlAdminTopUpOrganizationCreditsInput {
  /**
   * Signed amount in **credits**. Positive = grant; negative = manual
   * reduction (clamped at `balance=0`). Optional twin of `amountUsdMicros` —
   * exactly one of the two must be provided. Kept for one release (#582
   * Stage C); prefer `amountUsdMicros`.
   */
  amountCredits?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Signed amount in **micro-USD** (`1 credit = 10_000 micros`). Additive
   * twin of `amountCredits` (#582 Stage C). Must be a multiple of 10_000
   * (whole credits) — sub-credit top-ups are rejected until Stage E, since
   * they would break the exact credit mirror / rollback. NOT a USD unit.
   */
  amountUsdMicros?: InputMaybe<Scalars['Int']['input']>;
  note: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}

export interface GqlTopUpOutcomeObject {
  /**
   * Derived from `amountAppliedUsdMicros / 10_000`.
   * @deprecated use amountAppliedUsdMicros (integer micro-USD); credits are derived micros/10_000
   */
  amountApplied: Scalars['Int']['output'];
  /**
   * Applied top-up amount in micro-USD (differs from requested only when a
   * negative reduction was clamped at `balance=0`).
   */
  amountAppliedUsdMicros: Scalars['Int']['output'];
  /**
   * Derived from `amountRequestedUsdMicros / 10_000`.
   * @deprecated use amountRequestedUsdMicros (integer micro-USD); credits are derived micros/10_000
   */
  amountRequested: Scalars['Int']['output'];
  /** Requested top-up amount in micro-USD (#582 Stage C). */
  amountRequestedUsdMicros: Scalars['Int']['output'];
  balance: GqlOrganizationCreditBalanceObject;
  clamped: Scalars['Boolean']['output'];
}

export interface GqlTrackingLinkSetStatusInput {
  linkId: Scalars['String']['input'];
  status: GqlGraphqlLinkStatus;
}

export interface GqlUnsuppressEmailInput {
  /** Lowercase + trim applied by the address constructor. */
  address: Scalars['String']['input'];
  categoryScope: GqlCategoryScopeInput;
  /**
   * `None`/empty string = match a global suppression. `Some(org_hex)` =
   * match a per-org suppression.
   */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * One-of input — exactly one of `all_categories` or `categories` must be
 * set. Empty `categories` is rejected — callers that mean "any category"
 * must use `all_categories: true`.
 */
export interface GqlCategoryScopeInput {
  allCategories?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<GqlGraphqlEmailCategory>>;
}

export interface GqlUpdateCampaignAuthOutreachStatusInput {
  authId: Scalars['String']['input'];
  campaignId: Scalars['String']['input'];
  status: GqlCampaignAuthOutreachStatusEnum;
}

export interface GqlUpdateCampaignAuthTaskStatusInput {
  status: GqlCampaignAuthTaskStatusEnum;
  taskId: Scalars['String']['input'];
}

export interface GqlUpdateCampaignExcludedPostIdsInput {
  campaignId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}

export interface GqlUpdateCampaignIncludedPostIdsInput {
  campaignId: Scalars['String']['input'];
  postId: Scalars['String']['input'];
}

export interface GqlUpdateLinkBioBackgroundInput {
  advancedColor?: InputMaybe<GqlBackgroundAdvancedColorInput>;
  avatarAlignmentType?: InputMaybe<GqlAvatarAlignmentType>;
  avatarStrokeType?: InputMaybe<GqlAvatarStrokeType>;
  backgroundImage?: InputMaybe<GqlBackgroundImage>;
  brandingHidden?: InputMaybe<Scalars['Boolean']['input']>;
  colorMode?: InputMaybe<GqlColorMode>;
  headerImageUrl?: InputMaybe<Scalars['String']['input']>;
  linkbioId: Scalars['ID']['input'];
}

export interface GqlBackgroundAdvancedColorInput {
  background: Scalars['String']['input'];
  icons: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  line: Scalars['String']['input'];
  primary: Scalars['String']['input'];
  secondary: Scalars['String']['input'];
  shadow1: Scalars['String']['input'];
  shadow2: Scalars['String']['input'];
  shadow3: Scalars['String']['input'];
  text: Scalars['String']['input'];
}

/**
 * Input for updating a LinkBio link.
 *
 * Note: The `source` field is automatically fetched from the auth entity
 * based on `authId` if provided. This ensures data consistency.
 */
export interface GqlUpdateLinkBioLinkInput {
  authId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageHidden?: InputMaybe<Scalars['Boolean']['input']>;
  imageS3Key?: InputMaybe<Scalars['String']['input']>;
  linkbioId: Scalars['ID']['input'];
  linkId: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  postId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Input for updating a LinkBio link icon.
 *
 * Note: The `source` field is automatically fetched from the auth entity
 * based on `authId` if provided. This ensures data consistency.
 */
export interface GqlUpdateLinkBioLinkIconInput {
  authId?: InputMaybe<Scalars['ID']['input']>;
  iconId: Scalars['ID']['input'];
  linkbioId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlUpdateLinkBioPageInput {
  avatarS3Key?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  customDomain?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  previewImageUrl?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Input for updating a LinkBio tab.
 *
 * Note: The `source` field is automatically fetched from the auth entity
 * based on `authId` if provided. This ensures data consistency.
 */
export interface GqlUpdateLinkBioTabInput {
  authId?: InputMaybe<Scalars['ID']['input']>;
  linkbioId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tabId: Scalars['ID']['input'];
  type?: InputMaybe<GqlLinkbioMarkupTabType>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlUpdateMemberInput {
  department?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  memberId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<GqlOrganizationPermissionItemInput>>;
  roleType?: InputMaybe<GqlGraphqlOrganizationRoleType>;
  status?: InputMaybe<GqlGraphqlOrganizationMemberStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlUpdateOrganizationProfileInput {
  avatarS3Key?: InputMaybe<Scalars['String']['input']>;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  goals?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlProfileUpdateInput {
  avatarS3Key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingPassed?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GqlUpdateLinkBioContactDetailsInput {
  contactDetails: GqlLinkBioContactDetailsUpdateInput;
  linkbioId: Scalars['ID']['input'];
}

export interface GqlLinkBioContactDetailsUpdateInput {
  buttonText: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  infoMessage: Scalars['String']['input'];
  targetEmail: Scalars['String']['input'];
}

export interface GqlLinkbioContactDetails {
  buttonText: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  infoMessage: Scalars['String']['output'];
  linkbioId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  targetEmail: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface GqlUtmTemplateCreateInput {
  campaignTemplate: Scalars['String']['input'];
  contentTemplate?: InputMaybe<Scalars['String']['input']>;
  mediumTemplate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /**
   * #540a — optional vanity short-code template. Omit to keep
   * random-hash codes.
   */
  shortLinkTemplate?: InputMaybe<Scalars['String']['input']>;
  sourceTemplate: Scalars['String']['input'];
  termTemplate?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlUtmTemplateUpdateInput {
  campaignTemplate: Scalars['String']['input'];
  contentTemplate?: InputMaybe<Scalars['String']['input']>;
  mediumTemplate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** #540a — optional vanity short-code template. Omit/null clears it. */
  shortLinkTemplate?: InputMaybe<Scalars['String']['input']>;
  sourceTemplate: Scalars['String']['input'];
  termTemplate?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlAccountVerifyEmailInput {
  secret: Scalars['String']['input'];
}

export interface GqlSubscriptionRoot {
  /** Session update events (published on finalize with final message + derived status) */
  aiChatSession: GqlChatSessionUpdateOutput;
  /** Stream thinking tokens and tool progress for a session */
  aiChatThinkingStream: GqlThinkingStreamOutput;
  /**
   * Subscribe to candidate updates for a specific history
   *
   * Returns real-time updates when new candidates are found or existing ones are updated.
   */
  aiSearchCandidates: GqlAiSearchCandidateUpdateOutput;
  /**
   * Subscribe to history-level updates (created, processing, completed, error)
   *
   * Returns real-time updates for all histories belonging to the caller's organization.
   * No input parameters — filters by organization_id from auth context.
   */
  aiSearchHistoryUpdates: GqlAiSearchHistoryOutput;
  /**
   * Subscribe to stage status updates for a specific history
   *
   * Returns real-time updates when a stage starts processing, completes, or fails.
   */
  aiSearchStageStatus: GqlAiSearchStageStatusOutput;
  /**
   * Live feed of per-auth-detail-page events for a single auth. Emits one
   * `AnalyticReady` / `BrandMatchReady` per upstream production event whose
   * scope matches the subscriber. On broadcaster lag, emits
   * `ResyncRequired` — client refetches the relevant auth-detail queries.
   *
   * Permission: org membership (`SubscriptionContext::from_ctx` enforces a
   * valid token + org claim). The auth-detail page itself is gated by the
   * existing query-side permissions (`brandMatchScore` / `auth(id)`); this
   * subscription does not re-check them per event.
   */
  authDetailEvents: GqlAuthDetailEventOutput;
  authGroupImportUpdates: GqlAuthGroupImportUpdateOutput;
  authIndexUpdates: GqlAuthIndexUpdateOutput;
  /**
   * Live note + item events for a single auth (per-auth scope; see
   * ADR-004). Emits `ResyncRequired` on lag — client refetches the
   * `auth_note` / `auth_note_items` queries.
   */
  authNoteEvents: GqlAuthNoteEventOutput;
  /**
   * Task status changes filtered by (type, entity). Org from auth context —
   * clients cannot choose org. `Lagged(n)` events from slow subscribers are
   * skipped (state always recoverable via `backgroundTask` query).
   */
  backgroundTaskProgress: GqlBackgroundTaskOutput;
  /**
   * Org-wide live feed for the tray panel (#263). Forwards every
   * transition for the current org regardless of type/entity. Type +
   * entity filtering is the client's job (the per-entity sub above
   * stays available for callers that need server-side filtering).
   * Same `Lagged(n)` handling as `background_task_progress` — drops
   * are non-fatal because state is always recoverable via
   * `backgroundTasksTray`.
   */
  backgroundTaskUpdated: GqlBackgroundTaskOutput;
  brandContextUpdated: GqlBrandContextObject;
  /**
   * Live Kanban events for a single campaign (per-campaign scope).
   * Emits `ResyncRequired` on broadcaster lag — client refetches the
   * `auth_task_list` query.
   *
   * Permission: `CampaignManage` (matches `update_campaign_auth_task_status`).
   */
  campaignAuthTaskEvents: GqlCampaignAuthTaskEventOutput;
  /**
   * Live link-health feed for a single campaign. Emits `Changed` on every
   * real status transition (per-link) and `RecheckQueued` whenever a force
   * re-check is accepted. On broadcaster lag, emits `ResyncRequired` —
   * client refetches `campaign(id).linkHealthSummary` (and per-link
   * `latestCheck` on visible rows).
   *
   * Permission: `CampaignManage` (matches the brand-side link-health
   * query gates).
   */
  campaignLinkHealthEvents: GqlCampaignLinkHealthEventOutput;
  /**
   * Live updates for the org's campaign list. The principal's
   * `organizationId` is taken from JWT claims — no argument needed
   * (matches the `brandContextUpdated` post-Phase-0 contract).
   *
   * Permission: org membership (same gate as the `campaignList` query).
   */
  campaignListEvents: GqlCampaignListEventOutput;
  /**
   * Live creator-portal events for task invites + status changes across
   * every campaign the creator organization participates in. No argument —
   * org-scoped to the authenticated creator org.
   *
   * Emits `ResyncRequired` on broadcaster lag — the client refetches
   * `organizationCampaignAuthTaskList` (the org-wide creator list) and
   * filters `seq > serverSeq`.
   *
   * Permission: membership in a `Creator`-type organization. The per-event
   * filter enforces creator-task ownership so a creator never sees another
   * creator's task events from the same campaign.
   */
  creatorTasksEvents: GqlCampaignAuthTaskEventOutput;
  deepLookupProgress: GqlDeepLookupProgressOutput;
  onNotification: GqlNotificationOutput;
  /**
   * Live updates for the org's member roster. The principal's
   * `organizationId` is taken from JWT claims — no argument needed
   * (matches the post-Phase-0 `brandContextUpdated` contract).
   *
   * Permission: org membership (the Team view is visible to every
   * member; per-event permission checks are enforced on the
   * underlying mutations, not the subscription).
   */
  organizationMembershipEvents: GqlOrganizationMembershipEventOutput;
  /**
   * Live activity feed for a single task. Emits one `Changed` per
   * task-scoped `CampaignFact` write. On broadcaster lag, emits
   * `ResyncRequired` — client refetches `campaignActivityTimeline`
   * (and filters items by `taskId` client-side).
   *
   * Permission: `CampaignManage` (matches the brand-side
   * `campaignActivityTimeline` read).
   */
  taskActivityEvents: GqlTaskActivityEventOutput;
}

export interface GqlSubscriptionRootAiChatSessionArgs {
  sessionId: Scalars['String']['input'];
}

export interface GqlSubscriptionRootAiChatThinkingStreamArgs {
  sessionId: Scalars['String']['input'];
}

export interface GqlSubscriptionRootAiSearchCandidatesArgs {
  historyId: Scalars['String']['input'];
  stageId?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlSubscriptionRootAiSearchStageStatusArgs {
  historyId: Scalars['String']['input'];
}

export interface GqlSubscriptionRootAuthDetailEventsArgs {
  authId: Scalars['String']['input'];
}

export interface GqlSubscriptionRootAuthGroupImportUpdatesArgs {
  importId?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlSubscriptionRootAuthIndexUpdatesArgs {
  authId?: InputMaybe<Scalars['String']['input']>;
}

export interface GqlSubscriptionRootAuthNoteEventsArgs {
  authId: Scalars['String']['input'];
}

export interface GqlSubscriptionRootBackgroundTaskProgressArgs {
  targetEntityId: Scalars['String']['input'];
  taskType: GqlBackgroundTaskTypeEnum;
}

export interface GqlSubscriptionRootCampaignAuthTaskEventsArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlSubscriptionRootCampaignLinkHealthEventsArgs {
  campaignId: Scalars['String']['input'];
}

export interface GqlSubscriptionRootDeepLookupProgressArgs {
  authId: Scalars['String']['input'];
}

export interface GqlSubscriptionRootTaskActivityEventsArgs {
  taskId: Scalars['String']['input'];
}

export interface GqlChatSessionUpdateOutput {
  messages: Array<GqlChatMessageOutput>;
  status: GqlGqlChatSessionStatus;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
}

export interface GqlAiSearchCandidateUpdateOutput {
  action: Scalars['String']['output'];
  candidate: GqlAiSearchCandidateUpdatePayload;
  historyId: Scalars['String']['output'];
  stageId: Scalars['String']['output'];
}

export interface GqlAiSearchCandidateUpdatePayload {
  _id: Scalars['String']['output'];
  /** Full auth object (None if auth not yet indexed, e.g., new Google candidates) */
  auth?: Maybe<GqlAuth>;
  authInnerId: Scalars['String']['output'];
  factReasons: Array<Scalars['String']['output']>;
  llmReasons: Array<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  username: Scalars['String']['output'];
}

export interface GqlAiSearchStageStatusOutput {
  historyId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  stageId: Scalars['String']['output'];
  stats?: Maybe<GqlStageProgressOutput>;
  status: GqlStageStatusOutput;
}

export interface GqlStageProgressOutput {
  accepted: Scalars['Int']['output'];
  dbVectorProcessed: Scalars['Int']['output'];
  durationMs: Scalars['Int']['output'];
  googleProcessed: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  rerankProcessed: Scalars['Int']['output'];
  twitterProcessed: Scalars['Int']['output'];
}

export type GqlAuthDetailEventOutput =
  | GqlAuthDetailAnalyticReady
  | GqlAuthDetailBrandMatchReady
  | GqlAuthDetailDeepSummaryUpdated
  | GqlAuthDetailPostAudioAnalysisReady
  | GqlAuthDetailPostListChanged
  | GqlAuthDetailPostVisualAnalysisReady
  | GqlResyncRequired;

export interface GqlAuthDetailAnalyticReady {
  /** The auth id (subscription scope). */
  entityId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlAuthDetailBrandMatchReady {
  /** The auth id (subscription scope). */
  entityId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlAuthDetailDeepSummaryUpdated {
  /** The auth id (subscription scope). */
  entityId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlAuthDetailPostAudioAnalysisReady {
  /** The auth id (subscription scope). */
  entityId: Scalars['String']['output'];
  /**
   * Platform-side post identifier (matches `Post.innerId` in the
   * rendered feed).
   */
  postId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlAuthDetailPostListChanged {
  /** The auth id (subscription scope). */
  entityId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlAuthDetailPostVisualAnalysisReady {
  /** The auth id (subscription scope). */
  entityId: Scalars['String']['output'];
  /**
   * Platform-side post identifier (matches `Post.innerId` in the
   * rendered feed). FE patches the badge for the matching post.
   */
  postId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

/**
 * Shared resync sentinel emitted when a subscriber falls behind the broadcast
 * buffer. Client refetches authoritative state via the corresponding query.
 * See ADR-002.
 */
export interface GqlResyncRequired {
  /**
   * Number of events dropped for this subscriber since the last delivery.
   * Counter only — the client refetches everything; no cursor semantics.
   */
  missed: Scalars['Int']['output'];
}

export interface GqlAuthGroupImportUpdateOutput {
  _id: Scalars['String']['output'];
  failedItems: Scalars['Int']['output'];
  processedItems: Scalars['Int']['output'];
  status: Scalars['String']['output'];
}

export interface GqlAuthIndexUpdateOutput {
  _id: Scalars['String']['output'];
  auth?: Maybe<GqlAuth>;
  correlationId?: Maybe<Scalars['String']['output']>;
  isLowInfo: Scalars['Boolean']['output'];
  keywords: Array<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
}

export type GqlAuthNoteEventOutput =
  | GqlAuthNoteEventNoteCreated
  | GqlAuthNoteEventNoteDeleted
  | GqlAuthNoteEventNoteEdited
  | GqlAuthNoteEventNoteItemCreated
  | GqlAuthNoteEventNoteItemDeleted
  | GqlAuthNoteEventNoteItemEdited
  | GqlAuthNoteEventNoteItemPinChanged
  | GqlResyncRequired;

export interface GqlAuthNoteEventNoteCreated {
  entityId: Scalars['String']['output'];
  noteId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlAuthNoteEventNoteDeleted {
  entityId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlAuthNoteEventNoteEdited {
  entityId: Scalars['String']['output'];
  noteId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlAuthNoteEventNoteItemCreated {
  entityId: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlAuthNoteEventNoteItemDeleted {
  entityId: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlAuthNoteEventNoteItemEdited {
  entityId: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlAuthNoteEventNoteItemPinChanged {
  entityId: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  pinned: Scalars['Boolean']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export type GqlCampaignAuthTaskEventOutput =
  | GqlCampaignTaskEventBatchApplied
  | GqlCampaignTaskEventLinkAdded
  | GqlCampaignTaskEventLinkRemoved
  | GqlCampaignTaskEventStatusChanged
  | GqlResyncRequired;

export interface GqlCampaignTaskEventBatchApplied {
  /** Number of new tasks (or links) created in the batch. */
  created: Scalars['Int']['output'];
  entityId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  /** Number of items skipped due to duplicate-key races / pre-existing rows. */
  skipped: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlCampaignTaskEventLinkAdded {
  entityId: Scalars['String']['output'];
  linkId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  taskId: Scalars['String']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlCampaignTaskEventLinkRemoved {
  entityId: Scalars['String']['output'];
  linkId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  taskId: Scalars['String']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlCampaignTaskEventStatusChanged {
  authId: Scalars['String']['output'];
  /** The campaign id (subscription scope). */
  entityId: Scalars['String']['output'];
  /**
   * Absent when the task is being newly created — FE places the card in
   * the column matching `to` without removing one elsewhere.
   */
  from?: Maybe<GqlCampaignAuthTaskStatusEnum>;
  seq: Scalars['Int']['output'];
  taskId: Scalars['String']['output'];
  to: GqlCampaignAuthTaskStatusEnum;
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export type GqlCampaignLinkHealthEventOutput =
  | GqlCampaignLinkHealthChanged
  | GqlCampaignLinkHealthRecheckQueued
  | GqlResyncRequired;

export interface GqlCampaignLinkHealthChanged {
  /** The campaign id (subscription scope). */
  entityId: Scalars['String']['output'];
  /** The link whose `overall_status` just transitioned. */
  linkId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  /** New status. FE patches the per-link badge directly without a refetch. */
  status: GqlLinkOverallStatusOutput;
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export interface GqlCampaignLinkHealthRecheckQueued {
  /** The campaign id (subscription scope). */
  entityId: Scalars['String']['output'];
  /** The link whose force re-check was just queued. */
  linkId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export type GqlCampaignListEventOutput =
  | GqlCampaignListChanged
  | GqlResyncRequired;

export interface GqlCampaignListChanged {
  /**
   * UI hint — kind of change. FE refetches the `campaignList` query in
   * all cases; this lets the FE highlight a row, show a toast, etc.
   * without waiting for the refetch to land.
   */
  change: GqlCampaignListChangeKind;
  /** The campaign id whose state changed. */
  entityId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export const GqlCampaignListChangeKind = {
  Created: 'CREATED',
  CreatorListChanged: 'CREATOR_LIST_CHANGED',
  StatusChanged: 'STATUS_CHANGED',
  Updated: 'UPDATED',
} as const;

export type GqlCampaignListChangeKind =
  (typeof GqlCampaignListChangeKind)[keyof typeof GqlCampaignListChangeKind];
export interface GqlDeepLookupProgressOutput {
  _id: Scalars['String']['output'];
  authId: Scalars['String']['output'];
  crossLinksCreated: Scalars['Int']['output'];
  discoveredLinksCount: Scalars['Int']['output'];
  discoveredProfilesCount: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  postsFetched: Scalars['Int']['output'];
  scrapedPagesCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  statusMessage?: Maybe<Scalars['String']['output']>;
  webSearchResultsCount: Scalars['Int']['output'];
}

export type GqlOrganizationMembershipEventOutput =
  | GqlOrganizationMembershipChanged
  | GqlResyncRequired;

export interface GqlOrganizationMembershipChanged {
  /**
   * UI hint — kind of change. FE refetches the `Organization.members`
   * list in all cases; this lets the FE highlight the affected row /
   * show a toast without waiting for the refetch to land.
   */
  change: GqlOrganizationMembershipChangeKind;
  /** The `OrganizationMember` id whose state changed. */
  entityId: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}

export const GqlOrganizationMembershipChangeKind = {
  InvitationCancelled: 'INVITATION_CANCELLED',
  MemberInvited: 'MEMBER_INVITED',
  MemberJoined: 'MEMBER_JOINED',
  MemberRemoved: 'MEMBER_REMOVED',
  MemberRoleChanged: 'MEMBER_ROLE_CHANGED',
} as const;

export type GqlOrganizationMembershipChangeKind =
  (typeof GqlOrganizationMembershipChangeKind)[keyof typeof GqlOrganizationMembershipChangeKind];
export type GqlTaskActivityEventOutput =
  | GqlResyncRequired
  | GqlTaskActivityEvent;

export interface GqlTaskActivityEvent {
  /** The task id (subscription scope). */
  entityId: Scalars['String']['output'];
  /**
   * UI hint — the kind of fact that fired. FE refetches the
   * `campaignActivityTimeline` query in all cases (ADR-009); this field
   * lets the FE display a toast / highlight without waiting for the
   * refetch to land.
   */
  factType: GqlCampaignActivityType;
  seq: Scalars['Int']['output'];
  ts: Scalars['String']['output'];
  version: Scalars['Int']['output'];
}
